import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';

@Component({
  selector: 'app-archive50',
  templateUrl: './archive50.component.html',
  styleUrls: [ './archive50.component.scss' ]
})
export class Archive50Component implements OnInit {

  public activities: any[] = []
  public selectedAtivities: any[] = []

  public topics: any[] = []
  public speakers: any[] = []

  public agenda: any[] = []
  public location: any = {}
  public rooms: any[] = [];
  public deptos: any[] = [];

  public errors: any[] = []

  public selectedDepto: any;
  public selectedRoom: any;
  public selectedDay: any;
  public selectedSpeaker: any;

  public selectDays: any[] = [];

  public criteria: string = '';
  public isSpeaker: boolean = false;
  public isDepto: boolean = false;

  public loading: boolean = false;

  public member_text: string;
  public member_image: string;

  public depto_text: string;


  constructor (
    private _httpClient: HttpClient,
    public _sanitizer: DomSanitizer
  ) { }

  ngOnInit () {
    this.getCongressSchedule();
  }

  getCongressSchedule () {

    this.selectDays.push({'id': 'g6j94rLVilsQLmAraQPu', 'name': '14/06/2024'})
    this.selectDays.push({'id': 'qe9JZRx1JUE7cjWsfWz7', 'name': '15/06/2024'})
    const event_id = 'qZzZKG5PbyJeStdMmOT2'
    const location_id = "3GsmApRYbpeYrCGYoMwR"
    this.criteria = '14 e 15 de Junho de 2024';

    this.loading = true

    /*
    this.getCongressScheduleData(event_id, location_id)
      .subscribe((result) => {

       console.log(JSON.stringify(result))

        this.rooms = result.rooms;
        this.deptos = result.deptos;
        this.speakers = result.speakers;
        this.activities = result.activities;

        this.activities.sort(this.compareDayAndTime)
        
        this.activities.forEach((activity)=>{
            activity.topics.sort(this.compareTimes)
        });

        this.selectedAtivities = this.activities;
        this.loading = false;

       
      })
  */

    const result = this.getCongressScheduleData()

    this.rooms = result.rooms;
    this.deptos = result.deptos;
    this.speakers = result.speakers;
    this.activities = result.activities;

    this.activities.sort(this.compareDayAndTime)

    this.activities.forEach((activity) => {
      activity.topics.sort(this.compareTimes)
    });

    this.selectedAtivities = this.activities;
    this.loading = false;

  }

  selectDepartent (event) {
    this.selectedAtivities = [];

    this.selectedRoom = null;
    this.selectedDay = null;
    this.selectedSpeaker = null;

    this.isSpeaker = false;
    this.isDepto = true;

    this.selectedDepto = event
    let item = this.deptos.find(e => {
      return e.id === this.selectedDepto
    })

    console.log(JSON.stringify(item))

    this.criteria = item.short
    this.depto_text = item.text

    this.activities.forEach(activity => {
      if (activity.depto_id === this.selectedDepto) {
        this.addActivity(activity)
      }
    });
    this.selectedAtivities.sort(this.compareDayAndTime)

  }

  selectRoom (event) {
    this.selectedAtivities = [];

    this.selectedDepto = null;
    this.selectedDay = null;
    this.selectedSpeaker = null;

    this.isSpeaker = false;
    this.isDepto = false;

    this.selectedRoom = event
    let item = this.rooms.find(e => {
      return e.id === this.selectedRoom
    })
    this.criteria = item.name

    this.activities.forEach(activity => {
      if (activity.location_id === this.selectedRoom) {
        this.addActivity(activity)
      }
    });

    this.activities.sort(this.compareDayAndTime)

  }

  selectDay (event) {
    this.selectedAtivities = [];

    this.selectedDepto = null;
    this.selectedRoom = null;
    this.selectedSpeaker = null;

    this.isSpeaker = false;
    this.isDepto = false;

    this.selectedDay = event
    let item = this.selectDays.find(e => {
      return e.id === this.selectedDay
    })
    this.criteria = item.name

    this.activities.forEach(activity => {
      if (activity.day_id === this.selectedDay) {
        this.addActivity(activity)
      }
    });

    this.selectedAtivities.sort(this.compareDayAndTime)

  }

  selectSpeaker (event) {
    this.member_image = null;

    this.selectedAtivities = [];

    this.selectedDepto = null;
    this.selectedRoom = null;
    this.selectedDay = null;

    this.isSpeaker = true;
    this.isDepto = false;

    this.selectedSpeaker = event.trim()

    let item = this.speakers.find(e => {
      return e.id === this.selectedSpeaker
    })

    this.member_text = item.text;
    this.member_image = item.image;
    this.criteria = item.name

    this.activities.forEach(activity => {
      activity.agenda.forEach((ag => {
        if (ag.member_id == this.selectedSpeaker) {
          this.addActivity(activity)
        }
      }))

      activity.topics.forEach((topic) => {
        topic.agenda.forEach((agt) => {
          if (agt.member_id == this.selectedSpeaker) {
            this.addActivity(activity)
          }
        })

      })

    });

    this.selectedAtivities.sort(this.compareDayAndTime)

  }

  addActivity (activity) {

    const exist = this.selectedAtivities.find((e) => {
      return e.id === activity.id
    })
    if (!exist) {
      this.selectedAtivities.push(activity)
    }
  }

  compareNames (a, b) {
    if (a.name > b.name) return 1;
    if (b.name > a.name) return -1;
    return 0;
  }

  compareDayAndTime (a: any, b: any) {

    //console.log(new Date(a.date._seconds*1000))
    const da = new Date(a.date._seconds * 1000)
    const db = new Date(b.date._seconds * 1000)

    const _a = Number(da.getDate() + a.startTime.replace(':', ''))
    const _b = Number(db.getDate() + b.startTime.replace(':', ''))

    if (_a > _b) return 1;
    if (_b > _a) return -1;
    return 0;
  }

  compareTimes (a, b) {
    let _a = a.startTime
    let _b = b.startTime
    if (_a > _b) return 1;
    if (_b > _a) return -1;
    return 0;
  }

  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////

  getCongressScheduleData () {
    return {
      "rooms": [
        {"name": "Auditório 2", "id": "1709662124777"},
        {"name": "Auditório 3", "id": "1709662130844"},
        {"name": "Auditório 4", "id": "1709662136986"},
        {"name": "Auditório 5", "id": "1709662142789"},
        {"name": "Auditório Principal", "id": "1709662092049"},
        {"name": "Sala 1 Simulador", "id": "1718204004696"},
        {"name": "Sala 2 Simulador", "id": "1718204014027"},
        {"name": "Área de Exposição", "id": "1709663252454"}
      ],
      "deptos": [
        {
          "id": "OLg0OAKHpv8TocDsXPsm",
          "name": "DBLACCV",
          "short": "13º CONGRESSO ACADÊMICO DE CIRURGIA CARDIOVASCULAR",
          "text": "<p>Departamento Brasileiro de Ligas Acadêmicas de Cirurgia Cardiovascular</p>"
        },
        {
          "id": "Gil3DxNzgfuINqXCVB7H",
          "name": "Associação Brasileira dos Residentes de Cirurgia Cardiovascular",
          "short": "ABRECCV",
          "text": "<ul><li>Associação Brasileira dos Residentes de Cirurgia Cardiovascular</li></ul>"
        },
        {
          "id": "NGf0C01VnQJgqQWSeYD1",
          "name": "ACADEMIA",
          "short": "ACADEMIA",
          "text": ""
        },
        {
          "id": "g7Sxz9Hmi7kgiqeCQZv6",
          "name": "ASSISTÊNCIA CIRCULATÓRIA VENTRICULAR E TRANSPLANTE CARDÍACO",
          "short": "ASSISTÊNCIA CIRCULATÓRIA VENTRICULAR E TRANSPLANTE CARDÍACO",
          "text": ""
        },
        {
          "id": "rchtbpLb6r1NLU9VKxwQ",
          "name": "BRAZILIAN JOURNAL OF CARDIOVASCULAR SURGERY ",
          "short": "BJCVS",
          "text": ""
        },
        {
          "id": "SP6o4MrkyrAgxdjm4TRf",
          "name": "CURSO DE TAVI",
          "short": "CURSO DE TAVI",
          "text": ""
        },
        {
          "id": "O8ZV7WXNuFyM5XybxTef",
          "name": "Departamento de Cirurgia Cardiovascular Pediátrica",
          "short": "DCCVPED",
          "text": "<p>Departamento de Cirurgia Cardiovascular Pediátrica</p>"
        },
        {
          "id": "yzJuE4VuCn9Mprf4cSqN",
          "name": "SESSÃO DEFEITOS ESTRUTURAIS",
          "short": "DEFEITOS ESTRUTURAIS",
          "text": ""
        },
        {
          "id": "ouzy3wlqiQvhvRBZ2K66",
          "name": "DISPOSITIVOS ELETRÔNICOS IMPLANTÁVEIS",
          "short": "DISPOSITIVOS ELETRÔNICOS IMPLANTÁVEIS",
          "text": ""
        },
        {
          "id": "v4jnCbd1oiYUZ7BVhOyD",
          "name": "EDUCAÇÃO MÉDICA CONTINUADA",
          "short": "EDUCAÇÃO MÉDICA CONTINUADA",
          "text": ""
        },
        {
          "id": "VTbA7orqer53sB1oBc29",
          "name": "SESSÃO JUDICIALIZAÇÃO NA SAÚDE",
          "short": "JUDICIALIZAÇÃO NA SAÚDE",
          "text": ""
        },
        {
          "id": "YwJfFvus3CFIpXHBVl1q",
          "name": "Johnson & Johnson Institute",
          "short": "Johnson & Johnson Institute",
          "text": ""
        },
        {
          "id": "sfO6vtpUaOhybohGxPPs",
          "name": "SESSÃO MICS E ROBÓTICA",
          "short": "MICS E ROBÓTICA",
          "text": ""
        },
        {
          "id": "bFWmir6aazVI0ewnHovj",
          "name": "SESSÃO OS PIORES CENÁRIOS EM CIRURGIA CARDIOVASCULAR",
          "short": "OS PIORES CENÁRIOS EM CIRURGIA CARDIOVASCULAR",
          "text": ""
        },
        {
          "id": "0opU2hMyvevrpIXDzjeD",
          "name": "Sociedade Brasileira de Cirurgia Cardiovascular",
          "short": "SBCCV",
          "text": "<p>Sociedade Brasileira de Cirurgia Cardiovascular</p>"
        },
        {
          "id": "DeTA2zHryJbnpiqE6H3Q",
          "name": "SEGURANÇA NA CIRURGIA CARDIOVASCULAR",
          "short": "SEGURANÇA NA CIRURGIA CARDIOVASCULAR",
          "text": ""
        },
        {
          "id": "u3kInDhnpMCXaHhssQHg",
          "name": "VÁLVULA",
          "short": "SESSÃO  VÁLVULA",
          "text": ""
        },
        {
          "id": "KD3Y2mWBG4jFpaus6CWT",
          "name": "AORTA",
          "short": "SESSÃO AORTA",
          "text": ""
        },
        {
          "id": "d41jSqncZoXyi7XvGpAq",
          "name": "COMO EU FAÇO",
          "short": "SESSÃO COMO EU FAÇO",
          "text": ""
        },
        {
          "id": "Esl6uAn1TMfIJxjRTmzm",
          "name": "CORONÁRIA",
          "short": "SESSÃO CORONÁRIA",
          "text": ""
        },
        {
          "id": "FL6nxVyGZig87kzytMdV",
          "name": "PÔSTERES",
          "short": "SESSÃO DE PÔSTERES",
          "text": ""
        },
        {
          "id": "4k2qiQ1Ve7QrN4R418K4",
          "name": "SESSÃO ESPECIAL SBC",
          "short": "SESSÃO ESPECIAL SBC",
          "text": ""
        },
        {
          "id": "a6SJZuj9UJUQUJf9CtjP",
          "name": "SESSÕES COMERCIAIS",
          "short": "SESSÕES COMERCIAIS",
          "text": ""
        },
        {
          "id": "wBpYBXkDmoai8eadspL0",
          "name": "SESSÃO TEMAS LIVRES",
          "short": "TEMAS LIVRES",
          "text": ""
        }
      ],
      "speakers": [
        {
          "id": "WVt1qCq8yrtvGokCuDGa",
          "name": "Achilles Abelaira Filho ",
          "text": "<p><i>Graduação em Medicina pela Faculdade de Medicina de Catanduva. Residência em Cirurgia Geral e Cardiovascular pela Faculdade de Medicina de São José do Rio Preto (Famerp). Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Atualmente é cirurgião cardíaco assistente do Hospital Beneficência Portuguesa (São José do Rio Preto, SP), Faculdade de Medicina de Catanduva, Hospital São Domingos-Unimed (Catanduva, SP) e Hospital Fernando Carlos Malzone (Matão, SP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FWVt1qCq8yrtvGokCuDGa.png?alt=media&token=cba50065-bc18-4f07-9e37-2b5f47950890"
        },
        {
          "id": "m7hFAW6dwk2YCb4qDre1",
          "name": "Acrísio Sales Valente",
          "text": "<p><i>Doutor em Cirurgia Torácica e Cardiovascular pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Professor de Medicina do Centro Universitário Unichristus. Diretor de Comunicação da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Cirurgião Cardiovascular do Hospital do Coração de Messejana e Hospital Universitário da Universidade Federal do Ceará (UFC).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fm7hFAW6dwk2YCb4qDre1.png?alt=media&token=c9baa129-724f-4530-8dbe-2014e6863082"
        },
        {
          "id": "zYDLh4xGxhL3IgftowDq",
          "name": "Aldrei Costa Araújo",
          "text": "<p><i>Acadêmico de Medicina. Pesquisador nos seguintes projetos: A sobrevida em longo prazo de pacientes submetidos à cirurgia primária aberta da aorta ascendente: meta-análise; Aspectos nutricionais em pacientes frágeis submetidos a cirurgia de revascularização do miocárdio; Análise do efeito da reoperação e dos procedimentos associados nas operações da aorta ascendente na sobrevida dos pacientes. Participou da idealização e produção do Manual de Alunos ProUni Medicina Unicid.&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FzYDLh4xGxhL3IgftowDq.png?alt=media&token=b2f95cc9-ddfc-4515-bb43-e8d445d152f7"
        },
        {
          "id": "vsJksbsfilmzwNOWqFeq",
          "name": "Alef de Carvalho Vieira",
          "text": "<p><i>Médico graduado pela Escola Bahiana de Medicina e Saúde Pública. Residente do quinto ano de Cirurgia Cardiovascular no Instituto Dante Pazzanese de Cardiologia. Mestre em Ciências pelo programa USP-IDPC.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FvsJksbsfilmzwNOWqFeq.png?alt=media&token=16205110-ca05-4d2f-940a-501c59a7a284"
        },
        {
          "id": "zPBATAIElUvAmJMONryH",
          "name": "Aleksander Dobrianskyj ",
          "text": "<p><i>Graduação pela Faculdade de Medicina da Universidade Federal do Paraná (UFPR). Residência Médica no Instituto Dante Pazzanese de Cardiologia. Especialista em Cirurgia Cardiovascular pela Sociedade Brasileira de Cirurgia Cardiovascular/Associação Médica Brasileira (SBCCV/AMB). Cirurgião cardiovascular concursado no Hospital das Clínicas da Universidade Federal de Goiás (UFG). Mestre em Medicina Interna pela Universidade Federal de Minas Gerais (UFMG)/convênio UFG.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FzPBATAIElUvAmJMONryH.png?alt=media&token=bb0e2ecc-8b2e-476c-a775-9ce60a2e19c2"
        },
        {
          "id": "ekCcVwDIzIrMotDU7WJn",
          "name": "Alexander John Pessoa Grant Anderson",
          "text": "<p><i>Formado pelo Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Ex-Presidente da Sociedade de Cirurgia Cardiovascular do Estado de São Paulo. Membro do Conselho Deliberativo da Sociedade de Cirurgia Cardiovascular do Estado de São Paulo. Responsável pelo Serviço de Cirurgia Cardiovascular do Hospital Unimed Limeira.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FekCcVwDIzIrMotDU7WJn.png?alt=media&token=ba391b22-e8a7-4160-96df-191cea7ede4a"
        },
        {
          "id": "aNlwkmlC0g7HCk8XgXAS",
          "name": "Alexandre Magno Macario Nunes Soares ",
          "text": "<p><i>Cirurgião cardiovascular no Pronto-Socorro Cardiológico de Pernambuco (Procape) da Universidade de Pernambuco (UPE). Coordenador do Departamento de Doenças da Aorta. Professor convidado na disciplina de Cirurgia Cardiotorácica. Cirurgião certificado pela Sociedade Brasileira de Cirurgia Cardiovascular/Sociedade Brasileira de Hemodinâmica e Cardiologia Intervencionista (SBCCV/SBHCI) em TAVI. Especialização em Cirurgia Endovascular pela Universidade Federal de Minas Gerais (UFMG).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FaNlwkmlC0g7HCk8XgXAS.png?alt=media&token=c0dfb590-ddbe-4bb6-8842-d53992b229f8"
        },
        {
          "id": "oQW5u6iNISWZNqIScPem",
          "name": "Alexandre Visconti Brick ",
          "text": "<p><i>Graduação pela Faculdade de Medicina da Universidade Federal de Juiz de Fora (UFJF). Residência Médica em Cardiologia e Cirurgia Cardiovascular no Hospital dos Servidores do Estado do Rio de Janeiro, com o Professor Cid Nogueira. Residência Médica com o Prof. E. J. Zerbini em São Paulo. Mestrado em Medicina, área de concentração em Cardiologia e Cirurgia Cardiovascular (orientador: Prof. Dr. Otoni Moreira Gomes). Doutorado em Ciências da Saúde (orientador: Prof. Domingo Marcolino Braile), na Faculdade de Medicina de São José do Rio Preto (Famerp). Professor da Faculdade de Medicina da Universidade de Brasília (UnB), aposentado, onde por três mandatos foi chefe do Departamento de Clínica Cirúrgica. Professor da Universidade Católica de Brasília. Chefe do Serviço de Cirurgia Cardiovascular do Hospital de Base (DF). Membro do Conselho Editorial do Brazilian Journal of Cardiovascular Surgery desde 2004. Presidente da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV) de 2004 a 2006. Membro da Sociedade Brasileira de Cardiologia (SBC) desde 1989. Membro titular da SBCCV. Membro da Sociedade Brasileira de Circulação Extracorpórea (SBCEC). Diretor do Hospital Regional de Taguatinga, Hospital Regional de Santa Maria e Hospital da Universidade Católica de Brasília. Diretor da Fundação de Empreendimentos Científicos e Tecnológicos da UnB (Finatec).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FoQW5u6iNISWZNqIScPem.png?alt=media&token=843a3136-4f77-4306-8b21-de7b068e38e3"
        },
        {
          "id": "f4THTPHP9RrOyp1amLgu",
          "name": "Alexsandro Fagundes",
          "text": "<p><i>Presidente da Sociedade Brasileira de Arritmias Cardíacas (Sobrac) biênio 2024-2025. Professor do curso de Medicina da Universidade do Estado da Bahia (Uneb). Especialista em Estimulação Cardíaca Artificial.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Ff4THTPHP9RrOyp1amLgu.png?alt=media&token=2e09367c-44aa-44e5-b872-97659b091151"
        },
        {
          "id": "0C730CSckDjjq8PIEFPk",
          "name": "Alisson Parrilha Toschi ",
          "text": "<p><i>Cirurgião cardiovascular em Joinville, Santa Catarina.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F0C730CSckDjjq8PIEFPk.png?alt=media&token=5aaf4949-7ea8-4556-a2d9-225b681fdfa4"
        },
        {
          "id": "1uk9yntz7n0s3s26AoOH",
          "name": "Alvaro Monteiro Perazzo ",
          "text": "<p><i>Residente Fellow em Transplante Cardíaco e Assistência Circulatória mecânica no Instituto do coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo, residência médica em Cirurgia Cardiovascular pelo Procape, Universidade de Pernambuco em 2024, é mestre em Cirurgia pelo Departamento de Cirurgia do Centro de Ciências Médicas da Universidade Federal de Pernambuco (2023) e atualmente é doutorando na Escola de Doenças Cardiovasculares (Cardiovascular Research Institute Maastricht) da Universidade de Maastricht, Holanda (2023)</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F1uk9yntz7n0s3s26AoOH.png?alt=media&token=378a7ac4-fd29-42fb-a925-0ebfb3bf0ded"
        },
        {
          "id": "50uvA0cJpDqqceyzWusk",
          "name": "Alvaro Rösler ",
          "text": "<p><i>Pesquisador cardiovascular, especialista em Estatística pela University of Michigan e em Ciência de Dados e Inteligência Artificial pela Universidade de São Paulo (USP). Mestre em Ciências da Reabilitação pela Universidade Federal de Ciências da Saúde de Porto Alegre (UFCSPA) e coordenador do Centro de Pesquisas em Cirurgia Cardiovascular do Hospital São Francisco da Santa Casa de Porto Alegre.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F50uvA0cJpDqqceyzWusk.png?alt=media&token=a40344c4-9eea-4a4e-92a3-b854fc4052a7"
        },
        {
          "id": "MylcOYoQFfJTDotsLSCv",
          "name": "Amanda Arrais Bento de Souza",
          "text": "<p><i>Acadêmica do sexto ano de Medicina na Universidade Santo Amaro (Unisa). Colaboradora Junior do Brazilian Journal of Cardiovascular Surgery em 2020. Vice-presidente, presidente e fundadora da Liga Acadêmica de Cirurgia Cardiovascular (LACCV) da Unisa (2020-2022). Diretora de Extensão do Departamento Brasileiro de Ligas Acadêmicas de Cirurgia Cardiovascular (DBLACCV, 2022-2023). Vice-presidente do DBLACCV (2023-2024). Certificada em Wilderness First Aid, Mountain Medicine e Yoga e Anatomia (Santa Casa de Misericórdia de São Paulo).&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FMylcOYoQFfJTDotsLSCv.png?alt=media&token=20f1b2d0-48b9-48bf-b25a-0b12e7e2901b"
        },
        {
          "id": "eLHjvjnNT7rXm3fCSSUa",
          "name": "Ana Maria Rocha Pinto e Silva ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Professora adjunta da Faculdade de Ciências Médicas da Santa Casa de Misericórdia de São Paulo.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FeLHjvjnNT7rXm3fCSSUa.png?alt=media&token=68057047-4d01-40dd-abd7-68906faaa1bc"
        },
        {
          "id": "momWB9r97qBCF7ipcNZ0",
          "name": "Anderson da Silva Terrazas ",
          "text": "<p><i>Médico formado pela Universidade do Estado do Amazonas (UEA). Especialista em Cirurgia Cardiovascular pela Sociedade Brasileira de Cirurgia Cardiovascular/Associação Médica Brasileira (SBCCV/AMB). Área de atuação em Dispositivos Cardíacos Eletrônicos Implantáveis (DCEI) pela SBCCV/AMB, pós-graduação em Angiorradiologia e Cirurgia Cardiovascular pela Santa Casa de Misericórdia de São Paulo. Presidente do Departamento de Cirurgia Endovascular (Decem/SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FmomWB9r97qBCF7ipcNZ0.png?alt=media&token=8c958a41-bf1f-47f3-93a2-49b924a71359"
        },
        {
          "id": "e30jF97J4vzs1KoU8RrL",
          "name": "Andrea Cristina Oliveira Freitas ",
          "text": "<p style=\"text-align: center;\"><i>Cirurgiã chefe do Centro de Cirurgia Cardiovascular do Hospital Estadual Mário Covas (Santo André, São Paulo). </i></p><p style=\"text-align: center;\"><i>Membro Titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p><p style=\"text-align: center;\"><i>Membro da Society of Thoracic Surgeons (STS) e da European Association for Cardiothoracic Surgery (EACTS).</i></p><p style=\"text-align: center;\"><i>Membro da LACES Women in Cardiac Surgery (LACES - WICS).&nbsp;</i></p><p style=\"text-align: center;\"><i>Mestre em Ciências Médicas pela FMABC.</i><br></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FcBtbzzbboRetAV2Dtwt50CsUOLw2.jpg?alt=media&token=e0e1227e-fcd2-4517-a911-4e59a86ce88f"
        },
        {
          "id": "2RAcpVOvEjrF816lyq6K",
          "name": "Andrea Dumsch de Aragon Ferreira ",
          "text": "<p><i>Cirurgiã cardíaca da Santa Casa de Curitiba, do Hospital INC e do Hospital Angelina Caron. Membro especialista pela Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Mestre em Cirurgia pela Pontifícia Universidade Católica do Paraná (PUCPR). Fellow em Cirurgia Cardíaca na Universidade do Alabama.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F2RAcpVOvEjrF816lyq6K.png?alt=media&token=a0d31c2f-3604-4b30-a6dc-1e252127ee83"
        },
        {
          "id": "KjpMuLGHX3c1svkrsP74",
          "name": "Andrey José Oliveira Monteiro ",
          "text": "<p><i>Membro do Departamento de Cirurgia Cardíaca Pediátrica da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Cirurgião no Instituto Pro Criança Cardíaca e na Universidade Estadual do Rio de Janeiro (UERJ).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FKjpMuLGHX3c1svkrsP74.png?alt=media&token=0f7b413e-ae84-4deb-b3ad-a34357506810"
        },
        {
          "id": "5ahNmX5HyfHZqXjs0aP5",
          "name": "André Luppi Mota ",
          "text": "<p><i>Graduação em Medicina pela Faculdade de Medicina de Ribeirão Preto da Universidade de São Paulo (FMRP-USP). Cirurgião cardiovascular e mestre pela Universidade Federal de São Paulo (Unifesp). Doutor em Ciências pela USP. Título de especialista pela Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Pós-doutorado no Massachusetts General Hospital, Harvard School of Medicine.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F5ahNmX5HyfHZqXjs0aP5.png?alt=media&token=ac26f86c-6799-4f52-843e-9c0bdec0fc98"
        },
        {
          "id": "8xaAN7yNUDDOVNkWcgFG",
          "name": "André Raimundo Franca Guimarães ",
          "text": "<p><i>Secretário da Sociedade Norte-Nordeste de Cirurgia Cardiovascular (SNNCCV). Chefe da Cirurgia Cardiovascular e Supervisor da Residência em Cirurgia Cardiovascular na Santa Casa de Misericórdia de Feira de Santana (Bahia). Cirurgião cardiovascular na Fundação Bahiana de Cardiologia e no Hospital Tereza de Lisieux (Salvador, Bahia).&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F8xaAN7yNUDDOVNkWcgFG.png?alt=media&token=778ca714-622a-49c5-b970-5a915b670fde"
        },
        {
          "id": "fp8XIeJZ9Fd2dkVWJq0F",
          "name": "Andréia Cristina Feitosa do Carmo",
          "text": "<p><i>Graduação em Biblioteconomia pela Universidade Estadual Paulista Júlio de Mesquita Filho (Unesp). Especialização em Serviços de Informação Educativos – Programa Serviçosde Informação em Educação (Proesi) pela Universidade de São Paulo (USP). Especialização em Sistemas e Serviços de Informação pela Fundação Escola de Sociologia e Política de São Paulo. Aperfeiçoamento em Metodologia e Elaboração de Pesquisa e mestrado em Cirurgia Translacional pela Universidade Federal de São Paulo (Unifesp). Atualmente é bibliotecária da Unifesp. Tem experiência em pesquisa em saúde.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Ffp8XIeJZ9Fd2dkVWJq0F.png?alt=media&token=96235993-7c13-4e24-9d45-cd1cf05576a7"
        },
        {
          "id": "NsfYLwC5wmSrRbSVh17F",
          "name": "Antonio Carlos de Almeida Barbosa Filho",
          "text": "<p><i>Médico pelo Centro Universitário Cesmac. Foi monitor bolsista de Anatomia em 2018, de Semiologia Médica em 2019 e de Anatomia em 2020 do curso de Medicina do Centro Universitário Cesmac. Foi presidente fundador da Liga Acadêmica Morfofuncional do Cesmac (LAMC). Membro da Liga Acadêmica Cardiovascular (LACV) da Universidade Federal de Alagoas (Ufal) em 2021-2022. Fez estágio no Serviço de Cirurgia Cardiovascular do Instituto do Coração de Pernambuco do Real Hospital Português&nbsp;e realizou pesquisas na área de Cardiologia, sendo voluntário e bolsista no Programa Semente de Iniciação Científica (PSIC). Foi colaborador júnior do blog do Brazilian Journal of Cardiovascular Surgery (BJCVS). Ex-diretor científico do Departamento Brasileiro de Ligas Acadêmicas de Cirurgia Cardiovascular (DBLACCV) em 2021-2022.&nbsp;Revisor de papers do The Annals of Thoracic Surgery.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FNsfYLwC5wmSrRbSVh17F.png?alt=media&token=8c37fd60-2cf2-4505-86d9-bf595e78acb5"
        },
        {
          "id": "psfgBJto2mJevPxg6QEJ",
          "name": "Antonio de Jesus Chaves Junior",
          "text": "<p><i>Acadêmico do sexto ano de Medicina da Universidade Federal da Bahia (UFBA). Ex-presidente da Liga Acadêmica de Cirurgia Cardiovascular da Bahia (LACCV-BA), gestão 2020. Atual diretor científico do Departamento Brasileiro de Ligas Acadêmicas de Cirurgia Cardiovascular (DBLACCV) da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FpsfgBJto2mJevPxg6QEJ.png?alt=media&token=a4e66b48-d040-4732-9ec3-8433755ffb9a"
        },
        {
          "id": "EICPf5FiQ9fX4VXdH4Nb",
          "name": "Anísio Pedrosa",
          "text": "<p><i>Especialista em Estimulação Cardíaca Artificial pela Sociedade Brasileira de Arritmias Cardíacas/Departamento de Estimulação Cardíaca Artificial/Sociedade Brasileira de Cirurgia Cardiovascular/Sociedade Brasileira de Cardiologia (Sobrac/Deca/SBCCV/SBC). Médico assistente do grupo Clínico de Estimulação Cardíaca Artificial do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP).</i></p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FEICPf5FiQ9fX4VXdH4Nb.png?alt=media&token=d5b72ebb-2b0d-4586-886c-8a233dff51c4"
        },
        {
          "id": "l4rDJlQU0bo35wLxJrv0",
          "name": "Arnaldo Akio Okino ",
          "text": "<p><i>Graduação em Medicina pela Universidade Estadual de Londrina (UEL). Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Certificado pela atuação na área de Estimulação Cardíaca Eletrônica Implantável pela Associação Médica Brasileira/Sociedade Brasileira de Cardiologia/Sociedade Brasileira de Cirurgia Cardiovascular (AMB/SBC/SBCCV). Habilitado em terapia de implante por cateter de bioprótese valvar aórtica (TAVI) por acesso transfemoral pela Associação Médica Brasileira/Sociedade Brasileira de Cirurgia Cardiovascular/Sociedade Brasileira de Hemodinâmica e Cardiologia Intervencionista (AMB/SBCCV/SBHCI). Responsável técnico pelo transplante cardíaco na Santa Casa de Misericórdia de Londrina. Coordenador do Serviço de Residência em Cirurgia Cardiovascular na Santa Casa de Londrina/MEC.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2Fl4rDJlQU0bo35wLxJrv0.png?alt=media&token=d78dedb3-b913-41b5-b43a-f3c50d979ae9"
        },
        {
          "id": "NmiyO9n4FwyMQpFqcuZB",
          "name": "Attila Santos Berriel",
          "text": "<p><i>Médico formado pela Santa Casa de Misericórdia de Vitória (ES). Residente do terceiro ano de Cirurgia Cardiovascular no Instituto Dante Pazzanese de Cardiologia.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FNmiyO9n4FwyMQpFqcuZB.png?alt=media&token=b73bb5c7-9ee1-4945-acad-9199a5d8a28a"
        },
        {
          "id": "as7eHwKNPUp2qb4h9QM3",
          "name": "Auristela Ramos",
          "text": "<p><i>Chefe da Seção Médica de Valvopatias do Instituto Dante Pazzanese de Cardiologia. Doutora pela Universidade de São Paulo (USP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fas7eHwKNPUp2qb4h9QM3.png?alt=media&token=32355a11-0c96-4de0-a675-71305e6df51a"
        },
        {
          "id": "HiKwZGC9JxBw28x7X1ub",
          "name": "Beatriz Helena S. Furlanetto ",
          "text": "<p><i>Coordenadora da Cirurgia Cardíaca Pediátrica da Santa Casa de Misericórdia de São Paulo. Diretora do ECMO team e cirurgiã cardíaca pediátrica do Hospital Infantil Sabará. Cirurgiã cardíaca pediátrica e codiretora de ECMO do Hospital Beneficência Portuguesa de São Paulo (BP). Doutora em Cirurgia pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Ex-presidente do Departamento de Cirurgia Cardiovascular Pediátrica da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FHiKwZGC9JxBw28x7X1ub.png?alt=media&token=c61c911f-5d8a-4f1b-830c-a45a2d8ee13f"
        },
        {
          "id": "jTqlQiYMsaalx9BVnMCU",
          "name": "Bruno Botelho Pinheiro ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular. Membro da European Association for Cardio-Thoracic Surgery.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FjTqlQiYMsaalx9BVnMCU.png?alt=media&token=9b17c902-42f6-4f11-88da-e44146d7ccbf"
        },
        {
          "id": "IhkEw3DWE01hzwAJyxuR",
          "name": "Bruno da Costa Rocha ",
          "text": "<p><i>Coordenador do Programa de Fellowship em Cirurgia Cardiovascular Pediátrica no Hospital da Criança Martagão Gesteira (Salvador) e Hospital da Criança (Feira de Santana). Fellowship em Cirurgia Cardiovascular Pediátrica no Hospital Necker (França).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FIhkEw3DWE01hzwAJyxuR.png?alt=media&token=140a035b-77c1-4216-9ab3-f573a2641df1"
        },
        {
          "id": "pwRGgdGInnHNtmVajJLN",
          "name": "Carla Tanamati ",
          "text": "<p><i>Livre-docente de Cirurgia Cardiovascular Pediátrica da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Médica assistente da Divisão de Cirurgia Cardíaca Pediátrica do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FpwRGgdGInnHNtmVajJLN.png?alt=media&token=fb6c2255-2e20-422c-9228-d721b813ae65"
        },
        {
          "id": "JQRfMjQb3Z3zbqdH03HC",
          "name": "Carlos Eduardo Duarte",
          "text": "<p><i>Diretor Médico do C.A.R.E – Centro Avançado de Ritmologia e Eletrofisiologia de São Paulo. Médico assistente da Unidade de Estimulação Elétrica e Marca-passo do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FJQRfMjQb3Z3zbqdH03HC.png?alt=media&token=f9e2e5e8-f484-449e-a52e-94524cc36625"
        },
        {
          "id": "Nci7AIXDEKQ27UR2Ryfu",
          "name": "Carlos Manuel de Almeida Brandão ",
          "text": "<p><i>Professor colaborador da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Coordenador da Unidade Cirúrgica de Emergência do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor/HCFMUSP). Doutor em Medicina pela FMUSP. Diretor financeiro da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV) 2022/2023. Comissão de Prova da SBCCV 2024.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FNci7AIXDEKQ27UR2Ryfu.png?alt=media&token=caca4438-b82a-4178-a910-73f5b8352aa8"
        },
        {
          "id": "uAjTiB1jsq3FlwfLCnrH",
          "name": "Christiano da Silveira de Barcellos ",
          "text": "<p><i>Graduado em Medicina pela Universidade de Passo Fundo (1995). Residência em cirurgia cardiovascular pelo Instituto de Cardiologia do Rio Grande do Sul &nbsp;(1999). Mestrado em Ciências Médicas pelo Programa Interinstitucional Universidade Federal do Rio Grande do Sul/ Universidade de Passo Fundo (2004). Título de especialista em Cirurgia Cardiovascular pela Sociedade Brasileira de Cirurgia Cardiovascular em 2006. Título de especialista em Cardiologia pela Sociedade Brasileira de Cardiologia em 2007. Pós Graduação em Hemodinâmica e Cardiologia Intervencionista pela Pontifícia Universidade Católica do Rio Grande do Sul nos anos de 2008/2009. Título de especialista em Hemodinâmica e Cardiologia intervencionista pela Sociedade Brasileira de Hemodinâmica e Cardiologia Intervencionista em 2009.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FuAjTiB1jsq3FlwfLCnrH.png?alt=media&token=c9999593-3be5-42f5-92e4-0fb5c61ac391"
        },
        {
          "id": "EuVeg6zdaqH0f4GwwxmF",
          "name": "Ciro Vinicius Rezende dos Reis",
          "text": "<p><i>Cirurgião cardiovascular pela Santa Casa de Misericórdia de Goiânia. Fellow em Cirurgia Cardiovascular Transcateter no Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor/HCFMUSP). Diretoria da Associação Brasileira dos Residentes de Cirurgia Cardiovascular (ABRECCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FEuVeg6zdaqH0f4GwwxmF.png?alt=media&token=2968f165-b5b3-4ba3-91fd-0567a18cffa6"
        },
        {
          "id": "JyS5Mj4rUgRaqWTRMXRx",
          "name": "Cledicyon Eloy da Costa",
          "text": "<p><i>Graduação em Medicina pela Universidade Federal da Paraíba (UFPB). Título de especialista em Cirurgia Cardiovascular pela Sociedade Brasileira de Cirurgia Cardiovascular/Associação Médica Brasileira (SBCCV/AMB). Membro associado da Sociedade de Cardiologia do Estado de São Paulo (Socesp) e da Sociedade Brasileira de Cardiologia (SBC).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FJyS5Mj4rUgRaqWTRMXRx.png?alt=media&token=c8dbff2c-7bf0-4017-a519-bebfed687330"
        },
        {
          "id": "OnihPyWjPMkA6mJRMfwr",
          "name": "Cláudio Leo Gelape ",
          "text": "",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FOnihPyWjPMkA6mJRMfwr.png?alt=media&token=91fb4b96-b112-40a5-aabb-478d85e7abea"
        },
        {
          "id": "tVeFhvdUnh3pG801x1gI",
          "name": "Cristiano Pisani",
          "text": "<p><i>Médico eletrofisiologista do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor/HCFMUSP), Doutor em Ciências pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Diretor científico da Sociedade Brasileira de Arritmias Cardíacas (Sobrac).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FtVeFhvdUnh3pG801x1gI.png?alt=media&token=7f2348b0-5f7a-4867-a0c5-fe6fa310ba20"
        },
        {
          "id": "N7kAbrv1COv51XT2Vsd8",
          "name": "Cybelle Soares Matos Cascudo ",
          "text": "",
          "image": ""
        },
        {
          "id": "a8vPgddB3sABR4c6X0xF",
          "name": "Daniel Hoyer de Carvalho Barcellos ",
          "text": "<p><i>Graduado em Medicina pela Universidade Federal Fluminense (UFF). Residência em Cirurgia Geral e Cirurgia Cardiovascular na Santa Casa de Porto Alegre. Fellow em Cirurgia Cardiovascular Pediátrica e Congênita no Boston Children’s Hospital. Membro da World Society for Pediatric &amp; Congenital Heart Surgery. Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Atualmente atua como cirurgião cardiovascular no Serviço de Cirurgia Cardíaca Congênita e Pediátrica, e Transplante Cardíaco da Santa Casa de Porto Alegre.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fa8vPgddB3sABR4c6X0xF.png?alt=media&token=97969e76-8acb-42a4-9bcd-44eb2d7e8a81"
        },
        {
          "id": "1A7jYaqoGySa6tUTxhpo",
          "name": "Denis Bouchard",
          "text": "",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F1A7jYaqoGySa6tUTxhpo.png?alt=media&token=32ec9fff-bdbc-499d-bbfd-5258a9e21c96"
        },
        {
          "id": "Y9UL5zc8uOu7hUxm1O41",
          "name": "Denoel Marcelino Oliveira ",
          "text": "<p><i>Chefe da Cirurgia Cardiovascular Pediátrica do Instituto Nacional de Cardiologia (INC), Rio de Janeiro. Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FY9UL5zc8uOu7hUxm1O41.png?alt=media&token=b576ceb0-f984-4884-97f5-bc86b2c6a001"
        },
        {
          "id": "RtfC4tOZcC7lEmtA7qy4",
          "name": "Diego Felipe Gaia dos Santos ",
          "text": "<p><i>Professor adjunto e chefe do Setor de Tratamento Transcateter das Doenças Estruturais do Coração da Disciplina de Cirurgia Cardiovascular da Universidade Federal de São Paulo (Unifesp). Tem experiência na área de Cirurgia Cardiovascular, atuando principalmente em Cirurgia Minimamente Invasiva, Válvulas Transcateter e Doenças da Aorta.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FRtfC4tOZcC7lEmtA7qy4.png?alt=media&token=467acdf7-2aa8-4f98-91c5-0e384f16c224"
        },
        {
          "id": "caInCe2UEo2vJ5ez9FAN",
          "name": "Diogo Assis Souza ",
          "text": "<p><i>Graduação em Engenharia de Produção pela Fundação de Assistência e Educação e Engenharia Civil pela Universidade Paulista (Unip). Médico pelo Centro Universitário de Brasília (UniCEUB). Residente de Cirurgia Cardiovascular do Hospital de Base do Distrito Federal. Vice-presidente da Associação Brasileira dos Residentes de Cirurgia Cardiovascular (ABRECCV), gestão 2024.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FcaInCe2UEo2vJ5ez9FAN.png?alt=media&token=97292fe5-db40-42dd-88f7-902a2e6172a8"
        },
        {
          "id": "IOgE1kvheHZM5JYiB9Ps",
          "name": "Donizetti Dimer Giamberardino Filho",
          "text": "<p>Pediatra e nefrologista. Conselheiro do Conselho Federal de Medicina (CFM). Coordenador do Sistema de Acreditação de Escolas Médicas (SAEME-CFM). Diretor técnico do Hospital Pequeno Príncipe.</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FIOgE1kvheHZM5JYiB9Ps.png?alt=media&token=774a3f4a-9e91-40af-ac2f-b6e8be224d8f"
        },
        {
          "id": "pWpnxr0dJGFYWgjb5jE9",
          "name": "Décio Cavalet Soares Abuchaim ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Doutor em Ciências pela Universidade de São Paulo (USP). Mestre em Clínica Cirúrgica pela Fundação Universidade Regional de Blumenau (Furb). Fellow em Cirurgia Infantil no Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FpWpnxr0dJGFYWgjb5jE9.png?alt=media&token=6e422523-cb64-4c04-967b-b869a93597fe"
        },
        {
          "id": "xwv0eXrASx8uAKCrsDLh",
          "name": "Edson Magalhães Nunes",
          "text": "",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fxwv0eXrASx8uAKCrsDLh.png?alt=media&token=becb2339-e0f0-40e7-87f9-2adccdc416c0"
        },
        {
          "id": "HbH1jwatZQm6ly3bOqFo",
          "name": "Eduardo Augusto Victor Rocha",
          "text": "<p><i>Cirurgião cardiovascular. Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Mestre em Cirurgia pela Universidade Federal de Minas Gerais (UFMG). Doutor em Ciências pela Universidade de São Paulo (USP/ Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo). Professor adjunto de Cirurgia da Faculdade de Ciências Médicas de Minas Gerais (CMMG). Ex-presidente da SBCCV.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FHbH1jwatZQm6ly3bOqFo.png?alt=media&token=ad7cd764-940c-4b85-8327-0e453cbedad4"
        },
        {
          "id": "vklFqYm25ki5o1mzphiQ",
          "name": "Eduardo Keller Saadi ",
          "text": "<p><i>Professor titular de Cirurgia Cardiovascular da Faculdade de Medicina da Universidade Federal do Rio Grande do Sul (UFRGS/Hospital de Clínicas de Porto Alegre). Pós-doutorado pelo Royal Brompton Hospital (Londres). Chefe do Serviço de Cirurgia Cardiovascular e Centro da Aorta e Estrutural do Hospital Mãe de Deus.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FvklFqYm25ki5o1mzphiQ.png?alt=media&token=cb519d4d-a681-4018-a4bc-1d7d29ef3ab3"
        },
        {
          "id": "CmAlnnrzjRt13rIfjULG",
          "name": "Eduardo Miranda Teixeira",
          "text": "",
          "image": ""
        },
        {
          "id": "EtAfmnqDcepyhD8K2cGP",
          "name": "Elinthon Tavares Veronese ",
          "text": "<p><i>Cirurgião Cardiovascular do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP).</i></p><p><i>Membro Especialista pela SBCCV/AMB&nbsp;</i></p><p><i>Mestrado em Gestão de Saúde pela Fundação Getulio Vargas (FGV). </i></p><p><i>Aluno do Doutorado em Cirurgia Torácica e Cardiovascular pela Faculdade de Medicina da Universidade de São Paulo (FMUSP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FEtAfmnqDcepyhD8K2cGP.png?alt=media&token=2ea1dabb-c9cb-494a-bf71-dce94fd58012"
        },
        {
          "id": "KUrfspRDNH3y1f5UxEXv",
          "name": "Enio Buffolo ",
          "text": "<p><i>Professor emérito de Cirurgia Cardiovascular – Escola Paulista de Medicina da Universidade Federal de São Paulo (EPM-Unifesp). Ex-presidente da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Membro titular da European Society of Cardiothoracic Surgery (EACTS). Membro titular da Society of Thoracic Surgeons (STS).&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FKUrfspRDNH3y1f5UxEXv.png?alt=media&token=db1cfff3-c474-468c-8a61-ccf4980a3102"
        },
        {
          "id": "7wgRccFQiSVeGruP4z8c",
          "name": "Fabio Binhara Navarro ",
          "text": "<p><i>Graduação em Medicina pela Universidade Federal do Paraná (UFPR). Residência em Cirurgia Cardiovascular pelo Hospital Nossa Senhora das Graças (HNSG). Mestre em Clínica Cirúrgica pela Pontifícia Universidade Católica do Paraná (PUCPR). Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Diretor científico do Departamento de Cirurgia Cardiovascular Pediátrica (DCCVPED/SBCCV). Responsável pelos Serviços de Cirurgia Cardíaca do Hospital Pequeno Príncipe de Curitiba (Paraná) e do Hospital Materno Infantil de Joinville (Santa Catarina).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F7wgRccFQiSVeGruP4z8c.png?alt=media&token=2468805a-2051-4623-a87d-936a26ce6cf2"
        },
        {
          "id": "BTlpXRTvn56uWDHODHh2",
          "name": "Fabio Biscegli Jatene ",
          "text": "<p><i>Professor titular da disciplina de Cirurgia Cardiovascular da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Diretor da Divisão de Cirurgia Cardiovascular do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Vice-presidente do Conselho Diretor do InCor-HCFMUSP.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FBTlpXRTvn56uWDHODHh2.png?alt=media&token=b0481552-f15a-47f1-9894-e2c35cb1cc84"
        },
        {
          "id": "5oDJONxb6KKoNRImsWEj",
          "name": "Fabrício José de Souza Dinato ",
          "text": "<p><i>Cirurgião Cardiovascular - Instituto do Coração HC/FMUSP. ⁠Médico Assistente da Unidade Cirúrgica de Cardiopatias Valvares</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F5oDJONxb6KKoNRImsWEj.png?alt=media&token=20ee7c3e-2dac-459f-bb96-4dcf651cad74"
        },
        {
          "id": "2eC5tG3Rf3IgH8ZRNRA0",
          "name": "Fabrício Lara Carvalho",
          "text": "<p><i>&nbsp;Residente de Cirurgia Cardiovascular pela Beneficência Portuguesa de São Paulo (BP).&nbsp;</i><i>Graduação em Medicina pela Universidade Nove de Julho (Uninove).&nbsp;</i><i>Ex-vice-presidente do Departamento Brasileiro das Ligas Acadêmicas de Cirurgia Cardiovascular (DBLACCV) gestão 2022-2023. Ex-diretor de estágios do DBLACCV gestão 2021-2022. Fundador e presidente da Liga Acadêmica de Cardiologia e Cirurgia Cardiovascular da Uninove de Bauru gestão 2020-2021.</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F2eC5tG3Rf3IgH8ZRNRA0.png?alt=media&token=3bae1ecd-f9b1-43ca-949b-22704d8a91b9"
        },
        {
          "id": "AtXcVcGzQRhRm88BYtTT",
          "name": "Felipe Reale Cividanes ",
          "text": "<p><i>Graduação em Medicina pela Universidade Nove de Julho (Uninove). Cirurgia Cardiovascular pela Beneficência Portuguesa de São Paulo (BP), na equipe do Dr. Januário Manoel de Souza. Fellowship em Cirurgia Cardíaca Transcateter no Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Título de especialista pela Sociedade Brasileira de Cirurgia Cardiovascular/Associação Médica Brasileira (SBCCV/AMB). Discente do Programa de Doutorado da disciplina de Cirurgia Cardiovascular e Torácica do InCor-HCFMUSP.&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FAtXcVcGzQRhRm88BYtTT.png?alt=media&token=2b631c47-e429-4a48-b5ce-4d74c2ee610d"
        },
        {
          "id": "RzhhxnIjXUFxXnBViKDk",
          "name": "Fernando Antibas Atik ",
          "text": "<p><i>Chefe da Cirurgia Cardiovascular e da Unidade de Transplantes do Instituto de Cardiologia do Distrito Federal (ICDF).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FRzhhxnIjXUFxXnBViKDk.png?alt=media&token=980b8905-b777-42fd-8ba6-707a28f4ea00"
        },
        {
          "id": "KGboPJaP8ub7mjron2Qe",
          "name": "Fernando Antoniali ",
          "text": "<p><i>Ex-presidente do Departamento de Cirurgia Cardiovascular Pediátrica da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Presidente eleito da Extracorporeal Life Support Organization (ELSO) latino-americana. Diretor do Serviço de Cirurgia Cardíaca Pediátrica e ECMO do Hospital da PUC e Clínica Cárdio Cirúrgica de Campinas.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FKGboPJaP8ub7mjron2Qe.png?alt=media&token=a3e17cc7-c353-4ae8-95a7-988aa5f73c0b"
        },
        {
          "id": "RYDKllEwxDZR8rGlgksq",
          "name": "Fernando Antonio Fantini ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FRYDKllEwxDZR8rGlgksq.png?alt=media&token=237b41dc-83a2-4c46-b025-4d6f42f5fab8"
        },
        {
          "id": "VbemlUiQZS2XiFQdu4NW",
          "name": "Fernando Antonio Lucchese ",
          "text": "<p><i>Diretor Científico da SBCCV. Fellow of the American College of Cardiology (ACC).&nbsp;Diretor de três hospitais do complexo Santa Casa: Hospital São Francisco, Hospital da Criança Santo Antônio e Hospital Nora Teixeira. Presidente da Casa de Apoio Madre Ana. Membro da Direção Executiva Médica da Santa Casa de Porto Alegre.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FVbemlUiQZS2XiFQdu4NW.png?alt=media&token=b657bb98-c834-408d-aa9e-4d1b19bd78d0"
        },
        {
          "id": "opldCD9LX0CgEpbNC8lS",
          "name": "Fernando Bermudez Kubrusly ",
          "text": "",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FopldCD9LX0CgEpbNC8lS.png?alt=media&token=81779154-8cf0-42c2-9a9b-54d5cc1fa805"
        },
        {
          "id": "FjybEQe6bu0giHrR1tNN",
          "name": "Fernando Ribeiro Moraes Neto ",
          "text": "<p><i>Professor livre-docente em cirurgia cardiovascular pela Escola Paulista de Medicina da Universidade Federal de São Paulo (EPM-Unifesp). Chefe da disciplina de Cirurgia Cardiotorácica do Departamento de Cirurgia da Universidade Federal de Pernambuco (UFPE). Diretor do Instituto do Coração de Pernambuco (INCOR-PE).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FFjybEQe6bu0giHrR1tNN.png?alt=media&token=cfe7a681-d151-42d0-9e26-1fe76a327c72"
        },
        {
          "id": "k65dMcKtptW5VfLwYqpH",
          "name": "Filipe Tomasi Keppen Sequeira de Almeida ",
          "text": "<p><i>Graduação em Medicina pelo Centro Universitário Fundação Assis Gurgacz (FAG). Residente de Cirurgia Cardiovascular pela Irmandade da Santa Casa de Londrina (ISCAL). Mestrando em Gestão, Tecnologia e Inovação em Urgência e Emergência pela Universidade Estadual de Maringá (UEM).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fk65dMcKtptW5VfLwYqpH.png?alt=media&token=70fc10d3-2424-4e53-b4e4-bd2143275c6c"
        },
        {
          "id": "M1OfuhGffCIJkrYYt9pl",
          "name": "Filomena Galas",
          "text": "<p><i>Professora associada da Disciplina de Anestesiologia da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Supervisora do Serviço de Anestesiologia e Terapia Intensiva Cirúrgica do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Coordenadora da UTI Cardiológica e Unidade de Insuficiência Cardíaca Avançada do Hospital Sírio-Libanês (HSL).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FM1OfuhGffCIJkrYYt9pl.png?alt=media&token=e371c75b-2d95-450f-91a9-ce9cd9572976"
        },
        {
          "id": "oKssp1F2GX2hSPdTSk19",
          "name": "Flávio Tarasoutchi",
          "text": "<p><i>Professor livre-docente da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Diretor da Unidade Clínica de Valvopatias do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Professor colaborador da FMUSP.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FoKssp1F2GX2hSPdTSk19.png?alt=media&token=22d5ac78-e3a9-4c0b-8587-2f4456b3b81c"
        },
        {
          "id": "yp1SqWvrOgncLhVqTRyx",
          "name": "Francisco Diniz Affonso da Costa",
          "text": "<p><i>Mestrado e doutorado em Medicina (Clínica Cirúrgica) pela Universidade Federal do Paraná (UFPR). Livre-docente da Escola Paulista de Medicina da Universidade Federal de São Paulo (EPM-Unifesp). Membro titular da American Association for Thoracic Sugery (AATS). Chefe do Serviço de Cirurgia Cardíaca do Instituto de Neurologia e Cardiologia de Curitiba (INC Cardio). Chefe do Serviço de Cirurgia Cardíaca da Santa Casa de Misericórdia de Curitiba.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fyp1SqWvrOgncLhVqTRyx.png?alt=media&token=ac6b2196-e145-493e-9b8c-dae73591068c"
        },
        {
          "id": "Pm1emtcRbkfF6hMPs6YY",
          "name": "Fábio Sândoli de Brito Jr",
          "text": "<p><i>Diretor de Cardiologia Intervencionista do Hospital Sírio-Libanês. Diretor de Intervenções em Cardiopatia Estrutural do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Professor Livre Docente da Universidade de São Paulo (USP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FPm1emtcRbkfF6hMPs6YY.png?alt=media&token=ef6032bf-0787-4630-81b3-8eb4ee731955"
        },
        {
          "id": "05sQ6y14sKvQGnSvkvLA",
          "name": "Gabriel Rezende Neves",
          "text": "<p><i>Acadêmico de Medicina da Universidade do Estado do Pará (UEPA), cursando o oitavo semestre. Presidente e membro fundador da Liga Acadêmica de Cirurgia Cardiovascular do Pará (LACIC). Foi estagiário do Laboratório de Cirurgia Experimental da UEPA, atuando durante 3 anos na Linha de Isquemia e Reperfusão, ocupando o cargo de coordenador durante um ano. Atualmente é estagiário no Hospital Beneficente Portuguesa de Belém, na área de Cirurgia Cardiovascular.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F05sQ6y14sKvQGnSvkvLA.png?alt=media&token=b55b8765-e95c-4940-9d99-18d989835718"
        },
        {
          "id": "LHp66lMTiqQ3ZbPXi51K",
          "name": "Gabriel Rodrigues Bittencourt ",
          "text": "<p><i>Médico pela Universidade do Estado do Rio de Janeiro (Uerj). Residente de Cirurgia Cardiovascular no Hospital das Clínicas da Universidade Federal de Minas Gerais. Editorial Fellow do Brazilian Journal of Cardiovascular Surgery (BJCVS). Membro da diretoria da Associação Brasileira de Residentes de Cirurgia Cardiovascular (ABRECCV). Fundador e ex-presidente (gestão 2018-2019) da Liga Acadêmica de Cirurgia Cardiovascular Professor Waldir Jazbik (Lacic-Uerj). Ex-presidente (gestão 2021-2022) e ex-diretor de extensão (gestão 2020-2021) do Departamento de Ligas Acadêmicas de Cirurgia Cardiovascular da Sociedade Brasileira de Cirurgia Cardiovascular (DBLACCV/SBCCV).&nbsp;</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FLHp66lMTiqQ3ZbPXi51K.png?alt=media&token=810d6f0d-9874-4267-a0d0-785743e64b0d"
        },
        {
          "id": "RpHhiAlwBULqUuq0Hdnb",
          "name": "Gabriel Starling Costa",
          "text": "<p><i>Acadêmico do curso de Medicina do sétimo período da Faculdade de Ciências Médicas de Minas Gerais (FCM-MG).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FRpHhiAlwBULqUuq0Hdnb.png?alt=media&token=309153f8-1aa9-4a59-8da1-a5b03c562409"
        },
        {
          "id": "wxV46124AmHJk1py3kre",
          "name": "Gabriela Ferreira Nunes",
          "text": "<p><i>Graduanda em Medicina na Universidade Federal de Ouro Preto (UFOP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FwxV46124AmHJk1py3kre.png?alt=media&token=4139af75-6fb1-45dc-8f15-2526cf87ef31"
        },
        {
          "id": "iTQuvZOVhMEUlf5NvGy5",
          "name": "Gabriella Meneses Rocha Borges de Albuquerque",
          "text": "<p><i>Acadêmica do curso de Medicina na Universidade de Fortaleza (Unifor), cursando o sexto período. Atualmente é presidente do Projeto de Extensão Escola de Pediatria (EPed) do Instituto do Coração da Criança e do Adolescente (InCor Criança) e coordenadora de pesquisa da Liga de Cirurgia Torácica e Cardiovascular da Unifor (Licito).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FiTQuvZOVhMEUlf5NvGy5.png?alt=media&token=6c79b6c7-b1b3-4b11-9735-d1902e94a190"
        },
        {
          "id": "GKzpZ6W4tXzDatR29wmZ",
          "name": "Gabrielle Martins Peres ",
          "text": "",
          "image": ""
        },
        {
          "id": "5YxlBHAfgpiuHI67JHKZ",
          "name": "George Ronald Soncini da Rosa ",
          "text": "<p><i>Mestre e doutor em Cirurgia Cardiovascular pela Universidade Federal do Paraná (UFPR). Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Presidente da Sociedade Paranaense de Cirurgia Cardiovascular (SPCCV). Professor titular do curso de Medicina da Universidade do Contestado e das Faculdades Pequeno Príncipe.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F5YxlBHAfgpiuHI67JHKZ.png?alt=media&token=425766a5-de0f-4281-bb04-19e85ac82104"
        },
        {
          "id": "yP9v1YUaKffTWIhPxQui",
          "name": "Gilberto Venossi Barbosa ",
          "text": "<p><i>Professor de Cirurgia Cardiotorácica da Faculdade de Medicina da Universidade Federal do Rio Grande do Sul (UFRGS). Foi Coordenador da Comissão Nacional de Hands-on da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV), Coordenador dos Centros de Ensino e Treinamento da SBCCV (1998-2016) e Coordenador da Hands-on, no Congresso SBCCV, em 2019. Ex-presidente da SBCCV.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FyP9v1YUaKffTWIhPxQui.png?alt=media&token=8c88bdd9-777d-4987-8ba4-aea444cfa701"
        },
        {
          "id": "Q2gVHf5GxvfJb7T0N0Y1",
          "name": "Gilberto de Oliveira Scuciato",
          "text": "<p><i>Formado em Biomedicina pela Universidade Santo Amaro (Unisa). Em 1995 fez o primeiro curso de especialização em Circulação Extracorpórea pelo Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP) e desde então trabalha no Hospital do Coração prestando serviços para a equipe Dr. Adib Jatene. Atualmente é sócio da equipe Delta Perfusão, prestando serviços principalmente para o Instituto Dante Pazzanese e HCor e esporadicamente para outros hospitais da cidade de São Paulo (Rede D'Or, Albert Einstein, Sírio-Libanês etc.). ECMO especialista pelo InCor em 2013. Atualmente trabalha quase que exclusivamente com cardiopatias congênitas.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FQ2gVHf5GxvfJb7T0N0Y1.png?alt=media&token=75272f41-b0f0-4013-bb82-98ac12420087"
        },
        {
          "id": "J5XrbAnMvBOgM7IU08pE",
          "name": "Giovanna Fávero Cano",
          "text": "",
          "image": ""
        },
        {
          "id": "D9OFMMa4b6zhRZ90JGDg",
          "name": "Giuseppe Bruschi",
          "text": "<p><i>Especialista em Cirurgia Cardiovascular em Milão.&nbsp;Membro da European Society of Cardiology (ESC), da European Society of Cardiac Surgery (ESCVS) e da National Association of Hospital Cardiologists (ANMCO).&nbsp;Atualmente é diretor médico de primeiro nível do Departamento de Cirurgia Cardíaca do Departamento Cardio-Tóraco-Vascular A. De Gasperis do ASST Grande Ospedale Metropolitano Niguarda (Milão, Itália). Atua principalmente com o tratamento transcateter da doença da válvula cardíaca, estenose da válvula aórtica, regurgitação mitral e Mitraclip. Desde 2008 realiza formação contínua no Serviço de Hemodinâmica do Cardio Center do ASST Niguarda.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FD9OFMMa4b6zhRZ90JGDg.png?alt=media&token=8dccd73c-d7bc-446f-a9b3-e66702dbfb9c"
        },
        {
          "id": "xddttI4ZwqOtQ7uhUjjF",
          "name": "Gleison Carlos Arantes Filho",
          "text": "<p><i>Acadêmico de Medicina do oitavo período da Universidade Federal de Ouro Preto (Ufop). Autor e apresentador de trabalhos científicos em Congressos Nacionais na área de Cardiologia. Atualmente é associado acadêmico do Departamento Brasileiro de Ligas Acadêmicas de Cirurgia Cardiovascular (DBLACCV) e da Sociedade Brasileira de Cardiologia (SBC). Atua como representante local da Associação Brasileira das Ligas Acadêmicas de Cirurgia Capítulo Minas Gerais (Ablac-MG). Áreas de interesse: Cirurgia Cardiovascular e Cardiopatias Congênitas e Adquiridas.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FxddttI4ZwqOtQ7uhUjjF.png?alt=media&token=06fa372f-efd5-4f9a-b26a-e840025b0096"
        },
        {
          "id": "iN28qdxipRgK7fX0G4Fh",
          "name": "Glen Van Arsdell",
          "text": "<p><i>Chefe do Departamento de Cirurgia&nbsp;Cardiovascular Congênita na Universidade da Califórnia em Los Angeles (UCLA).&nbsp;Sua atuação acadêmica atualmente se concentra no desenvolvimento de&nbsp;cirurgia&nbsp;de precisão específica para pacientes com tetralogia de Fallot.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FiN28qdxipRgK7fX0G4Fh.png?alt=media&token=ab4cd7c1-89b7-4ee0-a2b1-2a1e42993d5f"
        },
        {
          "id": "KlWwq8iYe8E12tgFM8K8",
          "name": "Guilherme Rabello",
          "text": "<p><i>Engenheiro pela Escola Politécnica da Universidade de São Paulo (Poli-USP), desde 2011 atua na área da Saúde no desenvolvimento de soluções em Telemedicina e Inovação Médica. Atualmente é head de inovação do InovaInCor (núcleo de inovação do do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo-InCor-HCFMUSP), coordenador do Projeto de Patient Blood Management da Associação Brasileira de Hematologia e Hemoterapia (ABHH) e do Núcleo de Inovação da Sociedade de Cardiologia do Estado de São Paulo (Socesp), e embaixador da Healthcare Denmark para o Brasil, dentre outras atividades.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FKlWwq8iYe8E12tgFM8K8.png?alt=media&token=aa747131-1db6-4abf-8171-b2969d8098d0"
        },
        {
          "id": "V64V1Hjhqx4criX08D9u",
          "name": "Guilherme Viotto Rodrigues da Silva",
          "text": "<p><i>Cirurgião Cardíaco dos Hospitais&nbsp;</i><i>do Coração (Hcor), Sírio Libanês e Albert Einstein.&nbsp;</i><i>Cirurgião Cardiovascular pelo Hospital das Clínicas da Faculdade de Medicina de Botucatu (FMB-Unesp). Complementação especializada em Cirurgia Cardíaca Pediátrica pelo Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FV64V1Hjhqx4criX08D9u.png?alt=media&token=b52f4efa-ce71-4562-8e0b-4f92bfe6f17f"
        },
        {
          "id": "fw6hFmYYPOCIXsxdSLRm",
          "name": "Gustavo Calado de Aguiar Ribeiro ",
          "text": "<p><i>Professor membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).&nbsp;⁠Titular de Cirurgia Cardíaca da Pontifícia Universidade Católica de Campinas (PUC-Campinas).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Ffw6hFmYYPOCIXsxdSLRm.png?alt=media&token=992f7d8d-242c-4798-861d-216d0a43b952"
        },
        {
          "id": "YSTjpav26KV1ydeC6v9p",
          "name": "Gustavo Ieno Judas ",
          "text": "<p><i>Doutor em Ciências Médicas pela Universidade de São Paulo (USP). Membro titular e Diretor Financeiro da SBCCV da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FYSTjpav26KV1ydeC6v9p.png?alt=media&token=7e5f4ea7-754a-4ac7-ac4b-bce23de3abb4"
        },
        {
          "id": "QZjFuLMJXZlRdcYRyw2I",
          "name": "Gustavo Klug Pimentel ",
          "text": "<p><i>Graduação em Medicina pela Universidade Federal do Paraná (UFPR). Residência Médica em Cirurgia Cardiovascular no Hospital Nossa Senhora das Graças. Mestrado em Cirurgia pela Pontifícia Universidade Católica do Paraná (PUCPR). Experiência nas áreas de Cirurgia Cardiovascular em Adultos e Pediátrica.</i></p><p>&nbsp;</p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FQZjFuLMJXZlRdcYRyw2I.png?alt=media&token=82c9004b-2148-407a-9c1e-b632ff3bbdd2"
        },
        {
          "id": "keFvoyoOACgEM8bxAcmx",
          "name": "Henrique Madureira da Rocha Coutinho ",
          "text": "<p><i>Coordenador do Serviço de Cirurgia Cardiovascular do Hospital das Clínicas de Teresópolis Costantino Ottaviano (HCTCO). Cirurgião cardiovascular Hospital Universitário Pedro Ernesto é o hospital universitário da Universidade do Estado do Rio de Janeiro (HUPE-Uerj). Mestre em Ciências Médicas pela UERJ. Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FkeFvoyoOACgEM8bxAcmx.png?alt=media&token=133d73b4-cdd0-4d48-a682-8099d0a775c7"
        },
        {
          "id": "9bpCBQ85pG4g5h1I9TtZ",
          "name": "Henrique Murad ",
          "text": "<p><i>Professor emérito da Universidade Federal do Rio de Janeiro (UFRJ). Membro titular da Academia Nacional de Medicina (ANM). Cirurgião cardiovascular do Hospital São Vicente de Paulo (Rio de Janeiro).&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F9bpCBQ85pG4g5h1I9TtZ.png?alt=media&token=9869c6fc-320a-4bfc-a07c-450f68f153c9"
        },
        {
          "id": "7qi2vEYdO3teszgHsWwG",
          "name": "Heraldo Guedis Lobo Filho ",
          "text": "<p><i>Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Membro habilitado do Departamento de Estimulação Cardíaca Artificial (Deca). Título de especialista em Medicina Intensiva. Mestrado e doutorado em Cirurgia pela Universidade Federal do Ceará (UFC). Professor da Faculdade de Medicina da UFC. Cirurgião cardiovascular do Hospital Dr. Carlos Alberto Stuart Gomes.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F7qi2vEYdO3teszgHsWwG.png?alt=media&token=b39a4ee7-d628-406a-b5f1-e019f287d330"
        },
        {
          "id": "tf3oLkNVCVXfHGH4ftNY",
          "name": "Herbert Freyre Ríos",
          "text": "",
          "image": ""
        },
        {
          "id": "rkypLnEeHc6cO47JlH17",
          "name": "Hristof Kirov",
          "text": "",
          "image": ""
        },
        {
          "id": "1YRRj0zd5Kxu7qTlcNcy",
          "name": "Ignacio Bezerra",
          "text": "<p>Cirurgião cardiovascular pediátrico e cirurgião&nbsp;especializado em transplante pediátrico de coração, rim e pulmão no Hospital JP Garrahan, Buenos Aires, Argentina.&nbsp;</p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F1YRRj0zd5Kxu7qTlcNcy.png?alt=media&token=73716ed1-dded-45de-b3c7-44a722050b4e"
        },
        {
          "id": "lr42ygHEcumaJDMyXSkN",
          "name": "Isadora Rênia Lucena Oliveira",
          "text": "",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2Flr42ygHEcumaJDMyXSkN.png?alt=media&token=62adf8d8-0c9f-46fb-ac2e-a5c25cf7c4a2"
        },
        {
          "id": "SLvHHLo7cP0WxBtdV5az",
          "name": "Janaína Souto Rocha",
          "text": "<p><i>Advogada, administradora do Instagram cardiopatia_congenita2, juntamente com Larissa Mendes.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FSLvHHLo7cP0WxBtdV5az.png?alt=media&token=7550e68a-6bbc-41cb-8cfc-2d4343c797ae"
        },
        {
          "id": "fVNXav4rEz5KTGiUocDg",
          "name": "Jarbas Jakson Dinkhuysen ",
          "text": "",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FfVNXav4rEz5KTGiUocDg.png?alt=media&token=be8d04b3-0dc8-4d22-b3f4-4930b595d06b"
        },
        {
          "id": "1xdxQBBzvVGwp77X6HKl",
          "name": "Jesus Antonio Gutierrez Saurith ",
          "text": "<p><i>Graduação em Medicina - Pontificia Universidade Javeriana - Colombia</i></p><p><i>Cirurgião Cardiovascular - Formado no Instituto Dante Pazzanese de Cardiologia</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F1xdxQBBzvVGwp77X6HKl.png?alt=media&token=856736f2-d679-48c9-bff1-9d01ccd88095"
        },
        {
          "id": "3PGBHb0C3UO8TXp9gDM2",
          "name": "Jocerlano Santos de Sousa ",
          "text": "<p><i>Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Residência Médica em Cirurgia Cardiovascular no Instituto do Coração da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Diretor de Comunicação da Sociedade Brasileira de Cardiologia (SBC), regional Piauí. Cirurgião cardiovascular em Teresina, Piauí. Observership em Cirurgia Cardíaca Minimamente Invasiva no Herzzentrum (Leipzig, Alemanha). Observership em Cirurgia da Aorta na Cleveland Clinic (Ohio, EUA).</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F3PGBHb0C3UO8TXp9gDM2.png?alt=media&token=84ea226b-efc1-4083-82d6-bbd428c92dd7"
        },
        {
          "id": "Y90o4YcoL3yo2DzNQf0g",
          "name": "Josalmir José Melo do Amaral ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Doutor em Ciências pelo Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Professor associado do Departamento de Medicina Integrada da Universidade Federal do Rio Grande do Norte (UFRN). Chefe do Serviço de Cirurgia Cardiovascular do Hospital do Coração de Natal (Rio Grande do Norte).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FY90o4YcoL3yo2DzNQf0g.png?alt=media&token=82906aae-ed68-4687-940f-d5c76597d628"
        },
        {
          "id": "Sc8INEzLO3HQm3PdgCvH",
          "name": "José Augusto Duncan Santiago ",
          "text": "<p><i>Cirurgião Cardiovascular do Grupo de Miocardiopatias e Doenças da Aorta do InCor - HCFMUSP. Cirurgião Cardiovascular do Grupo de Emergências Cirúrgicas do InCor - HCFMUSP. Professor Colaborador da Faculdade de Medicina da USP. Membro Especialista da SBCCV</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FSc8INEzLO3HQm3PdgCvH.png?alt=media&token=11526cb7-c5e5-444c-8df2-8f27a081b818"
        },
        {
          "id": "NfGhLRj2uYMTh2MAUyW0",
          "name": "José Carlos Pachón Mateos",
          "text": "<p><i>Professor da disciplina de Arritmias da Pós-graduação da USP. Diretor do Serviço de Arritmias do Hospital do Coração (HCor). Especialista em Estimulação Cardíaca Artificial pela Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FNfGhLRj2uYMTh2MAUyW0.png?alt=media&token=6005d3dc-3d93-47f4-b8d7-979fc7064dc8"
        },
        {
          "id": "ojVPBcxW6WCnYtTHpsXE",
          "name": "José Cícero Stocco Guilhen ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Professor adjunto do Departamento de Cirurgia da Universidade Federal de São Paulo (Unifesp). Chefe do Setor de Cirurgia Cardíaca Pediátrica do Instituto Dante Pazzanese de Cardiologia.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FojVPBcxW6WCnYtTHpsXE.png?alt=media&token=830adea4-2f39-4445-b442-2f5e258d8b86"
        },
        {
          "id": "5yrGDXcl3mMyHZSJbuow",
          "name": "José Honório de Almeida Palma Fonseca",
          "text": "<p><i>Professor associado livre-docente. Chefe da disciplina de Cirurgia Cardiovascular (mandato 2008-2012). Chefe do Grupo de Doenças da Aorta da Universidade Federal de São Paulo (Unifesp). Coordenador do Curso de Doenças da Aorta e Novas Habilidades em Cirurgia Cardíaca. Organizador do Curso de Pós-Graduação em Cirúrgica Translacional. Experiência na área de Medicina, com ênfase em Cirurgia Cardiovascular, atuando principalmente nos seguintes áreas: Dissecções, Aneurismas, Doenças Valvares, Endopróteses, Stents Aórticos, Tratamento Transcateter de Válvulas Cardíacas. Professor colaborador do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F5yrGDXcl3mMyHZSJbuow.png?alt=media&token=a5130aff-344a-4e12-805e-7ce41193b555"
        },
        {
          "id": "Evtzg8PI0eTjewEFOEe2",
          "name": "José Lira Mendes Filho ",
          "text": "<p><i>Mestre em Cirurgia Torácica e cardiovascular pela Universidade Federal de Pernambuco (UFPE). Doutor em Cirurgia Torácica e cardiovascular pela Universidade de São Paulo (USP). Professor de Cirurgia Cardiovascular da Universidade Federal do Piauí (UFPI). Membro titular da Academia de Medicina do Piauí. Membro titular da Academia Brasileira de Cirurgia Cardiovascular (ABCC).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FEvtzg8PI0eTjewEFOEe2.png?alt=media&token=0b5873f5-7cd1-44c8-aacb-8f809cc0b9e0"
        },
        {
          "id": "pw7FmMZMBTtsbcRfAVBk",
          "name": "José Teles de Mendonça ",
          "text": "<p><i>Professor titular de Cirurgia Cardiovascular da Universidade Federal de Sergipe (UFS). Ex-presidente da Sociedade Norte-Nordeste de Cirurgia Cardiovascular (SNNCCV). Ex-presidente da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Membro titular da Academia Brasileira de Cirurgia Cardiovascular (ABCC).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fpw7FmMZMBTtsbcRfAVBk.png?alt=media&token=b351cffc-a3d6-4f59-91fd-d67947581ba3"
        },
        {
          "id": "ifgnNJhEmY84MFU1gQjF",
          "name": "José Wanderley Neto ",
          "text": "<p><i>Ex-presidente da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV) e da Sociedade Norte-Nordeste de Cirurgia Cardiovascular (SNNCCV). Presidente da Academia Brasileira de Cirurgia Cardiovascular (ABCC). Diretor do Instituto de Doenças Cardiovasculares de Alagoas. Chefe do Serviço de Cirurgia Cardiovascular do Hospital do Coração de Alagoas.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FifgnNJhEmY84MFU1gQjF.png?alt=media&token=95befee7-64ea-4e2f-b11a-0ff3c63d1320"
        },
        {
          "id": "487mQwdaZGJfbJ8NbJ9n",
          "name": "João Carlos Ferreira Leal ",
          "text": "<p><i>Cirurgião cardiovascular do Hospital Beneficência Portuguesa de São José do Rio Preto. Professor adjunto da Faculdade Estadual de Medicina de São José do Rio Preto (Famerp). Mestrado e doutorado em Cirurgia Cardiovascular pela Universidade Estadual de Campinas (Unicamp). Ex-presidente da Sociedade Brasileira de Cirurgia Cardiovascular.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F487mQwdaZGJfbJ8NbJ9n.png?alt=media&token=2d596376-c833-4bf0-849b-2d68ec42179c"
        },
        {
          "id": "04h2scYEUKTReNq7iogR",
          "name": "João Marcelo Ancilon Cavalcante Albuquerque ",
          "text": "<p><i>Graduação em Medicina pela Universidade Federal do Ceará (UFC). Cirurgia geral pelo Hospital Geral de Fortaleza. Cirurgia cardiovascular pelo Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Fellow no Hospital Europeu Georges Pompidou – serviço do Prof. Carpentier. Mestrado em cirurgia pela Universidade de Paris. Título de especialista pela Sociedade Brasileira de Cirurgia Cardiovascular/Associação Médica Brasileira (SBCCV/AMB). Ex-presidente da Cooperativa de Cirurgiões Cardiovasculares do Estado do Ceará. Cirurgião do Hospital do Coração de Messejana (Ceará). Chefe do Serviço de Cirurgia Cardiovascular do Hospital São Carlos/Rede D’Or – Fortaleza, Ceará.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F04h2scYEUKTReNq7iogR.png?alt=media&token=22e5483c-ad96-4e4a-aea7-e33ebdac1ef4"
        },
        {
          "id": "KknoPWiFLlfc8TkiwjI2",
          "name": "João Paulo Segundo de Paiva Oliveira ",
          "text": "<p><i>Graduação em Medicina pela Universidade Federal de Pernambuco (UFPE). Residência Médica em Cirurgia Geral pelo Hospital da Restauração. Residência Médica em Cirurgia Cardiovascular pelo Instituto de Medicina Integral Professor Fernando Figueira (IMIP). CEO e sócio-fundador do Real Instituto de Cirurgia Cardiovascular (RICCA). Cirurgião cardiovascular e sócio-fundador da MAXCOR. MBA em Gestão Executiva em Saúde pela Faculdade Pernambucana de Saúde/Instituto de Medicina Integral Professor Fernando Figueira (FPS/IMIP).&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FKknoPWiFLlfc8TkiwjI2.png?alt=media&token=d6e7f0b5-a0ff-4b74-9e8a-2e48fae72016"
        },
        {
          "id": "hPRPEqyYykW4EpzoBnfV",
          "name": "João Pedro Gebran Neto",
          "text": "<p><i>Desembargador Federal do TRF4. Mestre em Direito Constitucional. Autor do livro Direito à saúde – análise à luz da jurisprudência (ed. Verbo Jurídico).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FhPRPEqyYykW4EpzoBnfV.png?alt=media&token=002ee686-6a55-4df8-bd65-b12237694b2c"
        },
        {
          "id": "v931elE9XIZJxcOGdNS4",
          "name": "Juan Alberto Cosquillo Mejia ",
          "text": "",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fv931elE9XIZJxcOGdNS4.png?alt=media&token=78cec117-49cd-4784-98f9-bd8f2269140a"
        },
        {
          "id": "uc7ygrqrXZ8jOy6l9cZQ",
          "name": "Jéssica Cordeiro de Siqueira Campos ",
          "text": "<p><i>Graduação em Medicina pela Universidade Federal de Pernambuco (UFPE). Cirurgiã cardiovascular. Integrante da Diretoria da Associação Brasileira dos Residentes de Cirurgia Cardiovascular (ABRECCV).</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2Fuc7ygrqrXZ8jOy6l9cZQ.png?alt=media&token=4e8f8af3-525a-48d5-8905-df19dfce0605"
        },
        {
          "id": "kN4uP9apTbZTqbSAifCh",
          "name": "Jéssica Silva Silvério",
          "text": "<p><i>Médica pela Escola Superior de Ciências da Saúde do Distrito Federal. Residente de Cirurgia Cardiovascular pelo Instituto de Cardiologia e Transplantes do Distrito Federal.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F3mZAJ0EiM8bQ92wm2tj0yc2kAlo1.jpg?alt=media&token=80d74b99-cc4b-462c-9afd-0aef0a402f4c"
        },
        {
          "id": "mG2QRigoVRKC0QCk8uGf",
          "name": "Karlos Jennysson Sousa Soares",
          "text": "<p><i>Mestre em Ciências com foco em Prevenção, Diagnóstico e Tratamento em Medicina Cardiovascular pelo Instituto Dante Pazzanese de Cardiologia/Universidade de São Paulo (USP). Fellowship em Cirurgia Cardiovascular Transcateter no Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Cirurgião cardiovascular pelo Instituto Dante Pazzanese de Cardiologia. Residência em Cirurgia Geral pela Santa Casa de Misericórdia de Sobral/Universidade Federal do Ceará (UFC) e graduação em Medicina pelas Faculdades Integradas da União Educacional do Planalto Central.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FmG2QRigoVRKC0QCk8uGf.png?alt=media&token=51447916-cff1-4eb0-abbc-3cc09acc8d68"
        },
        {
          "id": "0HKGwQwroXpkyJLzp9Sh",
          "name": "Laio Caju Wanderley",
          "text": "<p><i>Título de Especialista em Cirurgia Cardiovascular pela Sociedade Brasileira de Cirurgia Cardiovascular/Associação Médica Brasileira (SBCCV/AMB). Fellowship na Santa Casa de Porto Alegre, Unidade Santo Antônio e São Francisco, com foco em Cardiopatias Congênitas.</i><br><br><br>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FamqTd2mzoLXEGzH1pMur22ablnx1.jpg?alt=media&token=290ae076-1ed7-4391-8459-1b60d5c0346a"
        },
        {
          "id": "8slzbpEAdwuDdbwxTXYO",
          "name": "Larissa de Oliveira Beltrão",
          "text": "<p><i>Acadêmica de Medicina da Faculdade Pernambucana da de Saúde/Instituto de Medicina Integral Professor Fernando Figueira (FPS/IMIP). Estagiária extracurricular do Serviço de Cirurgia Cardiovascular e Transplante Cardíaco Adulto do Instituto de Medicina Integral Professor Fernando Figueira (IMIP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F8slzbpEAdwuDdbwxTXYO.png?alt=media&token=86704377-97df-476e-8f1c-39aadea30442"
        },
        {
          "id": "p5qCiPwfNvMKW046LzEC",
          "name": "Leila Nogueira Ferreira de Barros",
          "text": "<p><i>Cirurgiã cardiovascular pela Santa Casa de Misericórdia de São Paulo. Fellowship em Cirurgia Cardiovascular Transcateter pelo Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (Incor-HCFMUSP). Mestre em Pesquisa em Cirurgia pela Faculdade de Ciências Médicas da Santa Casa de Misericórdia de São Paulo. Membro da Diretoria do Comitê de Mulheres da Associação Latino-Americana de Cirurgia Cardiovascular e Endovascular (LACES).&nbsp;Fellow Editor do Brazilian Journal of Cardiovascular Surgery&nbsp;(BJCVS).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2Fp5qCiPwfNvMKW046LzEC.png?alt=media&token=834c8edc-9370-4ab5-bdad-a1a97b523f0f"
        },
        {
          "id": "LapyFJ6x4PKGq7qMfbdg",
          "name": "Leonardo Augusto Miana",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Presidente do Departamento de Cirurgia Cardiovascular Pediátrica (DCCVPED/SBCCV). Cirurgião Cardíaco do Incor. Doutor em Cirurgia Torácica e Cardiovascular pela Universidade de São Paulo (USP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FLapyFJ6x4PKGq7qMfbdg.png?alt=media&token=1c27866d-6e02-449d-8624-caabf018dc0d"
        },
        {
          "id": "770FBuk4BjAgZVPR0465",
          "name": "Letícia Siman Lopes ",
          "text": "<p><i>Acadêmica de Medicina na Universidade de Marília (Unimar). Fundadora da Liga Acadêmica de Cirurgia Cardiovascular (LACCV), 2023. Presidente da Associação das Ligas Acadêmicas de Medicina da Unimar (ALAMUNI), 2024. Relações Internas na Associação Brasileira das Ligas Acadêmicas de Cirurgia, capítulo São Paulo (ABLAC), 2024. Assistente Regional no National Exchange Team pela IFMSA Brazil, 2023-2024.&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F770FBuk4BjAgZVPR0465.png?alt=media&token=d217f25c-132e-4fb0-b3fa-ced95fb94651"
        },
        {
          "id": "caHwmq8IBqzjhrKwB1Eh",
          "name": "Lucas Molinari Veloso da Silveira",
          "text": "<p><i>Médico pela Universidade Federal do Rio Grande do Sul (UFRGS). Especialista em Cirurgia Cardiovascular pela Universidade de São Paulo (USP). Fellowship em Transplante Cardíaco em andamento na Universidade Federal de Ciências da Saúde de Porto Alegre (UFCSPA). Doutor em Cardiologia e Ciências Cardiovasculares pela UFRGS.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FcaHwmq8IBqzjhrKwB1Eh.png?alt=media&token=3fe52cf1-78ff-4f68-8d27-771194430c17"
        },
        {
          "id": "wzc9bboIiUmKkT9AXf57",
          "name": "Luciana Bertocco de Paiva Haddad",
          "text": "<p><i>Livre-docente pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Pós-Doutorado em Avaliação Econômica. Assistente do Serviço de Transplante de Órgãos do Aparelho Digestivo do Hospital das Clínicas da FMUSP. Presidente da Associação Brasileira de Transplantes de Órgãos (ABTO).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2Fwzc9bboIiUmKkT9AXf57.png?alt=media&token=15f2d74c-b1a6-4421-bb5c-cb78fc192ea7"
        },
        {
          "id": "z7koAlJEGjYXiGA4TL4k",
          "name": "Luciano Abdallah Ferreira ",
          "text": "<p><i>Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Membro especialista em Estimulação Artificial (SBCCV). Membro habilitado em TAVI pela Sociedade Brasileira de Cirurgia Cardiovascular/Sociedade Brasileira de Hemodinâmica e Cardiologia Intervencionista (SBCCV/SBHCI). Chefe do Serviço de Cirurgia Cardiovascular e preceptor da Residência Médica do Hospital Ibiapaba (Barbacena, MG).&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fz7koAlJEGjYXiGA4TL4k.png?alt=media&token=935351b3-f374-40b7-a05c-066e734db4c2"
        },
        {
          "id": "NAPjWcx02AeX9WhGu7cW",
          "name": "Luciano Rapold Souza ",
          "text": "<p><i>Cirurgião cardiovascular do Hospital Português e da Rede D'Or (Salvador, Bahia). Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Doutor em Ciências pela Universidade de São Paulo (USP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FNAPjWcx02AeX9WhGu7cW.png?alt=media&token=a839f3cb-f6a6-4e82-a080-81837d613ba6"
        },
        {
          "id": "UFGdWWcOzmh6GDgD0dDC",
          "name": "Luiz Augusto Ferreira Lisboa ",
          "text": "<p><i>Professor livre-docente em Cirurgia pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Cirurgião cardiovascular do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV) e da European Association for Cardio-Thoracic Surgery (EACTS).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FUFGdWWcOzmh6GDgD0dDC.png?alt=media&token=ce7873f6-e95f-4e5e-a092-9369b5a843ce"
        },
        {
          "id": "lPdDpW8VpNzGAyTTca5D",
          "name": "Luiz Carlos Bento de Souza ",
          "text": "",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FlPdDpW8VpNzGAyTTca5D.png?alt=media&token=59257399-b598-4d7b-8521-c249d274c86b"
        },
        {
          "id": "urqa8kheZfSyrtQUcRh6",
          "name": "Luiz Cláudio Moreira Lima ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Presidente do Conselho Deliberativo da SBCCV. Cirurgião cardiovascular e diretor técnico do Hospital Madre Teresa (Belo Horizonte, Minas Gerais).&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Furqa8kheZfSyrtQUcRh6.png?alt=media&token=5ea6759f-260b-4850-885d-c214ceb25de9"
        },
        {
          "id": "Grp7ZpLL5sbcfYJM0t21",
          "name": "Luiz Fernando Caneo ",
          "text": "<p><i>Cirurgião cardiovascular da Unidade de Cirurgia Cardiovascular Infantil do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Professor colaborador da Disciplina de Cardiopenumologia da Faculdade de Medicina da Universidade de São Paulo (FMUSP). ECMO Director – ELSO Center – 276 – InCor-HCFMUSP. Presidente do Departamento de Circulação Extracorpórea e Assistência Circulatória Mecânica (Decam).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FGrp7ZpLL5sbcfYJM0t21.png?alt=media&token=c30d7fb0-0a83-4587-9fd4-88e45f891fec"
        },
        {
          "id": "L14lyaA2guegwmc8salH",
          "name": "Luiz Fernando Kubrusly ",
          "text": "<p><i>Mestre e doutor pela Universidade Federal do Paraná (UFPR). Professor coordenador da Clínica Cirúrgica e Pós-Graduação da Faculdade Mackenzie do Paraná. Diretor do Instituto do Coração de Curitiba.&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FL14lyaA2guegwmc8salH.png?alt=media&token=77368254-3b8c-44c2-86e0-c81722ea201a"
        },
        {
          "id": "rzl2SSIWN0s5Wq0xMSbk",
          "name": "Luís Roberto Palma Dallan ",
          "text": "<p><i>Médico assistente da Divisão Cirúrgica de Coronariopatias e de Emergência do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Frzl2SSIWN0s5Wq0xMSbk.png?alt=media&token=26fb1b75-aca4-4aee-85c0-6df56c038ecc"
        },
        {
          "id": "GpZRhTdTjvBCFvSVgyfD",
          "name": "Lívia Silva de Paula Faria ",
          "text": "<p><i>R3 de Cirurgia Cardiovascular do Hospital Felicio Rocho, Belo Horizonte (Minas Gerais).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FGpZRhTdTjvBCFvSVgyfD.png?alt=media&token=a142ee79-da50-4b7c-b434-c1db748a54e0"
        },
        {
          "id": "wJFJCWc8Lsge7xSmhmsN",
          "name": "Lívia Torres Pinheiro",
          "text": "<p><i>Estudante de Medicina da Universidade Federal do Rio de Janeiro (UFRJ), instituição onde exerce investigação a partir de Iniciações Científicas desde o início da graduação. Agraciada com prêmios de relevância social e menções honrosas. Compõe o setor de pesquisa da Equipe Incision Brazil. Foi estagiária no Serviço de Cirurgia Cardiovascular da Faculdade de Medicina da Universidade do Porto (Portugal). Estagiária no setor de Cirurgia Cardiovascular do Hospital Universitário Pedro Ernesto (Rio de Janeiro).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FwJFJCWc8Lsge7xSmhmsN.png?alt=media&token=d2aca0e4-2b86-4b87-aeb6-b48c078e1e82"
        },
        {
          "id": "8vWrWlQ4IZxCMIoSQAF5",
          "name": "Magaly Arrais dos Santos",
          "text": "<p><i>Cirurgiã cardiovascular. Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Doutorado em Cirurgia Cardiovascular pela Universidade Federal de São Paulo (Unifesp). MBA em Gestão em Saúde pela Fundação Getulio Vargas (FGV). Especialista em Direito Médico e Hospitalar pela Escola Paulista de Direito (EPD). Graduada em Direito pelo IBMEC São Paulo. Advogada.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F8vWrWlQ4IZxCMIoSQAF5.png?alt=media&token=35f67133-20f4-4afc-9e7b-ed945c6b8d2b"
        },
        {
          "id": "oNlbl9hoqO4Ywxa9vCaG",
          "name": "Maikon Lucian Madeira Quarti",
          "text": "<p><i>Cirurgião geral pelo Hospital São José de Criciúma (Santa Catarina). Residente no Hospital Maternidade Marieta Konder Bornhausen em Itajaí (Santa Catarina). Atualmente é Presidente da Associação Nacional dos Médicos Residentes (ANMR). Compõe a diretoria da Associação Brasileira dos Residentes de Cirurgia Cardiovascular (ABRECCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FoNlbl9hoqO4Ywxa9vCaG.png?alt=media&token=85baea98-e2ae-4a9c-ba3e-17ac9f936f29"
        },
        {
          "id": "RcQEhCZ6GprndHbobXQG",
          "name": "Maral Ouzounian",
          "text": "<p><i>Professora associada de Cirurgia da Universidade de Toronto. Cirurgiã cardíaca e aórtica e diretora de fellowship do Toronto General Hospital. Antonio &amp; Helga DeGasperis Chair in Clinical Trials and Outcomes Research, University Health Network.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FRcQEhCZ6GprndHbobXQG.png?alt=media&token=c35d64a1-a17d-48cc-a532-c693223ca823"
        },
        {
          "id": "4l3989WUqEkyDScf47UK",
          "name": "Marcela da Cunha Sales ",
          "text": "<p><i>Cirurgiã cardiovascular do Hospital São Francisco – Santa Casa de Porto Alegre. Coordenadora do Centro de Tratamento de Aorta da Santa Casa de Porto Alegre. Ex-presidente da Sociedade Gaúcha de Cirurgia Cardiovascular (SGCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F4l3989WUqEkyDScf47UK.png?alt=media&token=096a68a8-0bad-49b8-a130-2727f6a518d4"
        },
        {
          "id": "ItkusNynvXCA1puFB0rV",
          "name": "Marcelo Alvarenga",
          "text": "<p><i>Médico endocrinologista. Profissional Certificado em Experiência do Paciente (CPXP). CEO e sócio-fundador da ConectaExp – Consultoria, Gestão em Saúde e Desenvolvimento de Pessoas. Coordenador e docente do curso de Pós-Graduação em Experiência do Paciente e Cuidado Centrado na Pessoa, parceria entre Hospital Sírio-Libanês e The Beryl Institute. Co-cair Global Council The Beryl Institute. Presidente da Sociedade Brasileira de Experiência do Paciente e Cuidado Centrado na Pessoa (Sobrexp).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FItkusNynvXCA1puFB0rV.png?alt=media&token=4bce6129-dbff-45b2-b860-48aa9ed727ae"
        },
        {
          "id": "bPK40aNYW7olk4LePR1r",
          "name": "Marcelo Biscegli Jatene ",
          "text": "<p><i>Professor associado e livre-docente em Cirurgia Cardiovascular pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Diretor do Serviço de Cirurgia Cardiovascular Infantil do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Coordenador da Cirurgia Cardíaca Pediátrica do Hospital do Coração (HCor).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FbPK40aNYW7olk4LePR1r.png?alt=media&token=9bb00285-07a8-4650-8314-429778a024ef"
        },
        {
          "id": "RKXTtRQhYcbVzqn6S09K",
          "name": "Marcelo Frederigue de Castro ",
          "text": "",
          "image": ""
        },
        {
          "id": "9lMeTcTxlqNY7HCQnI4J",
          "name": "Marcelo Matos Cascudo",
          "text": "<p><i>Cirurgião cardiovascular. Chefe do Serviço de Cirurgia Cardiovascular do Hospital Rio Grande/Incor Natal. Membro titular e ex-presidente da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Atual presidente do Conselho de Administração do complexo hospitalar Rio Grande, Natal (Rio Grande do Norte).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F9lMeTcTxlqNY7HCQnI4J.png?alt=media&token=7f09dec6-4664-43b0-ade9-eec1e1dfe61c"
        },
        {
          "id": "DELixrwkNaxoaXQWBQOE",
          "name": "Marcelo Ribeiro",
          "text": "<p><i>Cardiologista pediátrico e intervencionista em Cardiopatias Congênitas do Instituto Dante Pazzanese de Cardiologia, Hospital do Coração (HCor-SP), São Luiz Rede D’Or e NotreDame Intermédica.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FDELixrwkNaxoaXQWBQOE.png?alt=media&token=bac996fd-2bcf-4cbb-a153-0beb93ae37d5"
        },
        {
          "id": "UyaVScV1eqscIewX3Hl9",
          "name": "Marcelo Sávio da Silva Martins",
          "text": "<p><i>Chefe da Equipe de Cirurgia Cardíaca e vice-diretor do Hospital da Força Aérea do Galeão (Rio de Janeiro). Ex-presidente da Associação dos Cirurgiões Cardíacos do Estado do Rio de Janeiro (ACCERJ).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FUyaVScV1eqscIewX3Hl9.png?alt=media&token=af026f46-3163-4c74-9159-328af83e0e93"
        },
        {
          "id": "quxYsoET9AsI1bwkGwOL",
          "name": "Marco Antonio Ferreira Travessa ",
          "text": "<p><i>Graduação em Medicina pela Universidade Federal do Pará (UFPA). Residência Médica em Cirurgia Cardiovascular pelo Instituto Dante Pazzanese de Cardiologia. Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Cirurgião cardiovascular com atuação em cirurgia cardiovascular pediátrica na Fundação Pública Estadual Hospital de Clínicas Gaspar Vianna (Belém-PA).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FquxYsoET9AsI1bwkGwOL.png?alt=media&token=b6a85f38-c672-4419-8e23-f1a4ebe07f17"
        },
        {
          "id": "MarhnVGRhL3kSSe6uWVY",
          "name": "Marco Antonio Praça Oliveira ",
          "text": "<p><i>Doutor em Ciências pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Diretor da Sociedade de Cirurgia Cardiovascular do Estado de São Paulo (SCICVESP). Atualmente diretor da equipe do prof. Sérgio Almeida de Oliveira, liderando o Departamento de Cirurgia Minimamente Invasiva e Robótica e responsável pelos residentes de Cirurgia Cardiovascular. Speaker da Edwards e Ethicon.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FMarhnVGRhL3kSSe6uWVY.png?alt=media&token=ec2ac1ba-28cc-4c4e-a2f7-f844ca8eaf7a"
        },
        {
          "id": "dmBJ4PuwRRIZOc6Cnjd1",
          "name": "Marco Antonio de Sousa do Vale ",
          "text": "<p><i>Acadêmico de Medicina do nono período no Centro Universitário Tocantinense Presidente Antônio Carlos em Araguaína (Tocantins). Atualmente presidente do Departamento Brasileiro das Ligas Acadêmicas em Cirurgia Cardiovascular (DBLACCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FdmBJ4PuwRRIZOc6Cnjd1.png?alt=media&token=fdafba77-98f5-45e4-9460-554a0746c533"
        },
        {
          "id": "JDupwQyvnXZXKoaikvJo",
          "name": "Marcos Antonio Cantero ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Mestrado e doutorado pela Universidade Federal da Grande Dourados (UFGD). Especialista em Medicina Intensiva pela Associação Médica Brasileira/Associação de Medicina Intensiva Brasileira (AMB/Amib). Professor de Medicina da UFGD.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FJDupwQyvnXZXKoaikvJo.png?alt=media&token=bc649445-b0bb-447c-8db2-229a425bce30"
        },
        {
          "id": "Ew8TnYbLbwnWqjXZZzFH",
          "name": "Marcos Aurélio Barboza de Oliveira ",
          "text": "<p><i>Graduação em Medicina pela Faculdade de Medicina de São José do Rio Preto (Famerp). Especialização em Cirurgia Geral, Cirurgia Cardiovascular e Cirurgia Cardiovascular Pediátrica no Hospital de Base de São José do Rio Preto. Doutorado em Ciências da Saúde pela Famerp. Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Revisor do Brazilian Journal of Cardiovascular Surgery (BJCVS) desde 2006 e editor associado desde 2018. Foi docente do curso de Medicina do Centro Universitário de Votuporanga (Unifev), responsável pelas disciplinas de Estatística e Metodologia Científica, de 2013 até 2016. Professor de Medicina da Universidade Federal do Mato Grosso (UFMT). Cirurgião cardiovascular (adulto e pediátrico) dos Hospitais São Raimundo, Albert Sabin e Hospital do Coração de Messejana em Fortaleza (Ceará).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FEw8TnYbLbwnWqjXZZzFH.png?alt=media&token=c9a33f11-5657-4252-9073-9995d8a2fd89"
        },
        {
          "id": "TawRmR2TVs1QsxUf0Ah3",
          "name": "Marcos Gradim Tiveron ",
          "text": "<p><i>Doutor em Ciências pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Cirurgião cardiovascular da Santa Casa de Misericórdia de Marília e do Hospital das Clínicas de Marília (Famema).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FTawRmR2TVs1QsxUf0Ah3.png?alt=media&token=29a334dc-4b98-4c10-b63b-c94531fa0a48"
        },
        {
          "id": "TuwefVAteYS7W1v2tBc3",
          "name": "Maria Fernanda Silva Jardim",
          "text": "<p><i>Especialista em Cardiologia Pediátrica e em Ecocardiografia pela Sociedade Brasileira de Cardiologia (SBC). Doutora em Ciências pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Médica assistente das unidades de terapia intensiva pediátricas do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Cardiologista pediátrica e coordenadora da Ecocardiografia Pediátrica do Hospital Samaritano.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FTuwefVAteYS7W1v2tBc3.png?alt=media&token=7a0e7bae-937f-45e6-aa67-0b59d63e484a"
        },
        {
          "id": "wgohVuaNKKh1JZpivxge",
          "name": "Maria Victoria Rocha Fontenele Maia",
          "text": "<p><i>Acadêmica de Medicina do sétimo semestre do Centro Universitário Unichristus. Aluna participante da Liga Acadêmica de Neurociências, Liga de Pediatria e Escola de Pediatria do Instituto do Coração da Criança e do Adolescente (InCor Criança). Pesquisadora com Iniciação Científica nas áreas de Cardiologia e Neurologia.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FwgohVuaNKKh1JZpivxge.png?alt=media&token=4db48513-8974-43fb-add8-46657cf2bc65"
        },
        {
          "id": "ksgFBN706h9DXrcpd5fE",
          "name": "Mariana Chisté Ferreira",
          "text": "",
          "image": ""
        },
        {
          "id": "3iXSPnIzLwdxAoj1mTpS",
          "name": "Matheus Sant’Anna de Oliveira Gonçalves ",
          "text": "<p><i>Acadêmico de Medicina pela Universidade Federal do Ceará (UFC). Membro da Liga de Cirurgia Cardiovascular (LCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F3iXSPnIzLwdxAoj1mTpS.png?alt=media&token=76a2538a-a512-4096-abdf-426e8a040557"
        },
        {
          "id": "PKjfvOcxsrIemox3jl4E",
          "name": "Mauro Barbosa Arruda Filho ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Mestre e doutor em Cirurgia pela Universidade Federal de Pernambuco (UFPE). Cirurgião do Real Hospital Português e do Pronto-Socorro Cardiológico de Pernambuco (Procape).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FPKjfvOcxsrIemox3jl4E.png?alt=media&token=9bd093c9-1753-4455-9d50-c23138d7fd11"
        },
        {
          "id": "dzKLi1kcJnITqT121rO9",
          "name": "Mauro Paes Leme de Sá ",
          "text": "<p><i>Diretor do Instituto do Coração Edson Saad (ICES-UFRJ). Chefe do Serviço de Cirurgia Cardíaca Hospital Universitário da Universidade Federal do Rio de Janeiro (UFRJ). Professor associado do Departamento de Cirurgia da Faculdade de Medicina da UFRJ. Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Membro da European Association for Cardio-Thoracic Surgery (EACTS).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FdzKLi1kcJnITqT121rO9.png?alt=media&token=097828ab-a805-4fe9-8ef4-a780618996f4"
        },
        {
          "id": "wQvCDxqKx3hrExuXNGmz",
          "name": "Maurílio Onofre Deininger ",
          "text": "<p><i>Cirurgião cardiovascular com título de especialista pela Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Doutorado e pós-doutorado em Medicina pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Ex-presidente da Sociedade Norte-Nordeste de Cirurgia Cardiovascular (SNNCCV). Médico cirurgião cardiovascular na cidade de João Pessoa (Paraíba). Atua nos hospitais Unimed, Memorial São Francisco, Nossa Senhora das Neves e Metropolitano.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FwQvCDxqKx3hrExuXNGmz.png?alt=media&token=c2953c43-66a5-4654-bcef-9c81dbeeb56b"
        },
        {
          "id": "CAXRyYBoEGo7TzzuYL31",
          "name": "Melchior Luiz Lima ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Doutor em Cirurgia Cardiovascular pela Universidade Federal de São Paulo (Unifesp).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FCAXRyYBoEGo7TzzuYL31.png?alt=media&token=86762866-959e-467a-804b-23e265303ab4"
        },
        {
          "id": "bLV5BRFJqwEkinXaN4M2",
          "name": "Melina Moroz Barg",
          "text": "<p><i>Graduada em Medicina na Argentina, com o diploma validado no Brasil pela Universidade Federal do Paraná. Atualmente, especializando-me em Cirurgia Cardiovascular no Instituto do Coração Dante Pazzanese em São Paulo. Membro da Society of Thoracic Surgeons , STS, e faco &nbsp;parte do Comitê de Filantropia da Associação Nacional dos Médicos Residentes.&nbsp;Apaixonada por trabalho humanitário, realiza voluntariado no Iraque, Uganda, Amazônia e Quênia.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FbLV5BRFJqwEkinXaN4M2.png?alt=media&token=ab88f671-f3db-4947-b1fe-78e5bae48714"
        },
        {
          "id": "3fH1Rx0qhLEqTM6Jqfw3",
          "name": "Milton Ary Meier ",
          "text": "",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F3fH1Rx0qhLEqTM6Jqfw3.png?alt=media&token=360ea7ae-e29c-468c-a902-2c947f128d3e"
        },
        {
          "id": "R3R27SD1RXJN10IYECch",
          "name": "Milton Maluhy Filho",
          "text": "<p><i>Presidente do Itaú Unibanco desde fevereiro de 2021. De 2019 a 2020, atuou como vice-presidente de Finanças e Riscos do banco. Também foi CEO do Banco Itaú CorpBanca, no Chile, de 2016 a 2018, onde liderou o processo de integração entre o CorpBanca e o Banco Itaú Chile. Entre 2012 e 2015, além de diretor-presidente da Redecard S.A., empresa de meios de pagamento eletrônicos do Itaú Unibanco, atuou também como diretor-executivo do banco responsável pela área de cartões de crédito e parcerias com grandes varejistas. Nascido em 1976, em São Paulo, Brasil, Milton está há 22 anos na organização e se tornou sócio em 2011. Nesse período, ocupou posições de liderança no Itaú BBA, nas áreas internacional, de produtos, de operações, na tesouraria, na mesa de clientes, além de ter atuado como diretor comercial do Corporate and Investment Bank.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FR3R27SD1RXJN10IYECch.png?alt=media&token=cf7fbcbf-634c-4c8b-bd6b-b0e6a6e83360"
        },
        {
          "id": "nogq5P5D7b3aSVHF6goW",
          "name": "Milton de Miranda Santoro ",
          "text": "<p><i>Cirurgião torácico e cardiovascular dos hospitais Pilar/Hospital Care, Angelina Caron, Santa Cruz/Rede D’Or.&nbsp;Membro da International Society for Minimally Invasive Cardiac Surgery (ISMICS).&nbsp;Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Membro adjunto do Colégio Brasileiro de Cirurgiões (CBC). Coordenador da Pós-Graduação em Cirurgia Cardiovascular Minimamente Invasiva da UniCaron/Scolla.</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fnogq5P5D7b3aSVHF6goW.png?alt=media&token=e9bbb8a4-d9a7-4b9a-9f23-52141009d7ee"
        },
        {
          "id": "ubeKErl515Mt9yaGHqi3",
          "name": "Moisés Barbosa de Andrade ",
          "text": "<p><i>Estudante de Medicina do sexto ano da Universidade Federal de Minas Gerais (UFMG). Seu foco é o tratamento cirúrgico de doenças cardiovasculares. Diretor de estágios do DBLACCV na gestão 2023. Durante sua trajetória acadêmica, atuou como coordenador da Liga Acadêmica de Cirurgia Cardiotorácica da UFMG (LCCT-UFMG) e monitor de Cirurgia, participando de vários mutirões de cirurgia em Minas Gerais. Atuou como pesquisador assistente em projeto que investiga pacientes diagnosticados com febre reumática com tratamento cirúrgico cardiovascular no Hospital das Clínicas da UFMG. Possui interesse em Cirurgia Cardíaca e Medicina de Emergência.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FubeKErl515Mt9yaGHqi3.png?alt=media&token=a5162ce8-5015-4659-8dff-ef3c6c88c608"
        },
        {
          "id": "UFJ3Ac1G2vumQDKpdZpH",
          "name": "Mário Ricardo Amar ",
          "text": "<p><i>Mestre em medicina pela Universidade Estadual do Rio de Janeiro (Uerj). Título de especialista pela Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Cirurgião do Complexo Hospitalar de Niterói, do Américas Medical City e do Hospital Universitário Pedro Ernesto-Uerj.</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FUFJ3Ac1G2vumQDKpdZpH.png?alt=media&token=efde99f2-9f52-40ff-afb7-ed633e037bac"
        },
        {
          "id": "D2cTwd9pATkdowb98vkW",
          "name": "Nadja Cecília de Castro Kraychete ",
          "text": "<p><i>Coordenadora do Serviço de Cirurgia Cardiovascular Pediátrica do Hospital Ana Nery e coordenadora de equipe nas instituições Santa Casa da Bahia, Centro Ítalo-Brasileiro de Promoção Sanitária, Hospital Aliança e Hospital Santo Amaro. Tem experiência na área de Cirurgia Cardiovascular Pediátrica e Adulto.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FD2cTwd9pATkdowb98vkW.png?alt=media&token=ba55faa4-af5b-4651-89ed-d87ff46f5c92"
        },
        {
          "id": "xBlS67SuCxOdyLWhi7zs",
          "name": "Nelson Américo Hossne Júnior",
          "text": "<p><i>Professor adjunto e Chefe da Disciplina de Cirurgia Cardiovascular da Universidade Federal de São Paulo (Unifesp).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FxBlS67SuCxOdyLWhi7zs.png?alt=media&token=cfd6b775-3002-44fc-aad2-3b842f9bab97"
        },
        {
          "id": "0qhPHbRIIKFp5Na5NXvN",
          "name": "Noedir Antonio Groppo Stolf ",
          "text": "<p><i>Professor emérito e sênior da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Professor titular aposentado de Cirurgia Cardiovascular. Ex-diretor da Divisão Cirúrgica e Presidente do Conselho Diretor do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F0qhPHbRIIKFp5Na5NXvN.png?alt=media&token=a590026c-21c4-4464-9e0d-43eb689b04f9"
        },
        {
          "id": "LGhSU3EWefWIrNY8DH39",
          "name": "Omar Asdrubal Vilca Mejia ",
          "text": "<p><i>Vice-presidente do Capítulo Brasileiro da Enhanced Recovery After Surgery (ERAS) Society. Professor livre-docente de Cirurgia Cardiovascular do Departamento de Cardiopneumologia da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Docente permanente do Programa de Pós-Graduação (Doutorado) em Cirurgia Torácica e Cardiovascular da FMUSP. Cirurgião assistente da Unidade Cirúrgica de Coronariopatias do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Coordenador da Unidade Cirúrgica de Qualidade e Segurança do InCor-HCFMUSP. Diretor do Registro Paulista de Cirurgia Cardiovascular (REPLICCAR). Harvard Alumni.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FLGhSU3EWefWIrNY8DH39.png?alt=media&token=d3789760-97df-4b88-8c58-26c13da491a7"
        },
        {
          "id": "tMtH7TBX5OeR4DXgaTF6",
          "name": "Pablo Maria A. Pomerantzeff ",
          "text": "<p><i>Professor associado livre-docente da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Diretor da Unidade Cirúrgica de Cardiopatias Valvares do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FtMtH7TBX5OeR4DXgaTF6.png?alt=media&token=96554c21-a876-4c8d-9e05-bddbead5d2d7"
        },
        {
          "id": "swv5sDij38nzPP0LGPX0",
          "name": "Paola Keese Montanhesi ",
          "text": "<p><i>Graduação em Medicina pela Faculdade de Ciências Médicas da Universidade Estadual de Campinas (Unicamp). Especialização em Cirurgia Cardiovascular pela equipe do Dr. José Pedro da Silva na Beneficência Portuguesa de São Paulo (BP). Título de especialista pela Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Título de Atuação em Estimulação Elétrica Cardíaca Implantável. Membro da International Society for Minimally Invasive Cardiac Surgery (ISMICS). Atuou durante 6 anos como cirurgiã no Grupo de Transplante Cardíaco do Hospital Israelita Albert Einstein (HIAE), tendo adquirido vasta experiência em Transplante Cardíaco e Assistência Circulatória Mecânica. Pelo mesmo período, integrou a equipe de Cirurgia Cardíaca Minimamente Invasiva e Robótica do HIAE e do Hospital Moriah sob a coordenação do Dr. Robinson Poffo. Experiência em Terapia Intensiva, com destaque para extensa atuação em UTI cardiológica. Programa de Fellowship em Cirurgia Cardíaca Minimamente Invasiva na Western University em London (Ontário, Canadá).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2Fswv5sDij38nzPP0LGPX0.png?alt=media&token=79766894-51dc-4a85-9554-ebd5347fc116"
        },
        {
          "id": "ErQ9Pd1VpuabuXHgLpfn",
          "name": "Patrícia Cristina Celestino",
          "text": "<p><i>Acadêmica de Medicina do nono período da Universidade do Estado do Rio de Janeiro (Uerj). Diretora do Departamento Brasileiro de Ligas Acadêmicas de Cirurgia Cardiovascular (DBLACCV). Presidente da Liga Acadêmica de Cirurgia Cardiovascular Professor Waldir Jazbik (Lacic-Uerj).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FErQ9Pd1VpuabuXHgLpfn.png?alt=media&token=281b6630-0369-4318-ba00-faa4c71eabc3"
        },
        {
          "id": "BQ1OXriXdZWCo3YpsGHb",
          "name": "Paulo César Santos ",
          "text": "<p><i>Residência Médica no Instituto Dante Pazzanese de Cardiologia, com mestrado e doutorado pela Escola Paulista de Medicina da Universidade Federal de São Paulo (EPM-Unifesp). Certificação em Cirurgia Robótica e Cirurgia Cardiovascular Minimamente Invasiva, Mayo Clinic, Nashville (EUA) Hospital St Thomas&nbsp;e Heart Center Leipzig (Alemanha).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FBQ1OXriXdZWCo3YpsGHb.png?alt=media&token=75a79894-479a-469a-b05b-1eb34bda2960"
        },
        {
          "id": "3YKHsRROT0UV32P4W7Wm",
          "name": "Paulo Manuel Pêgo-Fernandes ",
          "text": "<p><i>Professor titular do Departamento de Cardiopneumologia da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Diretor da Divisão de Cirurgia Torácica e presidente da Comissão Científica do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Vice-diretor da FMUSP.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F3YKHsRROT0UV32P4W7Wm.png?alt=media&token=30f019a1-14aa-4baa-9aa0-6a1ffeca9f72"
        },
        {
          "id": "HpAQ9NQjmjwtFQlGbFXQ",
          "name": "Paulo Roberto Barbosa Evora ",
          "text": "<p><i>Graduação em Medicina na Faculdade de Medicina de Ribeirão Preto da Universidade de São Paulo (FMRP-USP), onde também realizou sua residência de Cirurgia Geral e Cirurgia Torácica e Cardiovascular e defendeu sua tese de doutorado. Possui uma extensa trajetória de pesquisa e ensino, sendo professor titular na mesma instituição. Atual editor-chefe do Brazilian Journal of Cardiovascular Surgery (BJCVS).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FHpAQ9NQjmjwtFQlGbFXQ.png?alt=media&token=9221a4cf-bcbe-4a75-8559-af90ed17293a"
        },
        {
          "id": "mhJB0SuYtcugC3F5N1MT",
          "name": "Paulo Roberto Lunardi Prates ",
          "text": "<p><i>Cirurgião cardiovascular, chefe do Serviço de Cirurgia Cardíaca do Hospital da Criança Santo Antônio. Cirurgião cardiovascular do Serviço de Cirurgia Cardíaca do Instituto de Cardiologia do Rio Grande do Sul. Fellow em Cirurgia Cardiovascular no Texas Heart Institute, Houston (EUA). Membro especialista em Cirurgia Cardiovascular pela Sociedade Brasileira de Cirurgia Cardiovascular/Associação Médica Brasileira (SBCCV/AMB). Doutorado em Ciências da Saúde no Instituto de Cardiologia/Fundação Universitária de Cardiologia do Rio Grande do Sul (IC-FUC), em conjunto com Duke University.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FmhJB0SuYtcugC3F5N1MT.png?alt=media&token=8b2a8453-0c7b-4928-9079-56fcd2608caf"
        },
        {
          "id": "MNTt0PEzSWSglNXPwjY3",
          "name": "Paulo Roberto Slud Brofman ",
          "text": "<p><i>Cirurgião cardiovascular da Santa Casa de Curitiba e do Hospital Angelina Caron em Campina Grande do Sul (Paraná). Professor titular da Escola de Medicina da Pontifícia Universidade Católica do Paraná (PUCPR). Acadêmico titular da Academia Paranaense de Medicina. Ex-presidente da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Ex-presidente do Grupo de Arritmias da Sociedade Brasileira de Arritmias Cardíacas (Sobrac) e do Departamento de Estimulação Cardíaca Artificial (Deca-SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FMNTt0PEzSWSglNXPwjY3.png?alt=media&token=88e4af0b-8819-4a57-8086-d5f9d3de73ad"
        },
        {
          "id": "Vi7pRxvylrR04dvejEdS",
          "name": "Pedro Antônio Machado Gomes de Sousa",
          "text": "",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FVi7pRxvylrR04dvejEdS.png?alt=media&token=8ece7e51-294d-4797-849a-9690f2ad60d3"
        },
        {
          "id": "2oZM3ijS6gEUTE35FuN5",
          "name": "Pedro Borghesi Poltronieri ",
          "text": "<p><i>Residente de Cirurgia Cardiovascular (2° Ano) pelo Centro Universitário Faculdade de Medicina do ABC (FMABC).&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F2oZM3ijS6gEUTE35FuN5.png?alt=media&token=c866423f-48d6-4cf1-b6f5-78ac9c57c5a4"
        },
        {
          "id": "H9CVSu5K8Ny6oNcU3m5A",
          "name": "Pedro Farsky",
          "text": "<p><i>Doutor em Ciências pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Pós-doutorado em Cardiologia pelo Instituto Dante Pazzanese de Cardiologia. Professor pleno de pós-graduação pelo programa USP-IDPC.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FH9CVSu5K8Ny6oNcU3m5A.png?alt=media&token=c2702965-15f8-4e50-afd1-864fa07209ca"
        },
        {
          "id": "Y7YRZxn97HFtIcRvaG19",
          "name": "Pedro Gregori Neto",
          "text": "<p><i>Formado em Medicina pela Universidade Brasil. Residência pelo Serviço de Cirurgia Cardiovascular do Norte do Paraná. Membro da Associação Brasileira dos Residentes de Cirurgia Cardiovascular (ABRECCV). Membro diretório da ABRECCV, gestão 2023-2024.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FY7YRZxn97HFtIcRvaG19.png?alt=media&token=0ce06c34-e2ca-44e4-9812-8c530c5e33b9"
        },
        {
          "id": "ZSAm1sNI0J0iTAAEqc9L",
          "name": "Pedro Rafael Salerno ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Ex-presidente do Departamento de Cirurgia Cardíaca Pediátrica da SBCCV (2022-2023). Diretor de Departamentos Especializados da SBCCV. Doutor em Cirurgia Cardiovascular pela Universidade de São Paulo (USP). Cirurgião cardiovascular do Pronto-Socorro Cardiológico de Pernambuco (Procape). Professor da Faculdade de Medicina da Universidade Católica de Pernambuco (Unicap).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FZSAm1sNI0J0iTAAEqc9L.png?alt=media&token=34fc1ac5-cd18-45b1-a0d6-24c1bcd64c60"
        },
        {
          "id": "av5zEU5opRhtGuSuvcda",
          "name": "Protásio Lemos da Luz",
          "text": "<p><i>Professor titular sênior de Cardiologia do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Membro titular da Academia Brasileira de Ciências (ABC). Fundador e presidente da Associação Brasileira de Cardiologia Translacional (ABCT).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fav5zEU5opRhtGuSuvcda.png?alt=media&token=d4a5c6f0-4245-45ff-938a-dfd6a247e855"
        },
        {
          "id": "C94LtHfX2nQs7a4Pyf4t",
          "name": "Raúl Armando Micalay Paredes",
          "text": "<p><i>Cirurgião cardiovascular no Hospital São Vicente de Paulo (Mafra-SC). Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Professor na Universidade do Contestado (Mafra-SC).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FC94LtHfX2nQs7a4Pyf4t.png?alt=media&token=8396557f-69a8-4c0f-8dc3-1c939d86fac7"
        },
        {
          "id": "ZeUASbaH73pXVwiQyQE9",
          "name": "Renata Cassar",
          "text": "<p><i>Médica Ecocardiografista na Instituto do Coração - InCor HCFMUSP.&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FZeUASbaH73pXVwiQyQE9.png?alt=media&token=708a9356-d29b-4c16-ad91-0ad5294faeab"
        },
        {
          "id": "ZebI3mSmhsWZHYTKRcsw",
          "name": "Renato Abdala Karam Kalil ",
          "text": "<p><i>Professor emérito do Programa de Pós-Graduação da Fundação Universitária de Cardiologia. Coordenador do Núcleo de Cardiopatias Congênitas do Hospital Moinhos de Vento. Professor titular aposentado de Clínica Cirúrgica da Universidade Federal de Ciências da Saúde de Porto Alegre (UFCSPA). Membro titular da Academia Sul-Rio-Grandense de Medicina. Cirurgião cardiovascular com atuação nos hospitais Moinhos de Vento, Divina Providência, Mãe de Deus e Instituto de Cardiologia, em Porto Alegre (Rio Grande do Sul).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FZebI3mSmhsWZHYTKRcsw.png?alt=media&token=b3f7980a-20bb-49c4-a565-8ee8161f6dc7"
        },
        {
          "id": "U75AfgIWBMJIX8J6CWzb",
          "name": "Renato Bastos Pope ",
          "text": "<p><i>Coordenador do Serviço de Cirurgia Cardiovascular do Hospital Hans Dieter Schmidt em Joinville (Santa Catarina). Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FU75AfgIWBMJIX8J6CWzb.png?alt=media&token=331486e3-e7ce-4ebc-9883-f06db800a9ab"
        },
        {
          "id": "dSLHPzKH0oiuukq43W10",
          "name": "Renato Samy Assad ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Professor livre-docente da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Cirurgião cardiovascular do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP).&nbsp;Fellow do Children's Hospital, Harvard Medical School, EUA.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FdSLHPzKH0oiuukq43W10.png?alt=media&token=8d79b95b-ac85-434b-bf9b-d90afa022edf"
        },
        {
          "id": "8Map0XjSF9QFrEjbJ8Uj",
          "name": "Renato Tambellini Arnoni ",
          "text": "<p><i>Cirurgião cardiovascular do Instituto Dante Pazzanese de Cardiologia e do Hospital Edmundo Vasconcelos. Doutor em Ciências pela Universidade de São Paulo (USP). Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Presidente da Sociedade de Cirurgia Cardiovascular do Estado de São Paulo (SCICVESP). Diretor técnico do Hospital Edmundo Vasconcelos.</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F8Map0XjSF9QFrEjbJ8Uj.png?alt=media&token=f191d6dd-4dda-4f98-a29f-44fee2c45860"
        },
        {
          "id": "JUoLceN6nVddGAiBiJzn",
          "name": "Ricardo Adala Benfatti ",
          "text": "<p><i>Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Membro especialista em Cardiologia pela Sociedade Brasileira de Cardiologia (SBC). Mestre e doutor em Cirurgia Cardiovascular. Professor adjunto de Cirurgia Cardiovascular da Universidade Federal de Mato Grosso do Sul (UFMS).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FJUoLceN6nVddGAiBiJzn.png?alt=media&token=5f1d2b92-5a97-425f-98db-3a5b8d3a065d"
        },
        {
          "id": "31vhJSp1Mbrc88Ld13or",
          "name": "Ricardo José Choma ",
          "text": "<p><i>Formação médica pela UFPR 1998. Residência em Cirurgia Torácica e Cardiovascular 2002 Hospital Clínicas PR. Chefe Serviço Cirurgia Cardiovascular Hospital São José Criciúma - SC</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F31vhJSp1Mbrc88Ld13or.png?alt=media&token=ea03afdf-08ef-4f3c-80a3-d79bfc43ec1a"
        },
        {
          "id": "FosE0Q7Hd7wjyEK2oIww",
          "name": "Ricardo Nilsson Sgarbieri ",
          "text": "<p><i>Formado pela Faculdade Medicina de Ribeirão Preto da Universidade de São Paulo (FMRP-USP). Especialista em Cirurgia Cardiovascular pela Sociedade Brasileira de Cirurgia Cardiovascular/Associação Médica Brasileira (SBCCV/AMB). Mestrado e doutorado em Cirurgia Cardiovascular pela Universidade Estadual de Campinas (Unicamp).&nbsp;</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FFosE0Q7Hd7wjyEK2oIww.png?alt=media&token=3fd0ef39-5497-463c-8d10-3c641454b7f5"
        },
        {
          "id": "D3b9IRaPTShCijED1knv",
          "name": "Ricardo Pavanello",
          "text": "<p><i>Chefe da Seção de Coronariopatias do Instituto Dante Pazzanese de Cardiologia. Doutor em Ciências pela Universidade de São Paulo (USP). Fellow da European Society of Cardiology (ESC).&nbsp;</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FD3b9IRaPTShCijED1knv.png?alt=media&token=b513e725-aac3-4062-8b72-218051aa0eb4"
        },
        {
          "id": "9k0EGRTP67Xcz878MBZa",
          "name": "Ricardo Ribeiro Dias ",
          "text": "<p><i>Médico responsável pela Unidade Cirúrgica de Miocardiopatias e Doenças da Aorta do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Professor livre-docente do Departamento de Cirurgia Cardiovascular da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Professor colaborador da FMUSP. Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F9k0EGRTP67Xcz878MBZa.png?alt=media&token=847d8a09-7902-4e71-a295-37be786f0f0d"
        },
        {
          "id": "GkPljbxZKTpR5XQl9nze",
          "name": "Ricardo de Carvalho Lima ",
          "text": "<p><i>Professor titular da Faculdade de Ciências Médicas da Universidade de Pernambuco (FCM-UPE). Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Membro efetivo da American Association for Thoracic Surgery (AATS). Diretor geral do Pronto-Socorro Cardiológico de Pernambuco (Procape/UPE) – Hospital do Coração Prof. Luiz Tavares.&nbsp;</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FGkPljbxZKTpR5XQl9nze.png?alt=media&token=108ac212-0827-4d4e-8855-501ea654574d"
        },
        {
          "id": "akUPKrpWe1E9PFpHU5Bm",
          "name": "Roberto Costa ",
          "text": "<p><i>Professor associado da disciplina de Cirurgia Cardiovascular da Faculdade de Medicina da Universidade de São Paulo (FMUSP). Diretor da Unidade Cirúrgica de Estimulação Elétrica e Marca-Passo do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FakUPKrpWe1E9PFpHU5Bm.png?alt=media&token=94e60d6b-e6e1-4e39-bba0-7e2f49236fee"
        },
        {
          "id": "VfFO3FTnWduNYdCq9nCY",
          "name": "Robinson Poffo ",
          "text": "<p><i>Diretor do Instituto Poffo de Cirurgia Cardiovascular (São Paulo). Chefe do Serviço de Cirurgia Cardíaca do Hospital Moriah. Cirurgião cardíaco robótico do Hospital Israelita Albert Einstein (HIAE).</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FVfFO3FTnWduNYdCq9nCY.png?alt=media&token=4afa9ab1-d6d1-4dae-b7ed-f98838ed9ffa"
        },
        {
          "id": "YcEGvs1EHY5MaUR0DcWL",
          "name": "Rodrigo Coelho Segalote ",
          "text": "<p><i>Chefe da Divisão de Cirurgia do Instituto Nacional de Cardiologia. Responsável técnico do Transplante Cardíaco do Hospital São Lucas Copacabana. Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FYcEGvs1EHY5MaUR0DcWL.png?alt=media&token=0b293ea9-74af-45f6-b22f-de728209bd4e"
        },
        {
          "id": "tTSG956F1D7kvRqE2par",
          "name": "Rodrigo Freire Bezerra",
          "text": "<p><i>Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Formação em Cirurgia Cardiovascular pela equipe do prof. dr. José Pedro da Silva. Cirurgião responsável pelo Serviço de Cirurgia Cardíaca Congênita da Beneficência Portuguesa de São Paulo (BP). Especialista em ECMO pela Extracorporeal Life Support Organization (ELSO).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FtTSG956F1D7kvRqE2par.png?alt=media&token=6d04d8f3-720b-4b88-a27d-f5f43db5f040"
        },
        {
          "id": "A7jqjS8rC7rBiqvdwK9b",
          "name": "Romullo Medeiros Santos",
          "text": "<p><i>Graduação em Medicina pela Universidade de Brasília (UnB). Residência Médica em Cirurgia Geral pela Universidade Estadual de Campinas (Unicamp). Residência Médica em Cirurgia Cardiovascular e fellowship em Cirurgia de Aorta pelo Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-FMUSP) Atualmente é cirurgião assistente do Grupo de Cardiopatias Valvares do InCor-HCFMUSP. Tem experiência na área de Cirurgia, com ênfase em Cirurgia Cardiovascular.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FA7jqjS8rC7rBiqvdwK9b.png?alt=media&token=44fba320-24ff-423b-975d-14d75cfa8872"
        },
        {
          "id": "2P5sB0hUpZwpUaAScd6H",
          "name": "Ronaldo Honorato Barros Santos",
          "text": "<p><i>Graduação em Medicina pela Pontifícia Universidade Católica de São Paulo (PUCSP). Médico perito militar no HGE-SP durante o ano de 1993. Residência Médica em Cirurgia Geral pela PUCSP. Residência Médica em Cirurgia Cardiovascular pelo Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Médico assistente da Unidade Cirúrgica de Pós-Operatório do InCor-HCFMUSP de 1999 a 2003. Médico assistente da Divisão de Cirurgia do Departamento de Cardiopneumologia do InCor-HCFMUSP de 2003 até a presente data. Médico assistente do Grupo de Transplante Cardíaco do InCor-HCFMUSP de 2005 até a presente data. Médico de graduação da Faculdade de Medicina da Universidade de São Paulo (FMUSP) de 2007 até a presente data. Médico coordenador da Residência Especializada (Transplante Cardíaco) de 2008 até a presente data.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F2P5sB0hUpZwpUaAScd6H.png?alt=media&token=542c1e20-fa88-4da8-9902-4d18db3b0260"
        },
        {
          "id": "n9Z6BDJ50t5jBtPyY8Bb",
          "name": "Rubens Tofano de Barros ",
          "text": "<p><i>Membro do Serviço de Cirurgia Cardíaca e Marca-passo da Santa Casa de Misericórdia de Marília.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2Fn9Z6BDJ50t5jBtPyY8Bb.png?alt=media&token=3915ad09-b555-49a3-8298-bdad66f24d81"
        },
        {
          "id": "pHopGlaMmGboS9s4ZJPk",
          "name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
          "text": "<p><i>Professor associado e coordenador do curso de Medicina do Centro Universitário Fundação Assis Gurgacz. Diretor de Educação e 18º Presidente da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).&nbsp;Presidente eleito da Latin American Association of Cardiac and Endovascular Surgery (Laces). Presidente da World Society of Cardiovascular and Thoracic Surgeons (WSCTS).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FpHopGlaMmGboS9s4ZJPk.png?alt=media&token=7464e997-3e01-4fa7-baa8-17e98bc49bf3"
        },
        {
          "id": "TNegaNCo8I6SdabN45Gc",
          "name": "Samuel Padovani Steffen ",
          "text": "<p><i>Médico da Divisão de Cirurgia e cirurgião do Grupo de Transplante Cardíaco do Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Coordenador cirúrgico do Transplante Cardíaco da Rede D’Or (São Paulo). Especialista pela Sociedade Brasileira de Cirurgia Cardiovascular/Associação Médica Brasileira (SBCCV/AMB). Doutorando no InCor-HCFMUSP.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FTNegaNCo8I6SdabN45Gc.png?alt=media&token=b335d0ff-3f26-47f0-9d33-b00a3e6f6b7e"
        },
        {
          "id": "GA6Ncov8tW6bXJW5541J",
          "name": "Sandro Valério Fadel ",
          "text": "<p><i>Graduação pela Fundação Universidade Regional de Blumenau (Furb). Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV) desde 2007. Certificado de atuação na área de Estimulação Cardíaca Eletrônica Implantável. Atuação na área de Cirurgia Endovascular. Pós-graduação em Cirurgia Cardiovascular Minimamente Invasiva. Supervisor e preceptor da Residência Médica em Cirurgia Cardiovascular no Hospital Maternidade Marieta Konder Borhnausen, Itajaí (Santa Catarina). Coordenador e chefe do Serviço de Cirurgia Cardiovascular no Hospital Maternidade Marieta Konder Borhausen e no Hospital Unimed Litoral em Balneário Camboriú. Chefe do Serviço de Cirurgia Cardiovascular no Hospital do Coração, em Balneário Camboriú, e do Hospital Arquidiocesano Cônsul Carlos Renaux, em Brusque.</i></p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FGA6Ncov8tW6bXJW5541J.png?alt=media&token=41f6eea3-70cf-464f-94fc-101f7da0c52b"
        },
        {
          "id": "UjsGdYOu19nGJtuSpmwE",
          "name": "Shai Tejmam-Yarden",
          "text": "<p><i>Médico assistente no Edmond and Lily Safra Congenital Heart Center no Sheba Medical Center. Desde 2015, dirige o laboratório de Pesquisa Médica de Engenharia no Safra Congenital Heart Center e desde 2022 dirige o BioEngineering Hub no ARC Innovation Center no Sheba Medical Center.</i></p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FUjsGdYOu19nGJtuSpmwE.png?alt=media&token=e70d57da-eb99-46d8-bf7f-2303e61db143"
        },
        {
          "id": "1mnU1YxNND7gFlsAt2Rg",
          "name": "Shirlyne Fabianni Dias Gaspar ",
          "text": "<p><i>Graduação em Medicina pela Universidade Federal do Maranhão (UFMA). Residência Médica em Cirurgia Geral pelo Hospital Universitário da UFMA. Residência Médica em Cirurgia Cardiovascular pelo Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (InCor-HCFMUSP). Fellowship em Transplante Cardíaco e Assistência Circulatória Mecânica pelo InCor-HCFMUSP.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F1mnU1YxNND7gFlsAt2Rg.png?alt=media&token=b687f16a-5e4e-42e3-9331-e3ff21986c0b"
        },
        {
          "id": "1ZdmwujB8VCbexteCWYD",
          "name": "Suely Fazio Ferraciolli",
          "text": "<p><i>Neurorradiologista do Instituto de Radiologia (InRad) e do Instituto da Criança (ICr) do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (HCFMUSP).&nbsp;Post doctoral research fellow do Massachusetts General Hospital, Harvard School of Medicine.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F1ZdmwujB8VCbexteCWYD.png?alt=media&token=ff202630-dd4d-4df8-9d3c-f8de6d37370d"
        },
        {
          "id": "ThV5wKk60ERXMcvhChfj",
          "name": "Sérgio Francisco dos Santos Júnior ",
          "text": "<p><i>Cirurgião cardiovascular pela Beneficência Portuguesa de São Paulo (BP). Chefe do Serviço de Cirurgia Cardiovascular do Hospital Ágape, Arapiraca (Alagoas). Ex-presidente da Associação Brasileira dos Residentes de Cirurgia Cardiovascular (ABRECCV). Escritor e palestrante. Criador dos programas de Posicionamento Médico Digital (PMD).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FThV5wKk60ERXMcvhChfj.png?alt=media&token=329dd8af-f3fc-4cb8-bb67-b787e7b70aa3"
        },
        {
          "id": "1sRBX2OvshSSNxP35bWs",
          "name": "Sérgio Lima de Almeida ",
          "text": "<p><i>Cirurgião cardiovascular. Chefe do Serviço de Cirurgia Cardiovascular do Hospital SOS Cardio, Florianópolis. Professor de Cirurgia Cardiovascular da Universidade Unisul – Pedra Branca. Membro da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2F1sRBX2OvshSSNxP35bWs.png?alt=media&token=eeda6b72-47cc-4a80-b962-ad0b23afaf38"
        },
        {
          "id": "F8mhUjSkc2ALWeIIC2ND",
          "name": "Sérgio Montenegro",
          "text": "<p><i>Doutor em Medicina pela Universidade Federal de São Paulo (Unifesp). Chefe do Setor de Doença Coronariana do Pronto-Socorro Cardiológico de Pernambuco (Procape). Diarista da Unidade Coronária do Hospital Esperança Recife – Rede D'Or. Membro do Conselho Administrativo da Sociedade Brasileira de Cardiologia (SBC).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FF8mhUjSkc2ALWeIIC2ND.png?alt=media&token=f2b449bc-056b-44e9-a4c0-aaa4a42ebb37"
        },
        {
          "id": "5q4e8ZV6KSSHFKZhPVit",
          "name": "Sérgio da Costa Rayol",
          "text": "<p><i>Membro Titular da SBCCV. Mestre em Ciências da Saúde pela Universidade de Pernambuco(UPE). Doutorando em Ciências da Saúde pela Universidade de Pernambuco(UPE). Preceptor da Residência de Cirurgia Cardiovascular e de Cardiologia do Procape, Universidade de Pernambuco e Hospital das Clinicas da Universidade Federal de Pernambuco. Especialista em Cardiologia pela SBC</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2F5q4e8ZV6KSSHFKZhPVit.png?alt=media&token=73c2a950-bc49-4bc2-a919-a64a8876146d"
        },
        {
          "id": "XH4vlBYwp2pAMtDRhmpA",
          "name": "Thiago Leite Luz",
          "text": "",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FXH4vlBYwp2pAMtDRhmpA.png?alt=media&token=efd581f9-b0b0-4084-a57f-dbfff5ae4134"
        },
        {
          "id": "YGwJOfZCLXRbZ1cEFTO8",
          "name": "Thiana Yamaguti",
          "text": "<p><i>Graduação pela Faculdade de Medicina da Universidade de São Paulo (FMUSP). Doutorado em Ciências pela FMUSP. Residência em Anestesiologia pelo Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (HCFMUSP). Foi médica preceptora da Residência de Anestesiologia da FMUSP. Atua no Instituto do Coração do HCFMUSP e no Hospital e Maternidade Sepaco – Unidade Vila Mariana.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2FYGwJOfZCLXRbZ1cEFTO8.png?alt=media&token=fc4415d5-cd83-4ad5-be53-785a398b14de"
        },
        {
          "id": "J4MHBqTrgrbAoT4pGzV4",
          "name": "Torsten Doenst ",
          "text": "<p><i>Heisenberg professor of Cardiac Surgery. Department of Cardiothoracic Surgery, University of Jena (chairman and chief 2010).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FJ4MHBqTrgrbAoT4pGzV4.png?alt=media&token=2c190e9d-8505-4b7e-ba62-ab832d04fe0d"
        },
        {
          "id": "knPKVy27FPLqJGcHj9Hs",
          "name": "Valdano Mateus Correia Osório Manuel",
          "text": "<p><i>Cirurgião cardiovascular de adultos e pediátrico. Diretor do Serviço Cardiovascular e Torácico do Complexo Hospitalar de Doenças Cardio-Pulmonares em Luanda (Angola).&nbsp;Membro do Governing Council da World Society for Pediatric and Congenital Heart Surgery (WSPCHS) e da African Society for Pediatric and Congenital Heart Surgery (ASPCHS).&nbsp;Doutorando em ciências pela Faculdade de Medicina da Universidade de São Paulo (USP).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FknPKVy27FPLqJGcHj9Hs.png?alt=media&token=50adb2b6-5ee9-4b65-b771-b9b43d49affe"
        },
        {
          "id": "uk3OMbPvTpFbkwnLy5bI",
          "name": "Valdester Cavalcante Pinto Júnior ",
          "text": "<p><i>Cirurgião cardiovascular pediátrico do Hospital do Coração Dr. Carlos Alberto Studart. Mestre em Avaliação de Políticas pela Universidade Federal do Ceará (UFC). MBA Executivo em Saúde pela Fundação Getulio Vargas (FGV). Doutor em Biotecnologia pela Universidade Estadual do Ceará (UECE). Ex-presidente do DCCVPed e atual vice-presidente do DCCVPed</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers_temp%2Fuk3OMbPvTpFbkwnLy5bI.png?alt=media&token=f5af61a6-1fcd-44b9-b295-ede4df3321b9"
        },
        {
          "id": "Z8uiF2pLISUKj38hBtiT",
          "name": "Valquíria Pelisser Campagnucci ",
          "text": "<p><i>Mestre e doutora em Medicina, concentração em Cirurgia, pela Faculdade de Ciências Médicas da Santa Casa de Misericórdia de São Paulo (FCMSCSP). Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Chefe de Clínica Adjunto da Cirurgia Cardíaca da Irmandade da Santa Casa de Misericórdia de São Paulo. Professora Assistente da FCMSCSP. Professora no curso de Medicina na Universidade Nove de Julho (Uninove).</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FZ8uiF2pLISUKj38hBtiT.png?alt=media&token=6f03e1bc-0128-485e-bc34-b6e237ba566f"
        },
        {
          "id": "OF20ckfZhp8Gf8qvKS7u",
          "name": "Veridiana Silva de Andrade",
          "text": "<p><i>&nbsp;Prof Adjunta e Chefe do Setor de marcapasso e dispositivos cardíacos eletrônicos implantáveis da Disciplina de Cirurgia Cardiovascular da Unifesp - EPM</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FOF20ckfZhp8Gf8qvKS7u.png?alt=media&token=fd0b8379-bc6a-4624-a062-3871ec1d19ca"
        },
        {
          "id": "pEMSx9Gy5bvabVn3hmUS",
          "name": "Victor Gadelha",
          "text": "<p><i>Head médico de ensino, pesquisa e inovação da Diagnósticos da América S.A. (Dasa).</i></p>",
          "image": ""
        },
        {
          "id": "VBZgvFDBMbMvqvUcyrQ6",
          "name": "Vinicius José da Silva Nina",
          "text": "<p><i>Presidente da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV), gestão 2024-2025. Professor associado pós-doutor do curso de Medicina da Universidade Federal do Maranhão (UFMA). Membro do Conselho Curador da Organização Humanitária Cardiostart International (EUA). Editor associado do Brazilian Journal of Cardiovascular Surgery (BJCVS). Preceptor do Programa de Residência Médica em Cirurgia Cardiovascular no Hospital Universitário da UFMA.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FVBZgvFDBMbMvqvUcyrQ6.png?alt=media&token=0207577e-5082-4661-835b-020079b31f1b"
        },
        {
          "id": "IFFBOlR2QfHhXOk6FbdY",
          "name": "Waldo Emerson Pinheiro Daniel",
          "text": "<p><i>Chefe do Instituto Waldo E.P. Daniel de Cirurgia Cardiovascular, Minimamente Invasiva e Endovascular. Um dos precursores da Cirurgia Cardiovascular Minimamente Invasiva, principal no que tange à Revascularização Minimamente Invasiva. Membro Associado da SBCCV, Cirurgião Cardiovascular do Hospital Universitário Onofre Lopes( UFRN -Universidade Federal do Rio Grande do Norte), Membro do Corpo Docente da Pós-Graduação MICS Cirurgia Cardiovascular Minimamente Invasiva da SCOLLA( Paraná-BR), Apresentador no \"27°European Cardiology Conference\" (2018 in Rome, Italy), ICC 2019( Nova York ISMICS 2021( Varsóvia), 2022 STS/EACTS Latin America Cardiovascular Surgery Conference( Cartagena-COLÔMBIA), Congresso da SBCCV 2018, 2019, 2020, 2021, 2022, 2023, 2024.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FIFFBOlR2QfHhXOk6FbdY.png?alt=media&token=4d29da1e-acbf-4acc-af49-df4c66d843f2"
        },
        {
          "id": "zUJF3rGEzCCujnzfeA9P",
          "name": "Walter José Gomes ",
          "text": "<p><i>Professor titular de Cirurgia Cardiovascular da Escola Paulista de Medicina (EPM-Unifesp). Coeditor do Brazilian Journal of Cardiovascular Surgery (BJCVS). Ex-presidente da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Ex-presidente da Sociedade Latino-Americana de Cirurgia Torácica e Cardiovascular. Presidente do 42º Congresso da Sociedade de Cardiologia do Estado de São Paulo (Socesp), em 2022.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FzUJF3rGEzCCujnzfeA9P.png?alt=media&token=45c62796-d3d0-4566-8b90-fa485c4b465b"
        },
        {
          "id": "ipYdVH4QVNIWxHikji4D",
          "name": "Wanewman Lins Guedes de Andrade",
          "text": "<p><i>Graduação pela Universidade Federal da Paraíba (UFPB). Residência Médica na Beneficência Portuguesa de São Paulo (BP), na equipe do dr. Sérgio Almeida de Oliveira. Medical visiting no Texas Heart Institute (1996 e 1997). Membro especialista da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV).&nbsp;Membro da European Association for Cardio-Thoracic Surgery (EACTS). Membro da International Society for Minimally Invasive Cardiothoracic and Cardiovascular Surgery (ISMICS). Head of Cardiovascular Surgery no Hospital Cardiopulmonar – Rede D'Or desde 2006.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FipYdVH4QVNIWxHikji4D.png?alt=media&token=d5c011c2-4332-4808-8fe2-8bf614690e4e"
        },
        {
          "id": "G7lcUh6ajYPZpR2Xf60Y",
          "name": "Wilson Luiz da Silveira ",
          "text": "<p><i>Cirurgião cardiovascular. Membro titular da Sociedade Brasileira de Cirurgia Cardiovascular (SBCCV). Membro do Conselho da SBCCV.</i></p>",
          "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fmembers%2FG7lcUh6ajYPZpR2Xf60Y.png?alt=media&token=bb5e2133-7e4e-4ba4-8c3a-e54fa0f6c8b2"
        }
      ],
      "activities": [
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "0ZIlYKKWWtOtaquY70xv",
              "name": "Quais são as novas indicações de marcapasso e CDI de acordo com as novas diretrizes SBC/SOBRAC",
              "startTime": "08:00",
              "id": "VKFFmOcbjOaHIfKL1wd0",
              "agenda": [
                {
                  "member_id": "JQRfMjQb3Z3zbqdH03HC",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "0ZIlYKKWWtOtaquY70xv",
                  "id": "TYyxMUXjHrAuyI0qu1rl",
                  "topic_id": "VKFFmOcbjOaHIfKL1wd0",
                  "member_name": "Carlos Eduardo Duarte",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "0ZIlYKKWWtOtaquY70xv",
              "name": "FA registrada em memória do marca-passo: qual a importância?",
              "startTime": "08:15",
              "id": "BpdOiHEpoA2TfBr8Lmv3",
              "agenda": [
                {
                  "member_id": "tVeFhvdUnh3pG801x1gI",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "0ZIlYKKWWtOtaquY70xv",
                  "id": "alEH9dZq9mLiZ7yCo424",
                  "topic_id": "BpdOiHEpoA2TfBr8Lmv3",
                  "member_name": "Cristiano Pisani",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "0ZIlYKKWWtOtaquY70xv",
              "name": "Paciente com BAVT e FE menor que 50%: qual a melhor forma de estimulação?",
              "startTime": "08:30",
              "id": "uBqhjyiyZBVZaYncFADe",
              "agenda": [
                {
                  "member_id": "NfGhLRj2uYMTh2MAUyW0",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "0ZIlYKKWWtOtaquY70xv",
                  "id": "TXvDOfurFN1F2uw3gWil",
                  "topic_id": "uBqhjyiyZBVZaYncFADe",
                  "member_name": "José Carlos Pachón Mateos",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "0ZIlYKKWWtOtaquY70xv",
              "name": "Estimulação fisiológica: o que é e quais as perspectivas?",
              "startTime": "08:45",
              "id": "3ENyHtKQCnFyFYnyWrzH",
              "agenda": [
                {
                  "member_id": "f4THTPHP9RrOyp1amLgu",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "0ZIlYKKWWtOtaquY70xv",
                  "id": "B5DPfGl4hJTYLqaC8Wou",
                  "topic_id": "3ENyHtKQCnFyFYnyWrzH",
                  "member_name": "Alexsandro Fagundes",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "0ZIlYKKWWtOtaquY70xv",
              "name": "CDI subcutâneo deve ser a primeira escolha?",
              "startTime": "09:00",
              "id": "nyOB0ccwdODuAr8edPQt",
              "agenda": [
                {
                  "member_id": "EICPf5FiQ9fX4VXdH4Nb",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "0ZIlYKKWWtOtaquY70xv",
                  "id": "luCy8QUltk7aCSR5LIFY",
                  "topic_id": "nyOB0ccwdODuAr8edPQt",
                  "member_name": "Anísio Pedrosa",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "0ZIlYKKWWtOtaquY70xv",
              "name": "Estimulação fisiológica sob o ponto de vista do cirurgião",
              "startTime": "09:15",
              "id": "jdpLkvCbIbX2YHaoIWMw",
              "agenda": [
                {
                  "member_id": "MNTt0PEzSWSglNXPwjY3",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "0ZIlYKKWWtOtaquY70xv",
                  "id": "D68Px0woShEPzVIvQbxG",
                  "topic_id": "jdpLkvCbIbX2YHaoIWMw",
                  "member_name": "Paulo Roberto Slud Brofman ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "0ZIlYKKWWtOtaquY70xv",
              "name": "Extração de eletrodos",
              "startTime": "09:30",
              "id": "YueuuAdyBqw5dZyMVsoA",
              "agenda": [
                {
                  "member_id": "akUPKrpWe1E9PFpHU5Bm",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "0ZIlYKKWWtOtaquY70xv",
                  "id": "LSNhiS0p7s3WSqFfUmIi",
                  "topic_id": "YueuuAdyBqw5dZyMVsoA",
                  "member_name": "Roberto Costa ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "45",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "0ZIlYKKWWtOtaquY70xv",
              "name": "Discussão",
              "startTime": "09:45",
              "id": "uk6grXrM2lhzwznXS2jp",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "f4THTPHP9RrOyp1amLgu",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "0ZIlYKKWWtOtaquY70xv",
              "id": "9eAx5Axxc7FOzfrOnYKr",
              "member_name": "Alexsandro Fagundes",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "MNTt0PEzSWSglNXPwjY3",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "0ZIlYKKWWtOtaquY70xv",
              "id": "zLVMN6o5cgfcBIU5Tv97",
              "member_name": "Paulo Roberto Slud Brofman ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662124777",
          "depto_id": "ouzy3wlqiQvhvRBZ2K66",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "INOVAÇÕES EM DISPOSITIVOS IMPLANTÁVEIS",
          "depto": "DISPOSITIVOS ELETRÔNICOS IMPLANTÁVEIS",
          "location": "Auditório 2",
          "startTime": "08:00",
          "id": "0ZIlYKKWWtOtaquY70xv"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "9tur0lGacvneZxxUFJ99",
              "name": "Análise dos trials da cirurgia de revascularização do miocárdio / Analysis of myocardial revascularization surgery trials",
              "startTime": "8:00",
              "id": "qnHnC0o3yYUviwyQO9Pd",
              "agenda": [
                {
                  "member_id": "J4MHBqTrgrbAoT4pGzV4",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "9tur0lGacvneZxxUFJ99",
                  "id": "KrAwVe4sW9L4uT0VCw5t",
                  "topic_id": "qnHnC0o3yYUviwyQO9Pd",
                  "member_name": "Torsten Doenst ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "VBZgvFDBMbMvqvUcyrQ6",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "9tur0lGacvneZxxUFJ99",
              "id": "8FdggEYOBt8PviZoJl9n",
              "member_name": "Vinicius José da Silva Nina",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662092049",
          "depto_id": "Esl6uAn1TMfIJxjRTmzm",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "SESSÃO CORONÁRIA",
          "location": "Auditório Principal",
          "startTime": "08:00",
          "id": "9tur0lGacvneZxxUFJ99"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "LC3ob1CC2kBXgQLwE1vG",
              "name": "Abertura",
              "startTime": "08:00",
              "id": "xkd6tPBQloHp0Nvjuuum",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "LapyFJ6x4PKGq7qMfbdg",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "LC3ob1CC2kBXgQLwE1vG",
              "id": "1hgs7LmmheBXCF2M3984",
              "member_name": "Leonardo Augusto Miana",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "Abertura",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "08:00",
          "id": "LC3ob1CC2kBXgQLwE1vG"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "240",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "k5FZZ90mqTMrzXxnpQbq",
              "name": "Meril Life",
              "startTime": "08:00",
              "id": "kTfZnk9h0pfQH2grCthV",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "240",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "k5FZZ90mqTMrzXxnpQbq",
              "name": "Meril Life",
              "startTime": "14:00",
              "id": "zYEd6azZUX2GihCDDMoR",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1718204014027",
          "depto_id": "a6SJZuj9UJUQUJf9CtjP",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "Simuladores",
          "depto": "SESSÕES COMERCIAIS",
          "location": "Sala 2 Simulador",
          "startTime": "08:00",
          "id": "k5FZZ90mqTMrzXxnpQbq"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "35",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "6sG93wAiLkBC5M8E6hZa",
              "name": "Cirurgia cardiovascular pediátrica no nordeste: um pouco de história, muito do que pode ser feito",
              "startTime": "08:10",
              "id": "pTJcXjX8KxeJ6Nji86Vu",
              "agenda": [
                {
                  "member_id": "pw7FmMZMBTtsbcRfAVBk",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "6sG93wAiLkBC5M8E6hZa",
                  "id": "u9IoBZqfhAnTEKJZ7VbT",
                  "topic_id": "pTJcXjX8KxeJ6Nji86Vu",
                  "member_name": "José Teles de Mendonça ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "ifgnNJhEmY84MFU1gQjF",
              "role_name": "Presidente",
              "level": "a",
              "role_id": "n3EoDSuxQZNObutTSI6s",
              "activity_id": "6sG93wAiLkBC5M8E6hZa",
              "id": "HsurlplvhVF8yyeefxFn",
              "member_name": "José Wanderley Neto ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "CONFERÊNCIA MAGNA",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "08:10",
          "id": "6sG93wAiLkBC5M8E6hZa"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2qGfUaYUtrE9bemcqEBo",
              "name": "O papel da cirurgia de revascularização miocárdica após o Estudo ISCHEMIA ",
              "startTime": "08:20",
              "id": "D6XGW2uhmjm1H4QKiiaB",
              "agenda": [
                {
                  "member_id": "zUJF3rGEzCCujnzfeA9P",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2qGfUaYUtrE9bemcqEBo",
                  "id": "PjadKFLULDWRleJbS0nE",
                  "topic_id": "D6XGW2uhmjm1H4QKiiaB",
                  "member_name": "Walter José Gomes ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2qGfUaYUtrE9bemcqEBo",
              "name": "Revascularização híbrida: quando, como e para quem?",
              "startTime": "08:35",
              "id": "CQgLy0n5Mp3ZvyGerOib",
              "agenda": [
                {
                  "member_id": "MarhnVGRhL3kSSe6uWVY",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2qGfUaYUtrE9bemcqEBo",
                  "id": "MSMuVyS4ZkoJ4ZjkoW1D",
                  "topic_id": "CQgLy0n5Mp3ZvyGerOib",
                  "member_name": "Marco Antonio Praça Oliveira ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2qGfUaYUtrE9bemcqEBo",
              "name": "Análise crítica das diretrizes de revascularização do miocárdio na lesão de tronco",
              "startTime": "08:50",
              "id": "dqiFX1gmuRiUjJvUYSlP",
              "agenda": [
                {
                  "member_id": "UFGdWWcOzmh6GDgD0dDC",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2qGfUaYUtrE9bemcqEBo",
                  "id": "JPWaRuBgYv7yAYNw52w0",
                  "topic_id": "dqiFX1gmuRiUjJvUYSlP",
                  "member_name": "Luiz Augusto Ferreira Lisboa ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2qGfUaYUtrE9bemcqEBo",
              "name": "Novas evidências na revascularização do miocárdio em pacientes com baixa fração de ejeção do VE /New evidences on myocardial revascularization in patients with low LV ejection fraction ",
              "startTime": "09:05",
              "id": "mL1HUHx58sNvrq3vGJyn",
              "agenda": [
                {
                  "member_id": "J4MHBqTrgrbAoT4pGzV4",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2qGfUaYUtrE9bemcqEBo",
                  "id": "L0z4N1Oq5unlGy45EnmJ",
                  "topic_id": "mL1HUHx58sNvrq3vGJyn",
                  "member_name": "Torsten Doenst ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2qGfUaYUtrE9bemcqEBo",
              "name": "Terapia antiplaquetária no pré e pós-operatório de revascularização do miocárdio:  por quê, quando e como",
              "startTime": "09:20",
              "id": "RxX6cSip2fWrPHAbpi2N",
              "agenda": [
                {
                  "member_id": "H9CVSu5K8Ny6oNcU3m5A",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2qGfUaYUtrE9bemcqEBo",
                  "id": "dRS1A68ZpvW70YZUVr9v",
                  "topic_id": "RxX6cSip2fWrPHAbpi2N",
                  "member_name": "Pedro Farsky",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2qGfUaYUtrE9bemcqEBo",
              "name": "A revascularização coronariana somente com enxertos arteriais melhora desfechos?",
              "startTime": "09:35",
              "id": "zgUBTEUPF4kaqZv5189O",
              "agenda": [
                {
                  "member_id": "BTlpXRTvn56uWDHODHh2",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2qGfUaYUtrE9bemcqEBo",
                  "id": "USdp6N82PsMStKseFBZv",
                  "topic_id": "zgUBTEUPF4kaqZv5189O",
                  "member_name": "Fabio Biscegli Jatene ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2qGfUaYUtrE9bemcqEBo",
              "name": "A artéria torácica interna direita é melhor que a artéria radial como segundo enxerto arterial?",
              "startTime": "09:50",
              "id": "qcVCauiVSvpuIPfpbrkD",
              "agenda": [
                {
                  "member_id": "wQvCDxqKx3hrExuXNGmz",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2qGfUaYUtrE9bemcqEBo",
                  "id": "sATtC9jfJlLErtvAh4wH",
                  "topic_id": "qcVCauiVSvpuIPfpbrkD",
                  "member_name": "Maurílio Onofre Deininger ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2qGfUaYUtrE9bemcqEBo",
              "name": "Revascularização do miocárdio  com e sem circulação extracorpórea: os efeitos na resposta inflamatória",
              "startTime": "10:05",
              "id": "3oqbmoHuc75a5uahlfBR",
              "agenda": [
                {
                  "member_id": "IFFBOlR2QfHhXOk6FbdY",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2qGfUaYUtrE9bemcqEBo",
                  "id": "wmbiY5AsYknlgOzYEjrC",
                  "topic_id": "3oqbmoHuc75a5uahlfBR",
                  "member_name": "Waldo Emerson Pinheiro Daniel",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2qGfUaYUtrE9bemcqEBo",
              "name": "Discussão",
              "startTime": "10:20",
              "id": "PIHbmoqO2ZPDXu2ggrPk",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "zUJF3rGEzCCujnzfeA9P",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "2qGfUaYUtrE9bemcqEBo",
              "id": "7f3qJGKURLCJllTZJiao",
              "member_name": "Walter José Gomes ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "GkPljbxZKTpR5XQl9nze",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "2qGfUaYUtrE9bemcqEBo",
              "id": "kQajd4Z6cZt2m0EhUXtQ",
              "member_name": "Ricardo de Carvalho Lima ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662092049",
          "depto_id": "Esl6uAn1TMfIJxjRTmzm",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA I",
          "depto": "SESSÃO CORONÁRIA",
          "location": "Auditório Principal",
          "startTime": "08:20",
          "id": "2qGfUaYUtrE9bemcqEBo"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "4LzkBusMj9gIivImGE6f",
              "name": "Expansão da cirurgia cardiovascular",
              "startTime": "08:30",
              "id": "Vt4TupLJnmM9BGnQyVz8",
              "agenda": [
                {
                  "member_id": "pHopGlaMmGboS9s4ZJPk",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "4LzkBusMj9gIivImGE6f",
                  "id": "bx2dlAoMbgrFWtxPwxD5",
                  "topic_id": "Vt4TupLJnmM9BGnQyVz8",
                  "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "4LzkBusMj9gIivImGE6f",
              "name": "Inserção do novo médico no mercado de trabalho",
              "startTime": "08:45",
              "id": "GOdGEQV2APSiPe81KNNH",
              "agenda": [
                {
                  "member_id": "keFvoyoOACgEM8bxAcmx",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "4LzkBusMj9gIivImGE6f",
                  "id": "wCbLG1H7oXp7YW6Qv3tw",
                  "topic_id": "GOdGEQV2APSiPe81KNNH",
                  "member_name": "Henrique Madureira da Rocha Coutinho ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "4LzkBusMj9gIivImGE6f",
              "name": "Cirurgia cardiovascular na era digital",
              "startTime": "09:00",
              "id": "Lr1PoRJ1g5H8BK6RvGNV",
              "agenda": [
                {
                  "member_id": "ThV5wKk60ERXMcvhChfj",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "4LzkBusMj9gIivImGE6f",
                  "id": "QDyZmvP8icPenDQGpd6Z",
                  "topic_id": "Lr1PoRJ1g5H8BK6RvGNV",
                  "member_name": "Sérgio Francisco dos Santos Júnior ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "4LzkBusMj9gIivImGE6f",
              "name": "A importância da cirurgia minimamente invasiva e robótica",
              "startTime": "09:15",
              "id": "koq7cthxOloPHUoPuS7l",
              "agenda": [
                {
                  "member_id": "TNegaNCo8I6SdabN45Gc",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "4LzkBusMj9gIivImGE6f",
                  "id": "E1Tt3eKAJPZMI7qmXCdg",
                  "topic_id": "koq7cthxOloPHUoPuS7l",
                  "member_name": "Samuel Padovani Steffen ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "4LzkBusMj9gIivImGE6f",
              "name": "As novas tecnologias da cirurgia cardiovascular",
              "startTime": "09:30",
              "id": "d2iSK6S1DdlUXDRvvWii",
              "agenda": [
                {
                  "member_id": "5yrGDXcl3mMyHZSJbuow",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "4LzkBusMj9gIivImGE6f",
                  "id": "pVshQec3Yfg11ElEnWtP",
                  "topic_id": "d2iSK6S1DdlUXDRvvWii",
                  "member_name": "José Honório de Almeida Palma Fonseca",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "4LzkBusMj9gIivImGE6f",
              "name": "Protocolo ERAS",
              "startTime": "09:45",
              "id": "EMhUz93YA3yQCEVOezrV",
              "agenda": [
                {
                  "member_id": "LGhSU3EWefWIrNY8DH39",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "4LzkBusMj9gIivImGE6f",
                  "id": "4QpanPbDT2HcdTkLisVB",
                  "topic_id": "EMhUz93YA3yQCEVOezrV",
                  "member_name": "Omar Asdrubal Vilca Mejia ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "Y7YRZxn97HFtIcRvaG19",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "4LzkBusMj9gIivImGE6f",
              "id": "BFGzTL4d5p1RtRECM5JN",
              "member_name": "Pedro Gregori Neto",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "caInCe2UEo2vJ5ez9FAN",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "4LzkBusMj9gIivImGE6f",
              "id": "CicPO8cbGkYXVcreY2hp",
              "member_name": "Diogo Assis Souza ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "oNlbl9hoqO4Ywxa9vCaG",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "4LzkBusMj9gIivImGE6f",
              "id": "HDkig5lyUx6YPyqlkrWW",
              "member_name": "Maikon Lucian Madeira Quarti",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "1uk9yntz7n0s3s26AoOH",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "4LzkBusMj9gIivImGE6f",
              "id": "Pg9CXKmkb26QwNxVAckS",
              "member_name": "Alvaro Monteiro Perazzo ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "EuVeg6zdaqH0f4GwwxmF",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "4LzkBusMj9gIivImGE6f",
              "id": "msG8HwkfqaG86Jcr8xaj",
              "member_name": "Ciro Vinicius Rezende dos Reis",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662136986",
          "depto_id": "Gil3DxNzgfuINqXCVB7H",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA",
          "depto": "ABRECCV",
          "location": "Auditório 4",
          "startTime": "08:30",
          "id": "4LzkBusMj9gIivImGE6f"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "SKsXCTwnCzCdgPdMCgsw",
              "name": "Exames de imagem - Apenas o ecocardiograma é suficiente? Quando TC ou RM são fundamentais?",
              "startTime": "08:45",
              "id": "9W2qJCXdKECvVMB4S05n",
              "agenda": [
                {
                  "member_id": "ZeUASbaH73pXVwiQyQE9",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "SKsXCTwnCzCdgPdMCgsw",
                  "id": "sAS5o85aMCxekI89XPdC",
                  "topic_id": "9W2qJCXdKECvVMB4S05n",
                  "member_name": "Renata Cassar",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "SKsXCTwnCzCdgPdMCgsw",
              "name": "Manejo pré-operatório da coarctação e hipoplasia do arco",
              "startTime": "09:00",
              "id": "9qBVY7BByn2nLCxGFOj4",
              "agenda": [
                {
                  "member_id": "TuwefVAteYS7W1v2tBc3",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "SKsXCTwnCzCdgPdMCgsw",
                  "id": "9RZRnjs1cI42X0nbMekd",
                  "topic_id": "9qBVY7BByn2nLCxGFOj4",
                  "member_name": "Maria Fernanda Silva Jardim",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "SKsXCTwnCzCdgPdMCgsw",
              "name": "Abordagem cirúrgica por toracotomia lateral: técnicas e estratégias para melhor resultado",
              "startTime": "09:15",
              "id": "UygAQ8J31bfc1mavGOcO",
              "agenda": [
                {
                  "member_id": "KjpMuLGHX3c1svkrsP74",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "SKsXCTwnCzCdgPdMCgsw",
                  "id": "GzTWNAYosZ7rEMQJIkPW",
                  "topic_id": "UygAQ8J31bfc1mavGOcO",
                  "member_name": "Andrey José Oliveira Monteiro ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "SKsXCTwnCzCdgPdMCgsw",
              "name": "Hipoplasia do arco aórtico sem defeito intracardíaco: quando a abordagem com CEC é imperiosa e quais as técnicas e truques",
              "startTime": "09:30",
              "id": "f132skaAjH8Syzk7pFpu",
              "agenda": [
                {
                  "member_id": "KGboPJaP8ub7mjron2Qe",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "SKsXCTwnCzCdgPdMCgsw",
                  "id": "U7HgyPXmfruPVHHL2pYy",
                  "topic_id": "f132skaAjH8Syzk7pFpu",
                  "member_name": "Fernando Antoniali ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "SKsXCTwnCzCdgPdMCgsw",
              "name": "Hipoplasia de arco e CIV: paliação ou correção total?",
              "startTime": "09:45",
              "id": "qUu5wY3JsvcrQfl29CVY",
              "agenda": [
                {
                  "member_id": "ojVPBcxW6WCnYtTHpsXE",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "SKsXCTwnCzCdgPdMCgsw",
                  "id": "mQFbmtH8mVbrw7nETxma",
                  "topic_id": "qUu5wY3JsvcrQfl29CVY",
                  "member_name": "José Cícero Stocco Guilhen ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "SKsXCTwnCzCdgPdMCgsw",
              "name": "Discussão",
              "startTime": "10:00",
              "id": "eXaRy9nPnwaclvZdUrAd",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "Grp7ZpLL5sbcfYJM0t21",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "SKsXCTwnCzCdgPdMCgsw",
              "id": "DMCBij41c6paAFbjcFTq",
              "member_name": "Luiz Fernando Caneo ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "HiKwZGC9JxBw28x7X1ub",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "SKsXCTwnCzCdgPdMCgsw",
              "id": "xBDz2Fe3QOf7yEQASJw1",
              "member_name": "Beatriz Helena S. Furlanetto ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA - COARCTAÇÃO DE AORTA E HIPOPLASIA DO ARCO AÓRTICO",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "08:45",
          "id": "SKsXCTwnCzCdgPdMCgsw"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "DL2Aj2H4vYFzCubI4cCD",
              "name": "Como montar um serviço de cirurgia cardiovascular",
              "startTime": "10:00",
              "id": "cEg9NoAPy9SWnTuUxzTV",
              "agenda": [
                {
                  "member_id": "GA6Ncov8tW6bXJW5541J",
                  "role_name": "Debatedor(a)",
                  "level": "t",
                  "role_id": "akXbIW6V3Q1UHZQzE0BF",
                  "activity_id": "DL2Aj2H4vYFzCubI4cCD",
                  "id": "3DQS7nDmVt7fsVRDmHAC",
                  "topic_id": "cEg9NoAPy9SWnTuUxzTV",
                  "member_name": "Sandro Valério Fadel ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "KknoPWiFLlfc8TkiwjI2",
                  "role_name": "Debatedor(a)",
                  "level": "t",
                  "role_id": "akXbIW6V3Q1UHZQzE0BF",
                  "activity_id": "DL2Aj2H4vYFzCubI4cCD",
                  "id": "n3rWqQnNmIDFK8wFyvFu",
                  "topic_id": "cEg9NoAPy9SWnTuUxzTV",
                  "member_name": "João Paulo Segundo de Paiva Oliveira ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "C94LtHfX2nQs7a4Pyf4t",
                  "role_name": "Debatedor(a)",
                  "level": "t",
                  "role_id": "akXbIW6V3Q1UHZQzE0BF",
                  "activity_id": "DL2Aj2H4vYFzCubI4cCD",
                  "id": "zWhctykopjiP2QGE8E2Y",
                  "topic_id": "cEg9NoAPy9SWnTuUxzTV",
                  "member_name": "Raúl Armando Micalay Paredes",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "k65dMcKtptW5VfLwYqpH",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "DL2Aj2H4vYFzCubI4cCD",
              "id": "Pb4KgRGYmT6r3qwKu0ZN",
              "member_name": "Filipe Tomasi Keppen Sequeira de Almeida ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "uc7ygrqrXZ8jOy6l9cZQ",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "DL2Aj2H4vYFzCubI4cCD",
              "id": "TyvnpKAT2lfHJhHNMACL",
              "member_name": "Jéssica Cordeiro de Siqueira Campos ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "LHp66lMTiqQ3ZbPXi51K",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "DL2Aj2H4vYFzCubI4cCD",
              "id": "YFzjnuKg0ekRMMHTSNqE",
              "member_name": "Gabriel Rodrigues Bittencourt ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662136986",
          "depto_id": "Gil3DxNzgfuINqXCVB7H",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "DEBATE",
          "depto": "ABRECCV",
          "location": "Auditório 4",
          "startTime": "10:00",
          "id": "DL2Aj2H4vYFzCubI4cCD"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Fs0qBisZLnsJzK6Df4rX",
              "name": "P01 - Transplante cardíaco pediátrico em criança portadora de Situs Inversus Totalis e Dextrocardia: um relato de caso",
              "startTime": "10:30",
              "id": "Q572NHziUpSDn0gWY6jW",
              "agenda": [
                {
                  "member_id": "wgohVuaNKKh1JZpivxge",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "Fs0qBisZLnsJzK6Df4rX",
                  "id": "tNkPmXAhYh5cPszePYgM",
                  "topic_id": "Q572NHziUpSDn0gWY6jW",
                  "member_name": "Maria Victoria Rocha Fontenele Maia",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Fs0qBisZLnsJzK6Df4rX",
              "name": "P02 - Operação de konno-Rastan em pós-operatório tardio de cirurgia de Jatene: relato de caso",
              "startTime": "10:35",
              "id": "War7lAmVRINt4bt1mpRl",
              "agenda": [
                {
                  "member_id": "kN4uP9apTbZTqbSAifCh",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "Fs0qBisZLnsJzK6Df4rX",
                  "id": "A66d9scHtrTUwwcdC76j",
                  "topic_id": "War7lAmVRINt4bt1mpRl",
                  "member_name": "Jéssica Silva Silvério",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Fs0qBisZLnsJzK6Df4rX",
              "name": "P03 - Teratoma maduro mediastinal em adulto: um relato de caso ",
              "startTime": "10:40",
              "id": "JwEdNAD7FHhyTFo3nEpe",
              "agenda": [
                {
                  "member_id": "8slzbpEAdwuDdbwxTXYO",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "Fs0qBisZLnsJzK6Df4rX",
                  "id": "tyQbKc1YtiNNgOKBcV4G",
                  "topic_id": "JwEdNAD7FHhyTFo3nEpe",
                  "member_name": "Larissa de Oliveira Beltrão",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Fs0qBisZLnsJzK6Df4rX",
              "name": "P04 - Análise Ultraestrutural do endotélio da veia safena de paciente com comorbidades pró-inflamatórias submetido a cirurgia de revascularização do miocárdio",
              "startTime": "10:45",
              "id": "AqAbKfKKYlDh0uOuCpmv",
              "agenda": [
                {
                  "member_id": "3iXSPnIzLwdxAoj1mTpS",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "Fs0qBisZLnsJzK6Df4rX",
                  "id": "Je33aYVjH59YmCzKf21Y",
                  "topic_id": "AqAbKfKKYlDh0uOuCpmv",
                  "member_name": "Matheus Sant’Anna de Oliveira Gonçalves ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Fs0qBisZLnsJzK6Df4rX",
              "name": "P05 - Tamponamento cardíaco causado por hérnia diafragmática intrapericárdica estrangulada: relato de caso",
              "startTime": "10:50",
              "id": "zGV1jQbd9zDWV4Qc1zbN",
              "agenda": [
                {
                  "member_id": "lr42ygHEcumaJDMyXSkN",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "Fs0qBisZLnsJzK6Df4rX",
                  "id": "0P9GtjMj5hXxNfQZSoGv",
                  "topic_id": "zGV1jQbd9zDWV4Qc1zbN",
                  "member_name": "Isadora Rênia Lucena Oliveira",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "NsfYLwC5wmSrRbSVh17F",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "Fs0qBisZLnsJzK6Df4rX",
              "id": "0v6bN1CV9qtk6Fa5DOjP",
              "member_name": "Antonio Carlos de Almeida Barbosa Filho",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "caInCe2UEo2vJ5ez9FAN",
              "role_name": "Comentador(a)",
              "level": "a",
              "role_id": "QT9ZMl0B1XnPIXfMp0mx",
              "activity_id": "Fs0qBisZLnsJzK6Df4rX",
              "id": "GCMFwIturnPMr4pZxQ2I",
              "member_name": "Diogo Assis Souza ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709663252454",
          "depto_id": "FL6nxVyGZig87kzytMdV",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "SESSÃO DE PÔSTERES I",
          "depto": "SESSÃO DE PÔSTERES",
          "location": "Área de Exposição",
          "startTime": "10:30",
          "id": "Fs0qBisZLnsJzK6Df4rX"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "i9KKcfVKbmb7gEWJ9Wfu",
              "name": "Visita aos Expositores",
              "startTime": "10:30",
              "id": "3QaUngMS1SEljNlFsWIG",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709663252454",
          "depto_id": "0opU2hMyvevrpIXDzjeD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "INTERVALO",
          "depto": "SBCCV",
          "location": "Área de Exposição",
          "startTime": "10:30",
          "id": "i9KKcfVKbmb7gEWJ9Wfu"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "name": "Palavra do Presidente",
              "startTime": "11:00",
              "id": "5uosncvjjUgyGM2hBa3X",
              "agenda": [
                {
                  "member_id": "VBZgvFDBMbMvqvUcyrQ6",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "UuS54AzGS6CAKvWrgp1Y",
                  "id": "eE5gyCio7O7CdANg9uoY",
                  "topic_id": "5uosncvjjUgyGM2hBa3X",
                  "member_name": "Vinicius José da Silva Nina",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "ZSAm1sNI0J0iTAAEqc9L",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "7cHeaPdPDEdl48XDw6XE",
              "member_name": "Pedro Rafael Salerno ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "VbemlUiQZS2XiFQdu4NW",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "8diZOmEfE5gNm27DqKim",
              "member_name": "Fernando Antonio Lucchese ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "uk3OMbPvTpFbkwnLy5bI",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "BUxoQTWSB9VUR6S0Hx8u",
              "member_name": "Valdester Cavalcante Pinto Júnior ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "VBZgvFDBMbMvqvUcyrQ6",
              "role_name": "Presidente",
              "level": "a",
              "role_id": "n3EoDSuxQZNObutTSI6s",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "WQTkOvBnQElgMFmRNr0V",
              "member_name": "Vinicius José da Silva Nina",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "HpAQ9NQjmjwtFQlGbFXQ",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "XlERwgISuVj3YkgnRi3E",
              "member_name": "Paulo Roberto Barbosa Evora ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "Y90o4YcoL3yo2DzNQf0g",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "aHsjTVHnl6SfoRRTBZUd",
              "member_name": "Josalmir José Melo do Amaral ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "Z8uiF2pLISUKj38hBtiT",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "e1a6c6fLgiHzMHDc31TT",
              "member_name": "Valquíria Pelisser Campagnucci ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "vklFqYm25ki5o1mzphiQ",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "isFtTk563CnFhqg60rJg",
              "member_name": "Eduardo Keller Saadi ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "Nci7AIXDEKQ27UR2Ryfu",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "le83ujgJoBSJO45r92px",
              "member_name": "Carlos Manuel de Almeida Brandão ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "pHopGlaMmGboS9s4ZJPk",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "pvSlGhWth3HulrlyeZuu",
              "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "JDupwQyvnXZXKoaikvJo",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "sUlFPuhqETfd0dAihcu2",
              "member_name": "Marcos Antonio Cantero ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "YSTjpav26KV1ydeC6v9p",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "wmnwHP5yyv5pUWESwCaT",
              "member_name": "Gustavo Ieno Judas ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "G7lcUh6ajYPZpR2Xf60Y",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "xDkC3HE9207k4LaiRcbp",
              "member_name": "Wilson Luiz da Silveira ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "m7hFAW6dwk2YCb4qDre1",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "y2qTaKecUznUA7aswRY7",
              "member_name": "Acrísio Sales Valente",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "urqa8kheZfSyrtQUcRh6",
              "role_name": "Mesa",
              "level": "a",
              "role_id": "dpaZAe2f6L9er6EpbvKN",
              "activity_id": "UuS54AzGS6CAKvWrgp1Y",
              "id": "y8A3mfSeMXedYRaQ4wto",
              "member_name": "Luiz Cláudio Moreira Lima ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662092049",
          "depto_id": "0opU2hMyvevrpIXDzjeD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "ABERTURA DO CONGRESSO",
          "depto": "SBCCV",
          "location": "Auditório Principal",
          "startTime": "11:00",
          "id": "UuS54AzGS6CAKvWrgp1Y"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "45",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "njNPMvUW6lmfz3alNty0",
              "name": "Láurea ao Mérito",
              "startTime": "11:15",
              "id": "yKhVU4vTjtCc6nzANqW2",
              "agenda": [
                {
                  "member_id": "KUrfspRDNH3y1f5UxEXv",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "1ZNNu42VybsVi8pQvRQ4",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Enio Buffolo ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "fVNXav4rEz5KTGiUocDg",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "3pkcsEGhkd6h1CN1dzWP",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Jarbas Jakson Dinkhuysen ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "487mQwdaZGJfbJ8NbJ9n",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "5sVLMu343suY7H45p4If",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "João Carlos Ferreira Leal ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "Y90o4YcoL3yo2DzNQf0g",
                  "role_name": "Representante",
                  "level": "t",
                  "role_id": "oL1LWwd5VlBpJMsMoAfr",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "6KptIIVLvOjRBzDOX7yE",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Josalmir José Melo do Amaral ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "zUJF3rGEzCCujnzfeA9P",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "6up3hp7eqbUdQBo5yccu",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Walter José Gomes ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "yP9v1YUaKffTWIhPxQui",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "C9QrIJHLy4NWwyiFKW6M",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Gilberto Venossi Barbosa ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "MNTt0PEzSWSglNXPwjY3",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "JkxrTjIES5whwz3IY95q",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Paulo Roberto Slud Brofman ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "oQW5u6iNISWZNqIScPem",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "RcnNr5roj326ODBj4Ozp",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Alexandre Visconti Brick ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "BTlpXRTvn56uWDHODHh2",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "TOywA4vmMPDP6uNyaiRh",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Fabio Biscegli Jatene ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "ifgnNJhEmY84MFU1gQjF",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "UxwT1shp2S2yHoHblHpY",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "José Wanderley Neto ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "pw7FmMZMBTtsbcRfAVBk",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "V607pNhZpPjcYFr55yVQ",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "José Teles de Mendonça ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "VbemlUiQZS2XiFQdu4NW",
                  "role_name": "Representante",
                  "level": "t",
                  "role_id": "oL1LWwd5VlBpJMsMoAfr",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "b301AhopDc1OnC6N1iZh",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Fernando Antonio Lucchese ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "L14lyaA2guegwmc8salH",
                  "role_name": "Representante",
                  "level": "t",
                  "role_id": "oL1LWwd5VlBpJMsMoAfr",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "bd31YGmxghbyEDDhLCgc",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Luiz Fernando Kubrusly ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "HbH1jwatZQm6ly3bOqFo",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "fn1z8eihPmah1xr9eIIh",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Eduardo Augusto Victor Rocha",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "9lMeTcTxlqNY7HCQnI4J",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "h2m0WFTjkeyPWSvD2lLM",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Marcelo Matos Cascudo",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "lPdDpW8VpNzGAyTTca5D",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "k0mM98fBuXAiXJty6xjj",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Luiz Carlos Bento de Souza ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "3fH1Rx0qhLEqTM6Jqfw3",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "qiRkudaY9zDBIGHGl7iu",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Milton Ary Meier ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "pHopGlaMmGboS9s4ZJPk",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "qrapGVzCtjTFP6BFrW1J",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "0qhPHbRIIKFp5Na5NXvN",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "njNPMvUW6lmfz3alNty0",
                  "id": "sCq7pzRwD8LyQJavqA2c",
                  "topic_id": "yKhVU4vTjtCc6nzANqW2",
                  "member_name": "Noedir Antonio Groppo Stolf ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662092049",
          "depto_id": "0opU2hMyvevrpIXDzjeD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "HOMENAGEM AOS EX-PRESIDENTES DA SBCCV",
          "depto": "SBCCV",
          "location": "Auditório Principal",
          "startTime": "11:15",
          "id": "njNPMvUW6lmfz3alNty0"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "WOvmyOoYWBZ5lF9I33qB",
              "name": "Como exercer uma posição de liderança",
              "startTime": "12:00",
              "id": "RoJUD2CBp0hsPxixPPTI",
              "agenda": [
                {
                  "member_id": "R3R27SD1RXJN10IYECch",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "WOvmyOoYWBZ5lF9I33qB",
                  "id": "89GyC7Rlhz2JUGxhLN24",
                  "topic_id": "RoJUD2CBp0hsPxixPPTI",
                  "member_name": "Milton Maluhy Filho",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "VBZgvFDBMbMvqvUcyrQ6",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "WOvmyOoYWBZ5lF9I33qB",
              "id": "NKBw0VluCfo0r61E6Rbo",
              "member_name": "Vinicius José da Silva Nina",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "MarhnVGRhL3kSSe6uWVY",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "WOvmyOoYWBZ5lF9I33qB",
              "id": "hzdUvVqxStLJHDwGVSxc",
              "member_name": "Marco Antonio Praça Oliveira ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662092049",
          "depto_id": "0opU2hMyvevrpIXDzjeD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "PALESTRA  MAGNA",
          "depto": "SBCCV",
          "location": "Auditório Principal",
          "startTime": "12:00",
          "id": "WOvmyOoYWBZ5lF9I33qB"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "90",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "C4B7GWeW74Dr4CLan66F",
              "name": "ALMOÇO",
              "startTime": "12:00",
              "id": "AcWDXdgRWTCp8poQRQL6",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709663252454",
          "depto_id": "0opU2hMyvevrpIXDzjeD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "ALMOÇO",
          "depto": "SBCCV",
          "location": "Área de Exposição",
          "startTime": "12:30",
          "id": "C4B7GWeW74Dr4CLan66F"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [],
          "agenda": [
            {
              "member_id": "opldCD9LX0CgEpbNC8lS",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "G6ISOBUZAyPuMqXuwm8h",
              "id": "6zxfKLdxUx7Zm6yYX4tk",
              "member_name": "Fernando Bermudez Kubrusly ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "as7eHwKNPUp2qb4h9QM3",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "G6ISOBUZAyPuMqXuwm8h",
              "id": "GD0weH4QEnnVqbYxST0V",
              "member_name": "Auristela Ramos",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "FjybEQe6bu0giHrR1tNN",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "G6ISOBUZAyPuMqXuwm8h",
              "id": "GeYtx90HX83OalCRW3F3",
              "member_name": "Fernando Ribeiro Moraes Neto ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "YSTjpav26KV1ydeC6v9p",
              "role_name": "Moderador(a)",
              "level": "a",
              "role_id": "6QisZ6kM0eraJV2egjJa",
              "activity_id": "G6ISOBUZAyPuMqXuwm8h",
              "id": "jRLkyjpZL3XIZMvZuHgf",
              "member_name": "Gustavo Ieno Judas ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662130844",
          "depto_id": "a6SJZuj9UJUQUJf9CtjP",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "Simpósio Abbott - Essentials of Lifetime Management",
          "depto": "SESSÕES COMERCIAIS",
          "location": "Auditório 3",
          "startTime": "12:30",
          "id": "G6ISOBUZAyPuMqXuwm8h"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": {
            "image": "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fbanner_sponsors%2Fbanner_1717443236276.png?alt=media&token=9d3f12c6-a3c1-46da-8b86-697faae29410",
            "link": "https://www.edwards.com",
            "id": 1717443236276
          },
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "90",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "qVvqNobsWRoSSuVmWiPo",
              "name": "Tratamento cirúrgico valvar mitral: um modelo baseado em evidências ",
              "startTime": "12:30",
              "id": "HY8OyPfB9zrE4WTW2Vnb",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "1A7jYaqoGySa6tUTxhpo",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "qVvqNobsWRoSSuVmWiPo",
              "id": "YLtaJLu4OQg7IW4vE90J",
              "member_name": "Denis Bouchard",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "vklFqYm25ki5o1mzphiQ",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "qVvqNobsWRoSSuVmWiPo",
              "id": "b5ms7JmPGxjuVOcljJ3L",
              "member_name": "Eduardo Keller Saadi ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "BTlpXRTvn56uWDHODHh2",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "qVvqNobsWRoSSuVmWiPo",
              "id": "xvJGlQjkBwXcYfB23h1P",
              "member_name": "Fabio Biscegli Jatene ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662124777",
          "depto_id": "a6SJZuj9UJUQUJf9CtjP",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "SIMPÓSIO EDWARDS",
          "depto": "SESSÕES COMERCIAIS",
          "location": "Auditório 2",
          "startTime": "12:30",
          "id": "qVvqNobsWRoSSuVmWiPo"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "NJas36VDEr502YBauPet",
              "name": "Formação do cirurgião cardiovascular: quais as aflições e o que deve ser transformado",
              "startTime": "14:00",
              "id": "O8YifyYqLepEqaQzPeTY",
              "agenda": [
                {
                  "member_id": "9bpCBQ85pG4g5h1I9TtZ",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "NJas36VDEr502YBauPet",
                  "id": "HX7bs43zWzpqQLnkDj46",
                  "topic_id": "O8YifyYqLepEqaQzPeTY",
                  "member_name": "Henrique Murad ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "NJas36VDEr502YBauPet",
              "name": "Formação do cirurgião cardiovascular: quais as aflições e o que deve ser transformado",
              "startTime": "14:10",
              "id": "X3sKkWK3l8VLFLt4YKLm",
              "agenda": [
                {
                  "member_id": "oNlbl9hoqO4Ywxa9vCaG",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "NJas36VDEr502YBauPet",
                  "id": "IQvb6USz5sFKg5TrVAeT",
                  "topic_id": "X3sKkWK3l8VLFLt4YKLm",
                  "member_name": "Maikon Lucian Madeira Quarti",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "NJas36VDEr502YBauPet",
              "name": "Mercado de Trabalho: a cirurgia cardiovascular em evolução ou involução? Como encarar as novas tecnologias: concorrentes ou aliadas?",
              "startTime": "14:20",
              "id": "66cwjbAxmnc6g6TZbfA1",
              "agenda": [
                {
                  "member_id": "BTlpXRTvn56uWDHODHh2",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "NJas36VDEr502YBauPet",
                  "id": "rY512ygBHsNJNA681dvn",
                  "topic_id": "66cwjbAxmnc6g6TZbfA1",
                  "member_name": "Fabio Biscegli Jatene ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "NJas36VDEr502YBauPet",
              "name": "Mercado de Trabalho: a cirurgia cardiovascular em evolução ou involução? Como encarar as novas tecnologias: Concorrentes ou aliadas?",
              "startTime": "14:30",
              "id": "zqdiRfPi5zQd9ob72NNR",
              "agenda": [
                {
                  "member_id": "momWB9r97qBCF7ipcNZ0",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "NJas36VDEr502YBauPet",
                  "id": "fqSolFzz4N681hfttluH",
                  "topic_id": "zqdiRfPi5zQd9ob72NNR",
                  "member_name": "Anderson da Silva Terrazas ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "NJas36VDEr502YBauPet",
              "name": "Vida associativa: Órgãos de classe, quais os objetivos, o que importa e o que deve ser feito",
              "startTime": "14:40",
              "id": "5HQHfYM4Hf4fNkzNGn9H",
              "agenda": [
                {
                  "member_id": "VBZgvFDBMbMvqvUcyrQ6",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "NJas36VDEr502YBauPet",
                  "id": "sYvKr1nQzna0393StMAM",
                  "topic_id": "5HQHfYM4Hf4fNkzNGn9H",
                  "member_name": "Vinicius José da Silva Nina",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "NJas36VDEr502YBauPet",
              "name": "Vida associativa: Órgãos de classe, quais os objetivos, o que importa e o que deve ser feito",
              "startTime": "14:50",
              "id": "o7ypHtk9hXMuBpXthdl7",
              "agenda": [
                {
                  "member_id": "1uk9yntz7n0s3s26AoOH",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "NJas36VDEr502YBauPet",
                  "id": "drpvOerxVwUKBTaCvAIB",
                  "topic_id": "o7ypHtk9hXMuBpXthdl7",
                  "member_name": "Alvaro Monteiro Perazzo ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "AtXcVcGzQRhRm88BYtTT",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "NJas36VDEr502YBauPet",
              "id": "533D44XyFxhc55Ssxky7",
              "member_name": "Felipe Reale Cividanes ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "MNTt0PEzSWSglNXPwjY3",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "NJas36VDEr502YBauPet",
              "id": "778nuTbrGNoTNY08zdJJ",
              "member_name": "Paulo Roberto Slud Brofman ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "KUrfspRDNH3y1f5UxEXv",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "NJas36VDEr502YBauPet",
              "id": "Mkw8YY3L7kajMQKQZc2P",
              "member_name": "Enio Buffolo ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "0HKGwQwroXpkyJLzp9Sh",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "NJas36VDEr502YBauPet",
              "id": "a8ytzpZfdtFwpkzxqFfd",
              "member_name": "Laio Caju Wanderley",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662142789",
          "depto_id": "NGf0C01VnQJgqQWSeYD1",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "DEBATES - A ACADEMIA AJUDANDO A CONSTRUIR SONHOS E PRESERVANDO A MEMÓRIA DA CIRURGIA CARDIOVASCULAR",
          "depto": "ACADEMIA",
          "location": "Auditório 5",
          "startTime": "14:00",
          "id": "NJas36VDEr502YBauPet"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "PxIMPCPKxh0XdPUA4T8f",
              "name": "Como engajar a Instituição no programa de cultura de segurança em cirurgia cardiovascular?",
              "startTime": "14:00",
              "id": "dXR610CFAfSG5DkPcsys",
              "agenda": [
                {
                  "member_id": "BTlpXRTvn56uWDHODHh2",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "PxIMPCPKxh0XdPUA4T8f",
                  "id": "DMztMGOpJnwxKPELgJtM",
                  "topic_id": "dXR610CFAfSG5DkPcsys",
                  "member_name": "Fabio Biscegli Jatene ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "JDupwQyvnXZXKoaikvJo",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "PxIMPCPKxh0XdPUA4T8f",
              "id": "KVkIGTZUJiXYfq31iWjA",
              "member_name": "Marcos Antonio Cantero ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662124777",
          "depto_id": "DeTA2zHryJbnpiqE6H3Q",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "SEGURANÇA NA CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 2",
          "startTime": "14:00",
          "id": "PxIMPCPKxh0XdPUA4T8f"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "QdxIjebReQ9xobC1GpuH",
              "name": "Cirurgia valvar minimamente invasiva/Minimally invasive valve surgery",
              "startTime": "14:00",
              "id": "HjtG2zwzUUykARBTdnHZ",
              "agenda": [
                {
                  "member_id": "rkypLnEeHc6cO47JlH17",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "QdxIjebReQ9xobC1GpuH",
                  "id": "XywhCOjM29JJpSWbi5vg",
                  "topic_id": "HjtG2zwzUUykARBTdnHZ",
                  "member_name": "Hristof Kirov",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "Nci7AIXDEKQ27UR2Ryfu",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "QdxIjebReQ9xobC1GpuH",
              "id": "pAfq6nPlYpVGD7XM1iUC",
              "member_name": "Carlos Manuel de Almeida Brandão ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662092049",
          "depto_id": "u3kInDhnpMCXaHhssQHg",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "SESSÃO  VÁLVULA",
          "location": "Auditório Principal",
          "startTime": "14:00",
          "id": "QdxIjebReQ9xobC1GpuH"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "dAQRzQN3DO1HxRnEoVQT",
              "name": "Ultrafiltração modificada já provou seus reais benefícios? Preciso realizar em todos os casos?",
              "startTime": "14:00",
              "id": "oaxatAjc7JRuKAVaSza4",
              "agenda": [
                {
                  "member_id": "quxYsoET9AsI1bwkGwOL",
                  "role_name": "Presidente",
                  "level": "t",
                  "role_id": "n3EoDSuxQZNObutTSI6s",
                  "activity_id": "dAQRzQN3DO1HxRnEoVQT",
                  "id": "FXZz6sZv8gBBpI1F1okb",
                  "topic_id": "oaxatAjc7JRuKAVaSza4",
                  "member_name": "Marco Antonio Ferreira Travessa ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "Q2gVHf5GxvfJb7T0N0Y1",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "dAQRzQN3DO1HxRnEoVQT",
                  "id": "tOdnbWN2qVKWRY8GibuX",
                  "topic_id": "oaxatAjc7JRuKAVaSza4",
                  "member_name": "Gilberto de Oliveira Scuciato",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "dAQRzQN3DO1HxRnEoVQT",
              "name": "Procedimento híbrido totalmente percutâneo e futuro da cardiologia pediátrica intervencionista",
              "startTime": "14:20",
              "id": "854rAMqlqK2MaUdZox2c",
              "agenda": [
                {
                  "member_id": "FjybEQe6bu0giHrR1tNN",
                  "role_name": "Presidente",
                  "level": "t",
                  "role_id": "n3EoDSuxQZNObutTSI6s",
                  "activity_id": "dAQRzQN3DO1HxRnEoVQT",
                  "id": "5vV76J2Qye7Ci5cfPKUv",
                  "topic_id": "854rAMqlqK2MaUdZox2c",
                  "member_name": "Fernando Ribeiro Moraes Neto ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "DELixrwkNaxoaXQWBQOE",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "dAQRzQN3DO1HxRnEoVQT",
                  "id": "O4oF07xzU0n0wua24Kbt",
                  "topic_id": "854rAMqlqK2MaUdZox2c",
                  "member_name": "Marcelo Ribeiro",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "dAQRzQN3DO1HxRnEoVQT",
              "name": "Using novel 3D technologies for cardiovascular interventions and surgery planning and simulation",
              "startTime": "14:40",
              "id": "xSQ1qbWJcWpLbLO44wqU",
              "agenda": [
                {
                  "member_id": "UjsGdYOu19nGJtuSpmwE",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "dAQRzQN3DO1HxRnEoVQT",
                  "id": "D0YMg6V6JiPTmzBj6cVj",
                  "topic_id": "xSQ1qbWJcWpLbLO44wqU",
                  "member_name": "Shai Tejmam-Yarden",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "a8vPgddB3sABR4c6X0xF",
                  "role_name": "Presidente",
                  "level": "t",
                  "role_id": "n3EoDSuxQZNObutTSI6s",
                  "activity_id": "dAQRzQN3DO1HxRnEoVQT",
                  "id": "uQGy2I2TzzxHyylff8bH",
                  "topic_id": "xSQ1qbWJcWpLbLO44wqU",
                  "member_name": "Daniel Hoyer de Carvalho Barcellos ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "dAQRzQN3DO1HxRnEoVQT",
              "name": "Moldes 3D para reconstruções em procedimentos complexos / A 3D molded patch for complex congenital cardiac surgical procedures",
              "startTime": "15:00",
              "id": "Onz3s5ezR7AW19Y76GEw",
              "agenda": [
                {
                  "member_id": "1YRRj0zd5Kxu7qTlcNcy",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "dAQRzQN3DO1HxRnEoVQT",
                  "id": "GNuDzNf6F3whkMmTmGbC",
                  "topic_id": "Onz3s5ezR7AW19Y76GEw",
                  "member_name": "Ignacio Bezerra",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "D2cTwd9pATkdowb98vkW",
                  "role_name": "Presidente",
                  "level": "t",
                  "role_id": "n3EoDSuxQZNObutTSI6s",
                  "activity_id": "dAQRzQN3DO1HxRnEoVQT",
                  "id": "xnoH9lYs6ITH5aswwYwd",
                  "topic_id": "Onz3s5ezR7AW19Y76GEw",
                  "member_name": "Nadja Cecília de Castro Kraychete ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "dAQRzQN3DO1HxRnEoVQT",
              "name": "Estratégias anestésicas em cirurgia neonatal",
              "startTime": "15:30",
              "id": "aB8QrK4UthH0YMZZ7Eb4",
              "agenda": [
                {
                  "member_id": "FosE0Q7Hd7wjyEK2oIww",
                  "role_name": "Presidente",
                  "level": "t",
                  "role_id": "n3EoDSuxQZNObutTSI6s",
                  "activity_id": "dAQRzQN3DO1HxRnEoVQT",
                  "id": "51vjxhCeR03fEKRvYJcS",
                  "topic_id": "aB8QrK4UthH0YMZZ7Eb4",
                  "member_name": "Ricardo Nilsson Sgarbieri ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "YGwJOfZCLXRbZ1cEFTO8",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "dAQRzQN3DO1HxRnEoVQT",
                  "id": "T2GLGGYxL41P4WXJe64u",
                  "topic_id": "aB8QrK4UthH0YMZZ7Eb4",
                  "member_name": "Thiana Yamaguchi",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "SESSÃO DE CONFERÊNCIAS",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "14:00",
          "id": "dAQRzQN3DO1HxRnEoVQT"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "name": "TL01 - Impacto da anemia pré-operatória nos resultados perioperatórios da cirurgia de revascularização do miocárdio isolada: estudo de coorte pareado por escore de propensão",
              "startTime": "14:00",
              "id": "V42K19CQw2UOfbfsyt9c",
              "agenda": [
                {
                  "member_id": "50uvA0cJpDqqceyzWusk",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "f26tN3VSWIZ5ALwTc1hK",
                  "topic_id": "V42K19CQw2UOfbfsyt9c",
                  "member_name": "Alvaro Rösler ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "Ew8TnYbLbwnWqjXZZzFH",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "io8x3zA8cBZo9yOzGEtD",
                  "topic_id": "V42K19CQw2UOfbfsyt9c",
                  "member_name": "Marcos Aurélio Barboza de Oliveira ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "name": "TL02 - Troca valvar aórtica por bioprótese St. Jude Medical Trifecta em octogenários e seu impacto na expectativa de vida e no desempenho hemodinâmico",
              "startTime": "14:15",
              "id": "ESW4ThWpT1Y0dHztA5UK",
              "agenda": [
                {
                  "member_id": "wJFJCWc8Lsge7xSmhmsN",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "CkPdnpE8OGmOBuMEFRsf",
                  "topic_id": "ESW4ThWpT1Y0dHztA5UK",
                  "member_name": "Lívia Torres Pinheiro",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "TawRmR2TVs1QsxUf0Ah3",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "IPK1jDFhmExXp0Sv5VHT",
                  "topic_id": "ESW4ThWpT1Y0dHztA5UK",
                  "member_name": "Marcos Gradim Tiveron ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "name": "TL03 - Impacto da rápida recuperação na sobrevida de pacientes de cirurgia cardíaca: 5 anos da cultura do ERAS",
              "startTime": "14:30",
              "id": "uZCqvwW3QQl3vGJuRIvP",
              "agenda": [
                {
                  "member_id": "wQvCDxqKx3hrExuXNGmz",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "ZLDxr31L6OlFCPbfIglc",
                  "topic_id": "uZCqvwW3QQl3vGJuRIvP",
                  "member_name": "Maurílio Onofre Deininger ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "LGhSU3EWefWIrNY8DH39",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "iLCIiQTbadAFbZkFGiVy",
                  "topic_id": "uZCqvwW3QQl3vGJuRIvP",
                  "member_name": "Omar Asdrubal Vilca Mejia ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "name": "TL04 - Artérias de coelhos descelularizadas como enxerto biológico: estudo de biocompatibilidade, propriedades biomecânicas e caracterização imunofenotípica com fins de utilização como enxerto coronário",
              "startTime": "14:45",
              "id": "FN7tELUxDx3PEmWyj37h",
              "agenda": [
                {
                  "member_id": "L14lyaA2guegwmc8salH",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "8edfpKTjClKoaaH6xKaG",
                  "topic_id": "FN7tELUxDx3PEmWyj37h",
                  "member_name": "Luiz Fernando Kubrusly ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "7qi2vEYdO3teszgHsWwG",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "wS3ETcXYGErHs4apP6hI",
                  "topic_id": "FN7tELUxDx3PEmWyj37h",
                  "member_name": "Heraldo Guedis Lobo Filho ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "name": "TL05 - Abordagem transapical para intervenções nas válvulas aórtica e mitral: a experiência de um hospital universitário",
              "startTime": "15:00",
              "id": "PvwbWyEqsxfGk5y7qUdh",
              "agenda": [
                {
                  "member_id": "mG2QRigoVRKC0QCk8uGf",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "ZNzAUYrwkaqYYsiYljdh",
                  "topic_id": "PvwbWyEqsxfGk5y7qUdh",
                  "member_name": "Karlos Jennysson Sousa Soares",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "aNlwkmlC0g7HCk8XgXAS",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "gp64I1yhUhqhUJBTiNrh",
                  "topic_id": "PvwbWyEqsxfGk5y7qUdh",
                  "member_name": "Alexandre Magno Macario Nunes Soares ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "name": "TL06 - Haveria espaço para a intervenção na raiz ou aorta ascendente associada à valva aórtica bivalvulada para diâmetros menores que 45mm?",
              "startTime": "15:15",
              "id": "k97PPXkj74s0YSOu4DUo",
              "agenda": [
                {
                  "member_id": "9k0EGRTP67Xcz878MBZa",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "V65BKcHespBf9qC7Xq9w",
                  "topic_id": "k97PPXkj74s0YSOu4DUo",
                  "member_name": "Ricardo Ribeiro Dias ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "UyaVScV1eqscIewX3Hl9",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "rUavYmuLGhOrVHcRjf14",
                  "topic_id": "k97PPXkj74s0YSOu4DUo",
                  "member_name": "Marcelo Sávio da Silva Martins",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "name": "TL07 - Uso de corações com mais de 4 horas de isquemia: análise dos resultados em 521 transplantes consecutivos",
              "startTime": "15:30",
              "id": "DNlF996Hq0G2OZs66ri7",
              "agenda": [
                {
                  "member_id": "v931elE9XIZJxcOGdNS4",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "oSzBa3eehrQXpR8nKvEg",
                  "topic_id": "DNlF996Hq0G2OZs66ri7",
                  "member_name": "Juan Alberto Cosquillo Mejia ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "2P5sB0hUpZwpUaAScd6H",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "ryH6XGSnwENANZZBkG6l",
                  "topic_id": "DNlF996Hq0G2OZs66ri7",
                  "member_name": "Ronaldo Honorato Barros Santos",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "name": "TL08 - A experiência de um cirurgião cardiovascular com a utilização de um sistema com imagem espacial para estimulação fisiológica em pacientes que necessitam de marcapassos cardíacos",
              "startTime": "15:45",
              "id": "tyiIkMkLH9JzdWmuugpQ",
              "agenda": [
                {
                  "member_id": "HbH1jwatZQm6ly3bOqFo",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "0fYwDhAqHVyxJmrzuHWD",
                  "topic_id": "tyiIkMkLH9JzdWmuugpQ",
                  "member_name": "Eduardo Augusto Victor Rocha",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "MNTt0PEzSWSglNXPwjY3",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oZzUoEaW3XRhsL6mWghh",
                  "id": "ndD6ZAq5Eo7HiagSk6RS",
                  "topic_id": "tyiIkMkLH9JzdWmuugpQ",
                  "member_name": "Paulo Roberto Slud Brofman ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "uk3OMbPvTpFbkwnLy5bI",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "id": "5A0kKuyiVS8Z0Z3y8wZe",
              "member_name": "Valdester Cavalcante Pinto Júnior ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "m7hFAW6dwk2YCb4qDre1",
              "role_name": "Avaliador",
              "level": "a",
              "role_id": "OYeQjttFfvxFjQH8yQd5",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "id": "Boqyp0VQmjvShfxCSAXx",
              "member_name": "Acrísio Sales Valente",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "Z8uiF2pLISUKj38hBtiT",
              "role_name": "Avaliador",
              "level": "a",
              "role_id": "OYeQjttFfvxFjQH8yQd5",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "id": "FoBjGwZNlYHOQmjevdYq",
              "member_name": "Valquíria Pelisser Campagnucci ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "8vWrWlQ4IZxCMIoSQAF5",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "id": "RTWtEFIEJiIXkiKLJmet",
              "member_name": "Magaly Arrais dos Santos",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "Y90o4YcoL3yo2DzNQf0g",
              "role_name": "Avaliador",
              "level": "a",
              "role_id": "OYeQjttFfvxFjQH8yQd5",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "id": "UuvIodCvzUTfaNHVqoDi",
              "member_name": "Josalmir José Melo do Amaral ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "urqa8kheZfSyrtQUcRh6",
              "role_name": "Avaliador",
              "level": "a",
              "role_id": "OYeQjttFfvxFjQH8yQd5",
              "activity_id": "oZzUoEaW3XRhsL6mWghh",
              "id": "zpJAEqxG5KHUH6sBcHzO",
              "member_name": "Luiz Cláudio Moreira Lima ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662136986",
          "depto_id": "wBpYBXkDmoai8eadspL0",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "SESSÃO  ESPECIAL DE TEMAS LIVRES",
          "depto": "TEMAS LIVRES",
          "location": "Auditório 4",
          "startTime": "14:00",
          "id": "oZzUoEaW3XRhsL6mWghh"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "BCdHjF7hKuo3HzdgYBkl",
              "name": "Insuficiência tricúspide: intervenção percutânea ou cirurgia? /Tricuspid insufficiency: percutaneous intervention or surgery?",
              "startTime": "14:20",
              "id": "nCB1fEeInggK7gQ1HnF5",
              "agenda": [
                {
                  "member_id": "D9OFMMa4b6zhRZ90JGDg",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "BCdHjF7hKuo3HzdgYBkl",
                  "id": "qfB7ffgKliYTN2d4S6bS",
                  "topic_id": "nCB1fEeInggK7gQ1HnF5",
                  "member_name": "Giuseppe Bruschi",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "BCdHjF7hKuo3HzdgYBkl",
              "name": "Insuficiência mitral primária: quando a TEEER (Transcatheter Edge to Edge Repair - Mitraclip) pode ser opção equivalente ou melhor do que a plastia mitral?",
              "startTime": "14:35",
              "id": "LR25zirELkUvA8dVGGgM",
              "agenda": [
                {
                  "member_id": "vklFqYm25ki5o1mzphiQ",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "BCdHjF7hKuo3HzdgYBkl",
                  "id": "ifQzy1CQ5mLtBRsWTvHh",
                  "topic_id": "LR25zirELkUvA8dVGGgM",
                  "member_name": "Eduardo Keller Saadi ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "BCdHjF7hKuo3HzdgYBkl",
              "name": "Qual a melhor escolha da prótese em casos de valvopatia aórtica nos tempos de TAVI em pacientes entre 50 e 65 anos ",
              "startTime": "14:50",
              "id": "I2Ef0Com0IMmu4BWDkuv",
              "agenda": [
                {
                  "member_id": "dzKLi1kcJnITqT121rO9",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "BCdHjF7hKuo3HzdgYBkl",
                  "id": "rqSuv2PKqlMX7YMMBVFz",
                  "topic_id": "I2Ef0Com0IMmu4BWDkuv",
                  "member_name": "Mauro Paes Leme de Sá ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "BCdHjF7hKuo3HzdgYBkl",
              "name": "A oclusão do apêndice atrial esquerdo associada à cirurgia ou intervenção é segura?",
              "startTime": "15:05",
              "id": "OWwoXU63E3ZLaWFdKfqq",
              "agenda": [
                {
                  "member_id": "e30jF97J4vzs1KoU8RrL",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "BCdHjF7hKuo3HzdgYBkl",
                  "id": "YVXBlCn1WeQ1ypLT850h",
                  "topic_id": "OWwoXU63E3ZLaWFdKfqq",
                  "member_name": "Andrea Cristina Oliveira Freitas ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "BCdHjF7hKuo3HzdgYBkl",
              "name": "Qual o impacto do leak paravalvar após troca valvar aórtica cirúrgica ou transcateter?",
              "startTime": "15:20",
              "id": "bt72v9xImuj02xS89Eto",
              "agenda": [
                {
                  "member_id": "U75AfgIWBMJIX8J6CWzb",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "BCdHjF7hKuo3HzdgYBkl",
                  "id": "o4OxReeYVCalSlV5b1yI",
                  "topic_id": "bt72v9xImuj02xS89Eto",
                  "member_name": "Renato Bastos Pope ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "BCdHjF7hKuo3HzdgYBkl",
              "name": "Estratégias cirúrgicas em pacientes com anel aórtico pequeno/ Surgical strategies in patients with small aortic ring",
              "startTime": "15:35",
              "id": "yEMgUEawP2A23WkkyLPf",
              "agenda": [
                {
                  "member_id": "RcQEhCZ6GprndHbobXQG",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "BCdHjF7hKuo3HzdgYBkl",
                  "id": "xCBO6BFpFczdYazRvazD",
                  "topic_id": "yEMgUEawP2A23WkkyLPf",
                  "member_name": "Maral Ouzounian",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "BCdHjF7hKuo3HzdgYBkl",
              "name": "Discussão",
              "startTime": "15:50",
              "id": "rsRkpkPDf9PsMDbtNZpP",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "YSTjpav26KV1ydeC6v9p",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "BCdHjF7hKuo3HzdgYBkl",
              "id": "JQrcJWgDzo0eFC03vwxJ",
              "member_name": "Gustavo Ieno Judas ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "ZebI3mSmhsWZHYTKRcsw",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "BCdHjF7hKuo3HzdgYBkl",
              "id": "tGu5ws9P3oy0FwRzstxc",
              "member_name": "Renato Abdala Karam Kalil ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662092049",
          "depto_id": "u3kInDhnpMCXaHhssQHg",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA-REDONDA II",
          "depto": "SESSÃO  VÁLVULA",
          "location": "Auditório Principal",
          "startTime": "14:20",
          "id": "BCdHjF7hKuo3HzdgYBkl"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "MqPXNQnpycNTABza8ijX",
              "name": "Protocolo ERAS no Brasil: estado atual",
              "startTime": "14:20",
              "id": "VcA2d0yLpkY06wRl23sa",
              "agenda": [
                {
                  "member_id": "LGhSU3EWefWIrNY8DH39",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "MqPXNQnpycNTABza8ijX",
                  "id": "TsmK5mJU7Ue9AoyYFVnO",
                  "topic_id": "VcA2d0yLpkY06wRl23sa",
                  "member_name": "Omar Asdrubal Vilca Mejia ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "MqPXNQnpycNTABza8ijX",
              "name": "O protocolo Patient Blood Management- PBM como estratégia para cirurgia cardiovascular segura",
              "startTime": "14:35",
              "id": "eThibt7l9aLSa9k4XenI",
              "agenda": [
                {
                  "member_id": "KlWwq8iYe8E12tgFM8K8",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "MqPXNQnpycNTABza8ijX",
                  "id": "7vrN0f3CdAPaO5j1sMct",
                  "topic_id": "eThibt7l9aLSa9k4XenI",
                  "member_name": "Guilherme Rabello",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "MqPXNQnpycNTABza8ijX",
              "name": "Disseminando a cultura de segurança: o papel da CSIA/ Disseminating the culture of safety: the role of CSIA",
              "startTime": "14:50",
              "id": "bZu79jJmY2VFG72tPpMW",
              "agenda": [
                {
                  "member_id": "bLV5BRFJqwEkinXaN4M2",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "MqPXNQnpycNTABza8ijX",
                  "id": "IXPisaKYOkFIBJWL6iZJ",
                  "topic_id": "bZu79jJmY2VFG72tPpMW",
                  "member_name": "Melina Moroz Barg",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "MqPXNQnpycNTABza8ijX",
              "name": "Resultados tardios da Cirurgia de Ross",
              "startTime": "15:05",
              "id": "6X1r85uaZ15BkwzvUqwa",
              "agenda": [
                {
                  "member_id": "yp1SqWvrOgncLhVqTRyx",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "MqPXNQnpycNTABza8ijX",
                  "id": "dUacV89crFQ9RjOgNFa9",
                  "topic_id": "6X1r85uaZ15BkwzvUqwa",
                  "member_name": "Francisco Diniz Affonso da Costa",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "MqPXNQnpycNTABza8ijX",
              "name": "Como implantar um programa seguro em cirurgia robótica",
              "startTime": "15:20",
              "id": "bjJNfiDrsILACnW0Dgxv",
              "agenda": [
                {
                  "member_id": "VfFO3FTnWduNYdCq9nCY",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "MqPXNQnpycNTABza8ijX",
                  "id": "ZZ9YPXZ4eTXKLg94dO97",
                  "topic_id": "bjJNfiDrsILACnW0Dgxv",
                  "member_name": "Robinson Poffo ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "MqPXNQnpycNTABza8ijX",
              "name": "Gestão eficiente como pilar para excelência em cirurgia cardiovascular / Efficient management as a pillar for excellence in cardiovascular surgery",
              "startTime": "15:35",
              "id": "iZBBSPviZPon4gNA4BpT",
              "agenda": [
                {
                  "member_id": "iN28qdxipRgK7fX0G4Fh",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "MqPXNQnpycNTABza8ijX",
                  "id": "5jgcvCogUJChw7W7DyeR",
                  "topic_id": "iZBBSPviZPon4gNA4BpT",
                  "member_name": "Glen Van Arsdell",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "MqPXNQnpycNTABza8ijX",
              "name": "Discussão",
              "startTime": "15:50",
              "id": "CS3vFub8EIcYoV9Ph1Lw",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "8Map0XjSF9QFrEjbJ8Uj",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "MqPXNQnpycNTABza8ijX",
              "id": "E26WcTUSqe7r9IarbnrN",
              "member_name": "Renato Tambellini Arnoni ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "xBlS67SuCxOdyLWhi7zs",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "MqPXNQnpycNTABza8ijX",
              "id": "V9m5YHiV6OcZW1ar8WtJ",
              "member_name": "Nelson Américo Hossne Júnior ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662124777",
          "depto_id": "DeTA2zHryJbnpiqE6H3Q",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA IV",
          "depto": "SEGURANÇA NA CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 2",
          "startTime": "14:20",
          "id": "MqPXNQnpycNTABza8ijX"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "ZJRzgVHfpJbLJmE8iRsJ",
              "name": "As raízes da cirurgia cardiovascular brasileira e da Sociedade Brasileira de Cirurgia Cardiovascular",
              "startTime": "15:00",
              "id": "PfKVzXBlI3W4UYbYtV58",
              "agenda": [
                {
                  "member_id": "KUrfspRDNH3y1f5UxEXv",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "ZJRzgVHfpJbLJmE8iRsJ",
                  "id": "GwNq6lBxcuqDU8BUeBE4",
                  "topic_id": "PfKVzXBlI3W4UYbYtV58",
                  "member_name": "Enio Buffolo ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "ifgnNJhEmY84MFU1gQjF",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "ZJRzgVHfpJbLJmE8iRsJ",
              "id": "THiCWszaniEdv7u5NsUf",
              "member_name": "José Wanderley Neto ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "GkPljbxZKTpR5XQl9nze",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "ZJRzgVHfpJbLJmE8iRsJ",
              "id": "yGCAinIgH16ObQ3vQSR1",
              "member_name": "Ricardo de Carvalho Lima ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662142789",
          "depto_id": "NGf0C01VnQJgqQWSeYD1",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "CONFERÊNCIA",
          "depto": "ACADEMIA",
          "location": "Auditório 5",
          "startTime": "15:00",
          "id": "ZJRzgVHfpJbLJmE8iRsJ"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "AUkQOBBYKKMueCgIwO6U",
              "name": "Homenagem ao Prof. Dr. Milton Ary Meier",
              "startTime": "15:30",
              "id": "sHMMt0ozQ9uymzwL1nPL",
              "agenda": [
                {
                  "member_id": "3fH1Rx0qhLEqTM6Jqfw3",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "AUkQOBBYKKMueCgIwO6U",
                  "id": "PJcVn4twm4q7NqxWm9YF",
                  "topic_id": "sHMMt0ozQ9uymzwL1nPL",
                  "member_name": "Milton Ary Meier ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "VbemlUiQZS2XiFQdu4NW",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "AUkQOBBYKKMueCgIwO6U",
                  "id": "m44aslqR2MMYQDYGw6KA",
                  "topic_id": "sHMMt0ozQ9uymzwL1nPL",
                  "member_name": "Fernando Antonio Lucchese ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "AUkQOBBYKKMueCgIwO6U",
              "name": "Homenagem ao Prof. Dr. Gilberto Venossi Barbosa",
              "startTime": "15:45",
              "id": "iRgyhHsHBxXWe1PTQ8Fg",
              "agenda": [
                {
                  "member_id": "pw7FmMZMBTtsbcRfAVBk",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "AUkQOBBYKKMueCgIwO6U",
                  "id": "ApOSz5g1Edyv4j0KJLgN",
                  "topic_id": "iRgyhHsHBxXWe1PTQ8Fg",
                  "member_name": "José Teles de Mendonça ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "yP9v1YUaKffTWIhPxQui",
                  "role_name": "Homenageado (a)",
                  "level": "t",
                  "role_id": "1NpQkYzhKl0mHPUarvHH",
                  "activity_id": "AUkQOBBYKKMueCgIwO6U",
                  "id": "E5uc0vwPlzczTDZ4Tlc4",
                  "topic_id": "iRgyhHsHBxXWe1PTQ8Fg",
                  "member_name": "Gilberto Venossi Barbosa ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "GkPljbxZKTpR5XQl9nze",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "AUkQOBBYKKMueCgIwO6U",
              "id": "Hweh8DZnVhBoumo7OzGP",
              "member_name": "Ricardo de Carvalho Lima ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "ifgnNJhEmY84MFU1gQjF",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "AUkQOBBYKKMueCgIwO6U",
              "id": "LoPdkoMY8Gs33gorW4r9",
              "member_name": "José Wanderley Neto ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662142789",
          "depto_id": "NGf0C01VnQJgqQWSeYD1",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "SESSÃO DE HOMENAGENS",
          "depto": "ACADEMIA",
          "location": "Auditório 5",
          "startTime": "15:30",
          "id": "AUkQOBBYKKMueCgIwO6U"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "iIhM9HOgJfDSxr4mgxhD",
              "name": "P06 - Complicação durante \"Valve-In-Valve\" mitral por Via Transeptal",
              "startTime": "16:00",
              "id": "HCeODk0nCbFb7Dq23qWb",
              "agenda": [
                {
                  "member_id": "Vi7pRxvylrR04dvejEdS",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "iIhM9HOgJfDSxr4mgxhD",
                  "id": "e1shCWoHmvGIaU0ZqGLK",
                  "topic_id": "HCeODk0nCbFb7Dq23qWb",
                  "member_name": "Pedro Antônio Machado Gomes de Sousa",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "iIhM9HOgJfDSxr4mgxhD",
              "name": "P07 - Implante de Cardiodesfibrilador Epicárdico, um Relato de Caso",
              "startTime": "16:05",
              "id": "8aNwaJSnG9we06MbvZzc",
              "agenda": [
                {
                  "member_id": "GKzpZ6W4tXzDatR29wmZ",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "iIhM9HOgJfDSxr4mgxhD",
                  "id": "hDgRDog5lvND9dmWPFZR",
                  "topic_id": "8aNwaJSnG9we06MbvZzc",
                  "member_name": "Gabrielle Martins Peres ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "iIhM9HOgJfDSxr4mgxhD",
              "name": "P08 - Associação de Interrupção de Arco Aórtico com Ausência de Canal Arterial - Um Relato de Caso.",
              "startTime": "16:10",
              "id": "7gAS5oLPWX9cC3sxXHwm",
              "agenda": [
                {
                  "member_id": "iTQuvZOVhMEUlf5NvGy5",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "iIhM9HOgJfDSxr4mgxhD",
                  "id": "FvRYQw11iHsafEsvQ956",
                  "topic_id": "7gAS5oLPWX9cC3sxXHwm",
                  "member_name": "Gabriella Meneses Rocha Borges de Albuquerque",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "iIhM9HOgJfDSxr4mgxhD",
              "name": "P09 - Herniação Cardíaca em Pós-operatório Tardio de Pneumectomia Direita - Relato de Caso",
              "startTime": "16:15",
              "id": "d0RyIacO3qg82gVDhvAO",
              "agenda": [
                {
                  "member_id": "RpHhiAlwBULqUuq0Hdnb",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "iIhM9HOgJfDSxr4mgxhD",
                  "id": "UdezIPkviTax3jQF4hPq",
                  "topic_id": "d0RyIacO3qg82gVDhvAO",
                  "member_name": "Gabriel Starling Costa",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "iIhM9HOgJfDSxr4mgxhD",
              "name": "P10 - O uso do dispositivo Atriclip para exclusão de Aneurisma de Apêndice Atrial: Tratamento minimamente invasivo",
              "startTime": "16:20",
              "id": "uDfVNYHUeoVMMyrF6jQq",
              "agenda": [
                {
                  "member_id": "GpZRhTdTjvBCFvSVgyfD",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "iIhM9HOgJfDSxr4mgxhD",
                  "id": "p78qh1gtFyJcLhyxM1Db",
                  "topic_id": "uDfVNYHUeoVMMyrF6jQq",
                  "member_name": "Lívia Silva de Paula Faria ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "NsfYLwC5wmSrRbSVh17F",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "iIhM9HOgJfDSxr4mgxhD",
              "id": "5CRDzjkUtmGXqwVk6V2z",
              "member_name": "Antonio Carlos de Almeida Barbosa Filho",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "caInCe2UEo2vJ5ez9FAN",
              "role_name": "Comentador(a)",
              "level": "a",
              "role_id": "QT9ZMl0B1XnPIXfMp0mx",
              "activity_id": "iIhM9HOgJfDSxr4mgxhD",
              "id": "aftAxB4bQV3Vo9nGkqjv",
              "member_name": "Diogo Assis Souza ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709663252454",
          "depto_id": "FL6nxVyGZig87kzytMdV",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "PÔSTERES II",
          "depto": "SESSÃO DE PÔSTERES",
          "location": "Área de Exposição",
          "startTime": "16:00",
          "id": "iIhM9HOgJfDSxr4mgxhD"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "wTAB7KSGAotjeyV4YvFc",
              "name": "Visita aos Expositores ",
              "startTime": "16:00",
              "id": "KZQTGaRh90C3NyQFTuRZ",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709663252454",
          "depto_id": "0opU2hMyvevrpIXDzjeD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "INTERVALO",
          "depto": "SBCCV",
          "location": "Área de Exposição",
          "startTime": "16:00",
          "id": "wTAB7KSGAotjeyV4YvFc"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2ZdvtVejthwh7NcQ3oHt",
              "name": "Tratamento das doenças da aorta torácica: uma grande janela para o futuro/ Treatment of thoracic aortic diseases: a big window into the future",
              "startTime": "16:30",
              "id": "viUFNtDIxawonhdmgaCf",
              "agenda": [
                {
                  "member_id": "RcQEhCZ6GprndHbobXQG",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "2ZdvtVejthwh7NcQ3oHt",
                  "id": "Rr3okrOWVBLuB2gPvRJ4",
                  "topic_id": "viUFNtDIxawonhdmgaCf",
                  "member_name": "Maral Ouzounian",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "KUrfspRDNH3y1f5UxEXv",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "2ZdvtVejthwh7NcQ3oHt",
              "id": "7uUXaWO63bWPrlPcAK1n",
              "member_name": "Enio Buffolo ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662092049",
          "depto_id": "KD3Y2mWBG4jFpaus6CWT",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "SESSÃO AORTA",
          "location": "Auditório Principal",
          "startTime": "16:30",
          "id": "2ZdvtVejthwh7NcQ3oHt"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "YdkGbgGCurddR6iZiUon",
              "name": "O que é a inteligência artificial generativa: conceitos e principais vieses",
              "startTime": "16:30",
              "id": "I63m9ngfCuFsaTZlcpjF",
              "agenda": [
                {
                  "member_id": "pEMSx9Gy5bvabVn3hmUS",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "YdkGbgGCurddR6iZiUon",
                  "id": "OGtzwoe8fzOJA1tpoZNt",
                  "topic_id": "I63m9ngfCuFsaTZlcpjF",
                  "member_name": "Victor Gadelha",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "YdkGbgGCurddR6iZiUon",
              "name": "Aplicação da inteligência artificial generativa na medicina: presente e futuro",
              "startTime": "16:50",
              "id": "GAPFoV5SMzL9vbZaVLAK",
              "agenda": [
                {
                  "member_id": "1ZdmwujB8VCbexteCWYD",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "YdkGbgGCurddR6iZiUon",
                  "id": "fXjs1T7pTk34gU6cwTcU",
                  "topic_id": "GAPFoV5SMzL9vbZaVLAK",
                  "member_name": "Suely Fazio Ferraciolli",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "YdkGbgGCurddR6iZiUon",
              "name": "Aplicação da inteligência artificial generativa na medicina: abordagem prática",
              "startTime": "17:10",
              "id": "iEKQgi9xlInqmGLs4Bg5",
              "agenda": [
                {
                  "member_id": "5ahNmX5HyfHZqXjs0aP5",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "YdkGbgGCurddR6iZiUon",
                  "id": "FpTyCXonkldvsj7zgOGm",
                  "topic_id": "iEKQgi9xlInqmGLs4Bg5",
                  "member_name": "André Luppi Mota ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "YdkGbgGCurddR6iZiUon",
              "name": "A íntegra de inteligência artificial e pesquisa na cirurgia cardiovascular",
              "startTime": "17:30",
              "id": "HsROZRugq8WrGkPURVYN",
              "agenda": [
                {
                  "member_id": "fp8XIeJZ9Fd2dkVWJq0F",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "YdkGbgGCurddR6iZiUon",
                  "id": "7GFEY5fDllYu5RauS53q",
                  "topic_id": "HsROZRugq8WrGkPURVYN",
                  "member_name": "Andréia Cristina Feitosa do Carmo",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "YdkGbgGCurddR6iZiUon",
              "name": "A inteligência artificial generativa a favor do pensamento humano",
              "startTime": "17:50",
              "id": "97K8X0fgtqTuhoYC5j2I",
              "agenda": [
                {
                  "member_id": "XH4vlBYwp2pAMtDRhmpA",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "YdkGbgGCurddR6iZiUon",
                  "id": "PwKEF9oT6fVjmN51QAZE",
                  "topic_id": "97K8X0fgtqTuhoYC5j2I",
                  "member_name": "Thiago Leite Luz",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "YdkGbgGCurddR6iZiUon",
              "name": "Discussão",
              "startTime": "18:10",
              "id": "7gYRDxctOezKQjdIDICf",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "HpAQ9NQjmjwtFQlGbFXQ",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "YdkGbgGCurddR6iZiUon",
              "id": "1DStizoA8BTPr0eCUuHj",
              "member_name": "Paulo Roberto Barbosa Evora ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "p5qCiPwfNvMKW046LzEC",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "YdkGbgGCurddR6iZiUon",
              "id": "AC6jlpddhqcWV4HSSB8w",
              "member_name": "Leila Nogueira Ferreira de Barros",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662142789",
          "depto_id": "rchtbpLb6r1NLU9VKxwQ",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": " O PRESENTE E O FUTURO PRÓXIMO DA INTELIGÊNCIA ARTIFICIAL NA PUBLICAÇÃO CIENTÍFICA",
          "depto": "BJCVS",
          "location": "Auditório 5",
          "startTime": "16:30",
          "id": "YdkGbgGCurddR6iZiUon"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Zuktd2gFqD0fBDBWeirX",
              "name": "Robotically assisted mitral valve repair: state of the art",
              "startTime": "16:30",
              "id": "TMqULH7380FSt5ZqM0QK",
              "agenda": [
                {
                  "member_id": "1A7jYaqoGySa6tUTxhpo",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "Zuktd2gFqD0fBDBWeirX",
                  "id": "cl7XQFrmEYSnAiVXxGik",
                  "topic_id": "TMqULH7380FSt5ZqM0QK",
                  "member_name": "Denis Bouchard",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "ZSAm1sNI0J0iTAAEqc9L",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "Zuktd2gFqD0fBDBWeirX",
              "id": "pE8xUE0zlRzrNK8jq1Uk",
              "member_name": "Pedro Rafael Salerno ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662124777",
          "depto_id": "d41jSqncZoXyi7XvGpAq",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "SESSÃO COMO EU FAÇO",
          "location": "Auditório 2",
          "startTime": "16:30",
          "id": "Zuktd2gFqD0fBDBWeirX"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "m5CCbzzaOxKm0LTpLtXP",
              "name": "PC01 - Sistema de predição baseado em inteligência artificial para identificar pacientes com risco elevado para ocorrência de fibrilação atrial no pós-operatório de cirurgia cardíaca",
              "startTime": "16:30",
              "id": "SZYIQ4hOAaOyQwiGc2Dx",
              "agenda": [
                {
                  "member_id": "3PGBHb0C3UO8TXp9gDM2",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "jYkmD7TS8LdfYVhwYSk3",
                  "topic_id": "SZYIQ4hOAaOyQwiGc2Dx",
                  "member_name": "Jocerlano Santos de Sousa ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "50uvA0cJpDqqceyzWusk",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "lUHLM8og8GSoZK8SMePw",
                  "topic_id": "SZYIQ4hOAaOyQwiGc2Dx",
                  "member_name": "Alvaro Rösler ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "m5CCbzzaOxKm0LTpLtXP",
              "name": "PC02 - A reconstrução da raiz da aorta com preservação da valva aórtica em pacientes com Síndrome de Marfan é tão boa quanto nos não Marfans - Análise comparativa",
              "startTime": "16:45",
              "id": "NpP8u0jAJr3btM8fwldt",
              "agenda": [
                {
                  "member_id": "caHwmq8IBqzjhrKwB1Eh",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "9aJwBDFNoBuiOQl8UNmr",
                  "topic_id": "NpP8u0jAJr3btM8fwldt",
                  "member_name": "Lucas Molinari Veloso da Silveira",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "NAPjWcx02AeX9WhGu7cW",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "cYy2IoCeaTrVkNQ1Vh84",
                  "topic_id": "NpP8u0jAJr3btM8fwldt",
                  "member_name": "Luciano Rapold Souza ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "m5CCbzzaOxKm0LTpLtXP",
              "name": "PC03 - Experiência inicial em cirurgia minimamente invasiva da valva aórtica com os acessos miniesternotomia em L-invertido e minitoracotomia anterior direita",
              "startTime": "17:00",
              "id": "vEE7Z4umkvKxLbOGQHoe",
              "agenda": [
                {
                  "member_id": "ipYdVH4QVNIWxHikji4D",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "Aslj8UjJqE63RpvMCvaN",
                  "topic_id": "vEE7Z4umkvKxLbOGQHoe",
                  "member_name": "Wanewman Lins Guedes de Andrade",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "EtAfmnqDcepyhD8K2cGP",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "q0sCjClYUQKikBisQRsL",
                  "topic_id": "vEE7Z4umkvKxLbOGQHoe",
                  "member_name": "Elinthon Tavares Veronese ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "m5CCbzzaOxKm0LTpLtXP",
              "name": "PC04 - Experiência com o tratamento híbrido através da técnica do \"Frozen Elephant Trunk\" para o tratamento das doenças complexas da aorta torácica",
              "startTime": "17:15",
              "id": "179MZ43iHnIkhR0cxoas",
              "agenda": [
                {
                  "member_id": "A7jqjS8rC7rBiqvdwK9b",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "pzH5Bf6GL2asF9JIm1Ns",
                  "topic_id": "179MZ43iHnIkhR0cxoas",
                  "member_name": "Romullo Medeiros Santos",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "dzKLi1kcJnITqT121rO9",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "wy2gM7Dr57Pb9DoZyLIn",
                  "topic_id": "179MZ43iHnIkhR0cxoas",
                  "member_name": "Mauro Paes Leme de Sá ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "m5CCbzzaOxKm0LTpLtXP",
              "name": "PC05 - O STS SCORE subestima o risco cirúrgico e a mortalidade em pacientes submetidos a revascularização do miocárdio no Brasil",
              "startTime": "17:30",
              "id": "NB5ZzSjEhSxbctMKoi8v",
              "agenda": [
                {
                  "member_id": "2oZM3ijS6gEUTE35FuN5",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "s3vhCg2wKmRlutprC7IS",
                  "topic_id": "NB5ZzSjEhSxbctMKoi8v",
                  "member_name": "Pedro Borghesi Poltronieri ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "jTqlQiYMsaalx9BVnMCU",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "uaPuxBNPK1eLr8t2zpy4",
                  "topic_id": "NB5ZzSjEhSxbctMKoi8v",
                  "member_name": "Bruno Botelho Pinheiro ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "m5CCbzzaOxKm0LTpLtXP",
              "name": "PC06 - Análise do impacto dos níveis de hemoglobina glicada no pós-operatório de cirurgia de revascularização miocárdica em centro de referência",
              "startTime": "17:45",
              "id": "2mRMibIaYteC5FtGcPnU",
              "agenda": [
                {
                  "member_id": "NmiyO9n4FwyMQpFqcuZB",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "G00TzuS0MqicNzlPFuaX",
                  "topic_id": "2mRMibIaYteC5FtGcPnU",
                  "member_name": "Attila Santos Berriel",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "YcEGvs1EHY5MaUR0DcWL",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "ptKOEziGQZkg5BejYvGm",
                  "topic_id": "2mRMibIaYteC5FtGcPnU",
                  "member_name": "Rodrigo Coelho Segalote ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "m5CCbzzaOxKm0LTpLtXP",
              "name": "PC07 - Avaliação clínica de oxigenador neonatal que incorpora inovações que aumentam a segurança do sangue aspirado e drenado",
              "startTime": "18:00",
              "id": "93CuUlSqqh6AoOvYEoSn",
              "agenda": [
                {
                  "member_id": "pwRGgdGInnHNtmVajJLN",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "5rsTj4FmZwRZf1Kbi84N",
                  "topic_id": "93CuUlSqqh6AoOvYEoSn",
                  "member_name": "Carla Tanamati ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "1xdxQBBzvVGwp77X6HKl",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "wzI67x7v7sA9YobYHqgr",
                  "topic_id": "93CuUlSqqh6AoOvYEoSn",
                  "member_name": "Jesus Antonio Gutierrez Saurith ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "m5CCbzzaOxKm0LTpLtXP",
              "name": "PC08 - Uso da Cirurgia de Ross-Kono para o tratamento das lesões obstrutivas de ventrículo esquerdo em crianças: experiência inicial em centro único",
              "startTime": "18:15",
              "id": "TjpFP5eLEH2LwzIDpvFB",
              "agenda": [
                {
                  "member_id": "ojVPBcxW6WCnYtTHpsXE",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "t9vdaHjRWifV5GVzgDDi",
                  "topic_id": "TjpFP5eLEH2LwzIDpvFB",
                  "member_name": "José Cícero Stocco Guilhen ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                },
                {
                  "member_id": "IhkEw3DWE01hzwAJyxuR",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "m5CCbzzaOxKm0LTpLtXP",
                  "id": "u2RyZW7eXGn8wXSquuxo",
                  "topic_id": "TjpFP5eLEH2LwzIDpvFB",
                  "member_name": "Bruno da Costa Rocha ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "ekCcVwDIzIrMotDU7WJn",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "m5CCbzzaOxKm0LTpLtXP",
              "id": "KuUo6zjLMjz8eP3Fp3K4",
              "member_name": "Alexander John Pessoa Grant Anderson",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "PKjfvOcxsrIemox3jl4E",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "m5CCbzzaOxKm0LTpLtXP",
              "id": "MvhJDI5V6WNSqRZmFoHT",
              "member_name": "Mauro Barbosa Arruda Filho ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662136986",
          "depto_id": "FL6nxVyGZig87kzytMdV",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "PÔSTER COMENTADO",
          "depto": "SESSÃO DE PÔSTERES",
          "location": "Auditório 4",
          "startTime": "16:30",
          "id": "m5CCbzzaOxKm0LTpLtXP"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "JofTEQIV8ced5ANLubGC",
              "name": "CASO CLÍNICO 1",
              "startTime": "16:45",
              "id": "60EOQt6uwt3XyfCzY2VD",
              "agenda": [
                {
                  "member_id": "LapyFJ6x4PKGq7qMfbdg",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "JofTEQIV8ced5ANLubGC",
                  "id": "8CNE6uI9LhsEom9DC0FR",
                  "topic_id": "60EOQt6uwt3XyfCzY2VD",
                  "member_name": "Leonardo Augusto Miana",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "JofTEQIV8ced5ANLubGC",
              "name": "CASO CLÍNICO 2",
              "startTime": "17:00",
              "id": "GVx0qIVhQf8dQsUrpih5",
              "agenda": [
                {
                  "member_id": "7wgRccFQiSVeGruP4z8c",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "JofTEQIV8ced5ANLubGC",
                  "id": "HOL6omryChxKVU4L19UC",
                  "topic_id": "GVx0qIVhQf8dQsUrpih5",
                  "member_name": "Fabio Binhara Navarro ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "JofTEQIV8ced5ANLubGC",
              "name": "CASO CLÍNICO 3",
              "startTime": "17:15",
              "id": "29d4I8t4k9shFpSohSsa",
              "agenda": [
                {
                  "member_id": "uk3OMbPvTpFbkwnLy5bI",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "JofTEQIV8ced5ANLubGC",
                  "id": "Q5Ii2MvXb7vVhsOoTRAZ",
                  "topic_id": "29d4I8t4k9shFpSohSsa",
                  "member_name": "Valdester Cavalcante Pinto Júnior ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "uk3OMbPvTpFbkwnLy5bI",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "JofTEQIV8ced5ANLubGC",
              "id": "7nkua2m4VkQhKzJTQpY9",
              "member_name": "Valdester Cavalcante Pinto Júnior ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "iN28qdxipRgK7fX0G4Fh",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "JofTEQIV8ced5ANLubGC",
              "id": "DsvgnVFnYButim1577D1",
              "member_name": "Glen Van Arsdell",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "UjsGdYOu19nGJtuSpmwE",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "JofTEQIV8ced5ANLubGC",
              "id": "EeOFXjzG01UvUUckBe8d",
              "member_name": "Shai Tejmam-Yarden",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "ojVPBcxW6WCnYtTHpsXE",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "JofTEQIV8ced5ANLubGC",
              "id": "NZ8YfU5fyAhpfpoD6NHQ",
              "member_name": "José Cícero Stocco Guilhen ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "bPK40aNYW7olk4LePR1r",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "JofTEQIV8ced5ANLubGC",
              "id": "Ojwe4BGQvXYyT421iAy7",
              "member_name": "Marcelo Biscegli Jatene ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "1YRRj0zd5Kxu7qTlcNcy",
              "role_name": "Debatedor(a)",
              "level": "a",
              "role_id": "akXbIW6V3Q1UHZQzE0BF",
              "activity_id": "JofTEQIV8ced5ANLubGC",
              "id": "PAp7kqzrk8t2h3qKRuc6",
              "member_name": "Ignacio Bezerra",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "VBZgvFDBMbMvqvUcyrQ6",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "JofTEQIV8ced5ANLubGC",
              "id": "XJQtANXKf1RsVi7xHlu5",
              "member_name": "Vinicius José da Silva Nina",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "DISCUSSÃO DE CASOS CLÍNICOS",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "16:45",
          "id": "JofTEQIV8ced5ANLubGC"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "eZUSuY3HxaetcsLBVF0T",
              "name": "Correção do aneurisma da raiz da aorta com preservação da válvula aórtica: Tirone ou outra técnica?",
              "startTime": "16:50",
              "id": "0WHwGQlMWyKZ2uzLKfYm",
              "agenda": [
                {
                  "member_id": "4l3989WUqEkyDScf47UK",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "eZUSuY3HxaetcsLBVF0T",
                  "id": "TwIlk9Z1OvjFrZGyxGt4",
                  "topic_id": "0WHwGQlMWyKZ2uzLKfYm",
                  "member_name": "Marcela da Cunha Sales ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "eZUSuY3HxaetcsLBVF0T",
              "name": "Cirurgia de Ross: quem, quando e porquê",
              "startTime": "17:05",
              "id": "fJlcgo4WAHGZeUA1Q5Pj",
              "agenda": [
                {
                  "member_id": "RcQEhCZ6GprndHbobXQG",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "eZUSuY3HxaetcsLBVF0T",
                  "id": "QM2mbBGmhFtOF0Z6wzLa",
                  "topic_id": "fJlcgo4WAHGZeUA1Q5Pj",
                  "member_name": "Maral Ouzounian",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "eZUSuY3HxaetcsLBVF0T",
              "name": "Plastia mitral com neocordas",
              "startTime": "17:20",
              "id": "4rX1KH0F1axYxfQiUnae",
              "agenda": [
                {
                  "member_id": "YSTjpav26KV1ydeC6v9p",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "eZUSuY3HxaetcsLBVF0T",
                  "id": "WuBrjGDPCGFhgQaV9POw",
                  "topic_id": "4rX1KH0F1axYxfQiUnae",
                  "member_name": "Gustavo Ieno Judas ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "eZUSuY3HxaetcsLBVF0T",
              "name": "Truques e desafios no David Procedure",
              "startTime": "17:35",
              "id": "xbNgpOGjQMsWuVEZ7CJv",
              "agenda": [
                {
                  "member_id": "JyS5Mj4rUgRaqWTRMXRx",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "eZUSuY3HxaetcsLBVF0T",
                  "id": "YxHgfgaCV0xCIOBv10h5",
                  "topic_id": "xbNgpOGjQMsWuVEZ7CJv",
                  "member_name": "Cledicyon Eloy da Costa",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "eZUSuY3HxaetcsLBVF0T",
              "name": "Abordagem da valva mitral na correção da hipertrofia septal assimétrica obstrutiva",
              "startTime": "17:50",
              "id": "YE9bc8oVZaHolSlNGePV",
              "agenda": [
                {
                  "member_id": "FjybEQe6bu0giHrR1tNN",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "eZUSuY3HxaetcsLBVF0T",
                  "id": "XdAsLR3Uv66HEQnLNwys",
                  "topic_id": "YE9bc8oVZaHolSlNGePV",
                  "member_name": "Fernando Ribeiro Moraes Neto ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "eZUSuY3HxaetcsLBVF0T",
              "name": "Isquemia relacionada à coronária anômala: como revascularizar?",
              "startTime": "18:05",
              "id": "1kxpoKjEiw8PbZ5rRDC7",
              "agenda": [
                {
                  "member_id": "G7lcUh6ajYPZpR2Xf60Y",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "eZUSuY3HxaetcsLBVF0T",
                  "id": "4JSNrnUGVG7PGOU172FW",
                  "topic_id": "1kxpoKjEiw8PbZ5rRDC7",
                  "member_name": "Wilson Luiz da Silveira ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "eZUSuY3HxaetcsLBVF0T",
              "name": "Discussão Final",
              "startTime": "18:20",
              "id": "U8bQlWgAYlG9vgbiqn0Q",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "eLHjvjnNT7rXm3fCSSUa",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "eZUSuY3HxaetcsLBVF0T",
              "id": "cuKwl7ESYBroGdJ9EzYv",
              "member_name": "Ana Maria Rocha Pinto e Silva ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "7qi2vEYdO3teszgHsWwG",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "eZUSuY3HxaetcsLBVF0T",
              "id": "dLju1BdLIif5bL0VrWV0",
              "member_name": "Heraldo Guedis Lobo Filho ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662124777",
          "depto_id": "d41jSqncZoXyi7XvGpAq",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "DISCUSSÃO DE CASOS",
          "depto": "SESSÃO COMO EU FAÇO",
          "location": "Auditório 2",
          "startTime": "16:50",
          "id": "eZUSuY3HxaetcsLBVF0T"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "v64MrOADgI49dAlXMXGN",
              "name": "Alternativas para prevenir a isquemia medular",
              "startTime": "16:50",
              "id": "BHQrgvm93VQbsGvuVUO9",
              "agenda": [
                {
                  "member_id": "9k0EGRTP67Xcz878MBZa",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "v64MrOADgI49dAlXMXGN",
                  "id": "McatlFP6BMPF45uXOtdU",
                  "topic_id": "BHQrgvm93VQbsGvuVUO9",
                  "member_name": "Ricardo Ribeiro Dias ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "v64MrOADgI49dAlXMXGN",
              "name": "Na dissecção aguda tipo A devemos corrigir apenas a aorta ascendente ou estender ao arco e descendente proximal?",
              "startTime": "17:05",
              "id": "80rTs6SecVs5K2E5RLHe",
              "agenda": [
                {
                  "member_id": "487mQwdaZGJfbJ8NbJ9n",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "v64MrOADgI49dAlXMXGN",
                  "id": "PLFqnAQ9BrmjtZ3oR2W0",
                  "topic_id": "80rTs6SecVs5K2E5RLHe",
                  "member_name": "João Carlos Ferreira Leal ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "v64MrOADgI49dAlXMXGN",
              "name": "Aneurisma de aorta descendente no paciente com Marfan e outras doenças do colágeno: cirurgia convencional ou endovascular?",
              "startTime": "17:20",
              "id": "KczEvcmUc1TIgqXgAM4F",
              "agenda": [
                {
                  "member_id": "4l3989WUqEkyDScf47UK",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "v64MrOADgI49dAlXMXGN",
                  "id": "rHRCMRUoExspRQhrBlUB",
                  "topic_id": "KczEvcmUc1TIgqXgAM4F",
                  "member_name": "Marcela da Cunha Sales ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "v64MrOADgI49dAlXMXGN",
              "name": "Estratégias para o tratamento dos aneurismas tóraco-abdominais",
              "startTime": "17:35",
              "id": "vWab6JwW3fJJGOjDxYvY",
              "agenda": [
                {
                  "member_id": "Sc8INEzLO3HQm3PdgCvH",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "v64MrOADgI49dAlXMXGN",
                  "id": "McRBumPkQ3LwoRxlLInm",
                  "topic_id": "vWab6JwW3fJJGOjDxYvY",
                  "member_name": "José Augusto Duncan Santiago ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "v64MrOADgI49dAlXMXGN",
              "name": "Como tratar o hematoma intramural  e a úlcera perfurante de aorta?",
              "startTime": "17:50",
              "id": "LxGu9ET8SxmTwBKJ6Sfk",
              "agenda": [
                {
                  "member_id": "pHopGlaMmGboS9s4ZJPk",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "v64MrOADgI49dAlXMXGN",
                  "id": "B5MUEIdtyHDkiMiXwp91",
                  "topic_id": "LxGu9ET8SxmTwBKJ6Sfk",
                  "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
                  "day_id": "g6j94rLVilsQLmAraQPu"
                }
              ],
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "duration": "25",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "v64MrOADgI49dAlXMXGN",
              "name": "Discussão",
              "startTime": "18:05",
              "id": "eGtwvqLYr3uDYRjmqj2K",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [
            {
              "member_id": "8xaAN7yNUDDOVNkWcgFG",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "v64MrOADgI49dAlXMXGN",
              "id": "0ooMU5Eem0JlM8avhFRc",
              "member_name": "André Raimundo Franca Guimarães ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            },
            {
              "member_id": "pHopGlaMmGboS9s4ZJPk",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "v64MrOADgI49dAlXMXGN",
              "id": "k6RQoFZCmCwDkyn0rgkG",
              "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662092049",
          "depto_id": "KD3Y2mWBG4jFpaus6CWT",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA-REDONDA III",
          "depto": "SESSÃO AORTA",
          "location": "Auditório Principal",
          "startTime": "16:50",
          "id": "v64MrOADgI49dAlXMXGN"
        },
        {
          "date": {"_seconds": 1718334000, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "14/06",
          "topics": [
            {
              "duration": "60",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "KBRDCar4yUelBuIITW7o",
              "name": "ASSEMBLEIA SBCCV",
              "startTime": "18:30",
              "id": "djRpq4vqp2uuw2gGnvfr",
              "agenda": [],
              "day_id": "g6j94rLVilsQLmAraQPu"
            }
          ],
          "agenda": [],
          "day_id": "g6j94rLVilsQLmAraQPu",
          "location_id": "1709662092049",
          "depto_id": "0opU2hMyvevrpIXDzjeD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "ASSEMBLEIA SBCCV",
          "depto": "SBCCV",
          "location": "Auditório Principal",
          "startTime": "18:30",
          "id": "KBRDCar4yUelBuIITW7o"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "53FyKcQNDhmp4AlDkKV1",
              "name": "MICS versus Terapias Transcateter, o que ainda precisa ser dito? / MICS versus Transcatheter Therapies, what still needs to be said? ",
              "startTime": "08:00",
              "id": "IeKSoWO2CvlTpZc7LzSm",
              "agenda": [
                {
                  "member_id": "rkypLnEeHc6cO47JlH17",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "53FyKcQNDhmp4AlDkKV1",
                  "id": "bCnEZEcmHg0PhM8NbXAC",
                  "topic_id": "IeKSoWO2CvlTpZc7LzSm",
                  "member_name": "Hristof Kirov",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "1sRBX2OvshSSNxP35bWs",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "53FyKcQNDhmp4AlDkKV1",
              "id": "TANnXFZWPHyeSk1EnvIr",
              "member_name": "Sérgio Lima de Almeida ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662092049",
          "depto_id": "sfO6vtpUaOhybohGxPPs",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "MICS E ROBÓTICA",
          "location": "Auditório Principal",
          "startTime": "08:00",
          "id": "53FyKcQNDhmp4AlDkKV1"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "7GQDraZoU77TdwWWSvPz",
              "name": "Interface entre cirurgia cardiovascular e cardiologia clínica - a visão do clínico",
              "startTime": "08:00",
              "id": "dzt96ooqpvvaNhuH0sf8",
              "agenda": [
                {
                  "member_id": "av5zEU5opRhtGuSuvcda",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "7GQDraZoU77TdwWWSvPz",
                  "id": "OpGJpNodzlquL8hhv9tH",
                  "topic_id": "dzt96ooqpvvaNhuH0sf8",
                  "member_name": "Protásio Lemos da Luz",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "VBZgvFDBMbMvqvUcyrQ6",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "7GQDraZoU77TdwWWSvPz",
              "id": "GIar8ZgMfGxYSHqEmRDE",
              "member_name": "Vinicius José da Silva Nina",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662124777",
          "depto_id": "4k2qiQ1Ve7QrN4R418K4",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "SESSÃO ESPECIAL SBC",
          "location": "Auditório 2",
          "startTime": "08:00",
          "id": "7GQDraZoU77TdwWWSvPz"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "240",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "ZfryLzzFkJeHQG0vXcne",
              "name": "Edwards",
              "startTime": "08:00",
              "id": "dbIvqPp6ll9eYtkXNxYr",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1718204004696",
          "depto_id": "a6SJZuj9UJUQUJf9CtjP",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "Simuladores",
          "depto": "SESSÕES COMERCIAIS",
          "location": "Sala 1 Simulador",
          "startTime": "08:00",
          "id": "ZfryLzzFkJeHQG0vXcne"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "b5j1mG9s9Nv5Bvofoh7u",
              "name": "Desafios crescentes na formação e treinamento do cirurgião cardiovascular de hoje e do futuro. O que tem sido feito pelas instituições e pelas sociedades médicas no Brasil e no mundo",
              "startTime": "08:00",
              "id": "ibT9e1i46RUTFrIoPT1e",
              "agenda": [
                {
                  "member_id": "9bpCBQ85pG4g5h1I9TtZ",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "b5j1mG9s9Nv5Bvofoh7u",
                  "id": "uCL7FQ40iE8QXX3BBXbO",
                  "topic_id": "ibT9e1i46RUTFrIoPT1e",
                  "member_name": "Henrique Murad ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "xwv0eXrASx8uAKCrsDLh",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "b5j1mG9s9Nv5Bvofoh7u",
              "id": "xnd1riCYy3Dcfq5eVFMw",
              "member_name": "Edson Magalhães Nunes",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662136986",
          "depto_id": "v4jnCbd1oiYUZ7BVhOyD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "EDUCAÇÃO MÉDICA CONTINUADA",
          "location": "Auditório 4",
          "startTime": "08:00",
          "id": "b5j1mG9s9Nv5Bvofoh7u"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "240",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "tjBCIg4LYuyB7KmbwTJ8",
              "name": "Ethicon",
              "startTime": "08:00",
              "id": "AKODiEtbHnjtTl7tdKZH",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1718204014027",
          "depto_id": "a6SJZuj9UJUQUJf9CtjP",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "Simuladores ",
          "depto": "SESSÕES COMERCIAIS",
          "location": "Sala 2 Simulador",
          "startTime": "08:00",
          "id": "tjBCIg4LYuyB7KmbwTJ8"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
              "name": "Evidências robustas no tratamento da insuficiência mitral: prótese x valvoplastia percutânea borda-borda",
              "startTime": "08:20",
              "id": "k630UvfpEU7cVmGAUt7z",
              "agenda": [
                {
                  "member_id": "as7eHwKNPUp2qb4h9QM3",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
                  "id": "6464HHMvkLnDTBATr0wd",
                  "topic_id": "k630UvfpEU7cVmGAUt7z",
                  "member_name": "Auristela Ramos",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
              "name": "Tratamento da estenose valvar aórtica bicúspide: qual a melhor evidência para indicar TAVI x cirurgia aberta",
              "startTime": "08:40",
              "id": "CufxNE6QD76wTAGfAFgg",
              "agenda": [
                {
                  "member_id": "Pm1emtcRbkfF6hMPs6YY",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
                  "id": "9l5gomhh0KAJECjcNRjN",
                  "topic_id": "CufxNE6QD76wTAGfAFgg",
                  "member_name": "Fábio Sândoli de Brito Jr",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
              "name": "Tomada de decisão pelo Heart team na DAC complexa: a prática reflete as diretrizes?",
              "startTime": "09:00",
              "id": "BsKa2tYNnO8bjXLVUUlF",
              "agenda": [
                {
                  "member_id": "D3b9IRaPTShCijED1knv",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
                  "id": "4dgYqbsjrJlOj5zDV35F",
                  "topic_id": "BsKa2tYNnO8bjXLVUUlF",
                  "member_name": "Ricardo Pavanello",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
              "name": "Tratamento dos defeitos estruturais com as novas tecnologias: avanços e desafios",
              "startTime": "09:20",
              "id": "5IAuHgTTpJ0EEdq5sseO",
              "agenda": [
                {
                  "member_id": "vklFqYm25ki5o1mzphiQ",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
                  "id": "69bnrIDoXQMETHTJ47d3",
                  "topic_id": "5IAuHgTTpJ0EEdq5sseO",
                  "member_name": "Eduardo Keller Saadi ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
              "name": "Cardiointensivismo: como se preparar para esta nova área de atuação?",
              "startTime": "09:40",
              "id": "G1mfG8mYyhHcYmbBjoAA",
              "agenda": [
                {
                  "member_id": "pw7FmMZMBTtsbcRfAVBk",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
                  "id": "qFNCvCCUnR3hqbTUOsDa",
                  "topic_id": "G1mfG8mYyhHcYmbBjoAA",
                  "member_name": "José Teles de Mendonça ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
              "name": "Políticas Públicas na saúde cardiovascular: como podemos atuar?",
              "startTime": "10:00",
              "id": "NCabIzhq1led6GbE31L8",
              "agenda": [
                {
                  "member_id": "ifgnNJhEmY84MFU1gQjF",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
                  "id": "iO8uprkLso2xQdr2n1fK",
                  "topic_id": "NCabIzhq1led6GbE31L8",
                  "member_name": "José Wanderley Neto ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
              "name": "Discussão",
              "startTime": "10:20",
              "id": "uQucLFbQJKUjRIVOrnil",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "VBZgvFDBMbMvqvUcyrQ6",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
              "id": "Lv95tCM7OTlYwKtahw66",
              "member_name": "Vinicius José da Silva Nina",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "F8mhUjSkc2ALWeIIC2ND",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "1KIDFKeH5Gh2p6jXVcGS",
              "id": "hvg3oujWCuyYX4z3Bq9E",
              "member_name": "Sérgio Montenegro",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662124777",
          "depto_id": "4k2qiQ1Ve7QrN4R418K4",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "DILEMAS NO TRATAMENTO DAS CARDIOPATIAS COMPLEXAS E ADVOCACY",
          "depto": "SESSÃO ESPECIAL SBC",
          "location": "Auditório 2",
          "startTime": "08:20",
          "id": "1KIDFKeH5Gh2p6jXVcGS"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "VZHZke0PZrs6vcAEjBCe",
              "name": "Plástica da valva mitral robótica",
              "startTime": "08:20",
              "id": "0pl5w19y3ZRKPAh7RYBa",
              "agenda": [
                {
                  "member_id": "BQ1OXriXdZWCo3YpsGHb",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "VZHZke0PZrs6vcAEjBCe",
                  "id": "yuRVor9az7rlEBYs42Uc",
                  "topic_id": "0pl5w19y3ZRKPAh7RYBa",
                  "member_name": "Paulo César Santos ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "VZHZke0PZrs6vcAEjBCe",
              "name": "Tratamento minimamente invasivo da fibrilação atrial",
              "startTime": "08:35",
              "id": "yvtinprXSanJRH6dNGGl",
              "agenda": [
                {
                  "member_id": "momWB9r97qBCF7ipcNZ0",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "VZHZke0PZrs6vcAEjBCe",
                  "id": "B9akU3PrGF4tBCl6dh07",
                  "topic_id": "yvtinprXSanJRH6dNGGl",
                  "member_name": "Anderson da Silva Terrazas ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "VZHZke0PZrs6vcAEjBCe",
              "name": "Revascularização do miocárdio multivascular minimamente invasiva",
              "startTime": "08:50",
              "id": "MHazp7b34IkfadEwxxjS",
              "agenda": [
                {
                  "member_id": "rzl2SSIWN0s5Wq0xMSbk",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "VZHZke0PZrs6vcAEjBCe",
                  "id": "CHj2OFjJyLrjZ82lkCyb",
                  "topic_id": "MHazp7b34IkfadEwxxjS",
                  "member_name": "Luís Roberto Palma Dallan ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "VZHZke0PZrs6vcAEjBCe",
              "name": "Os resultados mostram vantagem na troca valvar aórtica por cirurgia minimamente invasiva?",
              "startTime": "09:05",
              "id": "WR4JeX2n7OZmuwotN1ps",
              "agenda": [
                {
                  "member_id": "ipYdVH4QVNIWxHikji4D",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "VZHZke0PZrs6vcAEjBCe",
                  "id": "TpzSIMBcZGDU2VQn744y",
                  "topic_id": "WR4JeX2n7OZmuwotN1ps",
                  "member_name": "Wanewman Lins Guedes de Andrade",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "VZHZke0PZrs6vcAEjBCe",
              "name": "Troca valvar aórtica por minitoracotomia antero-lateral ",
              "startTime": "09:20",
              "id": "G42Ey8ARrTrm96zasDm5",
              "agenda": [
                {
                  "member_id": "JUoLceN6nVddGAiBiJzn",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "VZHZke0PZrs6vcAEjBCe",
                  "id": "ZnLTin1NRTe849SG7hE0",
                  "topic_id": "G42Ey8ARrTrm96zasDm5",
                  "member_name": "Ricardo Adala Benfatti ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "VZHZke0PZrs6vcAEjBCe",
              "name": "O tempo de circulação extracorpórea na MICS ainda é um problema em 2024?",
              "startTime": "09:35",
              "id": "oGkTqVVA5NDq4qKLiGEM",
              "agenda": [
                {
                  "member_id": "CAXRyYBoEGo7TzzuYL31",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "VZHZke0PZrs6vcAEjBCe",
                  "id": "nRtC5NiaArRTGkbHz0kj",
                  "topic_id": "oGkTqVVA5NDq4qKLiGEM",
                  "member_name": "Melchior Luiz Lima ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "VZHZke0PZrs6vcAEjBCe",
              "name": "Cirurgia minimmamente invasiva da valva aórtica e mitral Tips and Tricks",
              "startTime": "09:50",
              "id": "QsJTjju0zaHtU1WSjRbr",
              "agenda": [
                {
                  "member_id": "nogq5P5D7b3aSVHF6goW",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "VZHZke0PZrs6vcAEjBCe",
                  "id": "JCL7nfFwGPVdJQCWcsK3",
                  "topic_id": "QsJTjju0zaHtU1WSjRbr",
                  "member_name": "Milton de Miranda Santoro ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "VZHZke0PZrs6vcAEjBCe",
              "name": "É possível obter a mesma qualidade de revascularização da cirurgia convencional com a cirurgia minimamente invasiva? -  Is it possible to obtain the same quality of revascularization as conventional surgery with minimally invasive surgery?",
              "startTime": "10:05",
              "id": "hRS1dxmzKHgWWm1brcSr",
              "agenda": [
                {
                  "member_id": "rkypLnEeHc6cO47JlH17",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "VZHZke0PZrs6vcAEjBCe",
                  "id": "o7WdtBFz1rSNYIN8hNkf",
                  "topic_id": "hRS1dxmzKHgWWm1brcSr",
                  "member_name": "Hristof Kirov",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "VZHZke0PZrs6vcAEjBCe",
              "name": "Discussão",
              "startTime": "10:20",
              "id": "TID2yOjkzEh0AETTuUWX",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "momWB9r97qBCF7ipcNZ0",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "VZHZke0PZrs6vcAEjBCe",
              "id": "AcfmDAUEYupQgHqspoBA",
              "member_name": "Anderson da Silva Terrazas ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "VfFO3FTnWduNYdCq9nCY",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "VZHZke0PZrs6vcAEjBCe",
              "id": "ZWT7YGjNimvbxQiMqHj0",
              "member_name": "Robinson Poffo ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662092049",
          "depto_id": "sfO6vtpUaOhybohGxPPs",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA V",
          "depto": "MICS E ROBÓTICA",
          "location": "Auditório Principal",
          "startTime": "08:20",
          "id": "VZHZke0PZrs6vcAEjBCe"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "zWF7lYf1P9qWerdfq21F",
              "name": "A importância da simulação no treinamento dos residentes em cirurgia cardiovascular",
              "startTime": "08:20",
              "id": "6k2s5wDdtH8u4f6PZB8B",
              "agenda": [
                {
                  "member_id": "k65dMcKtptW5VfLwYqpH",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "zWF7lYf1P9qWerdfq21F",
                  "id": "ZcEYpT7ToJ4p4nsjuYlX",
                  "topic_id": "6k2s5wDdtH8u4f6PZB8B",
                  "member_name": "Filipe Tomasi Keppen Sequeira de Almeida ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "zWF7lYf1P9qWerdfq21F",
              "name": "Avaliação do resultado do acesso direto na residência em cirurgia cardiovascular",
              "startTime": "08:35",
              "id": "YhHcoTvb8POSRwdEljvQ",
              "agenda": [
                {
                  "member_id": "p5qCiPwfNvMKW046LzEC",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "zWF7lYf1P9qWerdfq21F",
                  "id": "n8FMRsLeKRMUQ9a1N0Mn",
                  "topic_id": "YhHcoTvb8POSRwdEljvQ",
                  "member_name": "Leila Nogueira Ferreira de Barros",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "zWF7lYf1P9qWerdfq21F",
              "name": "O papel da SBCCV na avaliação da formação dos residentes em cirurgia cardiovascular",
              "startTime": "08:50",
              "id": "rtHpaHurWPFyukBuvlUE",
              "agenda": [
                {
                  "member_id": "pHopGlaMmGboS9s4ZJPk",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "zWF7lYf1P9qWerdfq21F",
                  "id": "yJ1JO1n8fiYlOYD6psIu",
                  "topic_id": "rtHpaHurWPFyukBuvlUE",
                  "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "zWF7lYf1P9qWerdfq21F",
              "name": "Programas de Fellowship em cirugia cardiovascular no Brasil",
              "startTime": "09:05",
              "id": "RYmVZ5KpUTxYOMfT9JMq",
              "agenda": [
                {
                  "member_id": "IhkEw3DWE01hzwAJyxuR",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "zWF7lYf1P9qWerdfq21F",
                  "id": "6f883czLmcqj81ozR09z",
                  "topic_id": "RYmVZ5KpUTxYOMfT9JMq",
                  "member_name": "Bruno da Costa Rocha ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "zWF7lYf1P9qWerdfq21F",
              "name": "Conhecimento em gestão financeira para a consolidação da carreira em cirurgia cardiovascular",
              "startTime": "09:20",
              "id": "sRZsCaJyiyWlsasJIliz",
              "agenda": [
                {
                  "member_id": "VbemlUiQZS2XiFQdu4NW",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "zWF7lYf1P9qWerdfq21F",
                  "id": "FZSKWqqJ3TOMKDcCVbMm",
                  "topic_id": "sRZsCaJyiyWlsasJIliz",
                  "member_name": "Fernando Antonio Lucchese ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "zWF7lYf1P9qWerdfq21F",
              "name": "Pós-graduação em cirurgia cardiovascular no Brasil",
              "startTime": "09:35",
              "id": "rHJ71SRoMrgfgeXixjLs",
              "agenda": [
                {
                  "member_id": "3YKHsRROT0UV32P4W7Wm",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "zWF7lYf1P9qWerdfq21F",
                  "id": "6Ni3cN4PHrsz4SEY4Civ",
                  "topic_id": "rHJ71SRoMrgfgeXixjLs",
                  "member_name": "Paulo Manuel Pêgo-Fernandes ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "zWF7lYf1P9qWerdfq21F",
              "name": "A saúde mental do cirurgião cardiovascular. O que precisamos saber",
              "startTime": "09:50",
              "id": "goAcyQ4GUMGxiggLOioi",
              "agenda": [
                {
                  "member_id": "HbH1jwatZQm6ly3bOqFo",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "zWF7lYf1P9qWerdfq21F",
                  "id": "tKvO15r582ZVLapWS3LL",
                  "topic_id": "goAcyQ4GUMGxiggLOioi",
                  "member_name": "Eduardo Augusto Victor Rocha",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "zWF7lYf1P9qWerdfq21F",
              "name": "Acadêmicos e Ligas em cirurgia cardiovascular",
              "startTime": "10:05",
              "id": "lvrREduuY2CUWKsSoZYi",
              "agenda": [
                {
                  "member_id": "MylcOYoQFfJTDotsLSCv",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "zWF7lYf1P9qWerdfq21F",
                  "id": "fnL7c6gJYG7PHU0qsLIO",
                  "topic_id": "lvrREduuY2CUWKsSoZYi",
                  "member_name": "Amanda Arrais Bento de Souza",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "zWF7lYf1P9qWerdfq21F",
              "name": "Discussão",
              "startTime": "10:20",
              "id": "eLDG3VfRwC9WDWVJmIvF",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "tMtH7TBX5OeR4DXgaTF6",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "zWF7lYf1P9qWerdfq21F",
              "id": "RraqdroQpZcbsqUMVchV",
              "member_name": "Pablo Maria A. Pomerantzeff ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "Z8uiF2pLISUKj38hBtiT",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "zWF7lYf1P9qWerdfq21F",
              "id": "mFvN0AOWOQegZv1HBXAG",
              "member_name": "Valquíria Pelisser Campagnucci ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662136986",
          "depto_id": "v4jnCbd1oiYUZ7BVhOyD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA IX",
          "depto": "EDUCAÇÃO MÉDICA CONTINUADA",
          "location": "Auditório 4",
          "startTime": "08:20",
          "id": "zWF7lYf1P9qWerdfq21F"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "C4GtRMu4KuF6iTLli8Xf",
              "name": "Qual o momento ideal para troca valvar pulmonar na insuficiência pós-correção de Tetralogia de Fallot?",
              "startTime": "08:30",
              "id": "kIy93KocXNQcXpYjdAPV",
              "agenda": [
                {
                  "member_id": "mhJB0SuYtcugC3F5N1MT",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "C4GtRMu4KuF6iTLli8Xf",
                  "id": "ky1bwl6Vtod4Bvpe3O0G",
                  "topic_id": "kIy93KocXNQcXpYjdAPV",
                  "member_name": "Paulo Roberto Lunardi Prates ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "C4GtRMu4KuF6iTLli8Xf",
              "name": "Quais próteses valvares disponíveis para VSVD e suas particularidades? Existe alguma superior?",
              "startTime": "08:45",
              "id": "Ren1Qf0JYQGpstadPiOc",
              "agenda": [
                {
                  "member_id": "ZSAm1sNI0J0iTAAEqc9L",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "C4GtRMu4KuF6iTLli8Xf",
                  "id": "reA3MEuMyobD3A9zX8hE",
                  "topic_id": "Ren1Qf0JYQGpstadPiOc",
                  "member_name": "Pedro Rafael Salerno ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "C4GtRMu4KuF6iTLli8Xf",
              "name": "Substituição com tubo de PTFE valvulado. Quais os resultados até agora?",
              "startTime": "09:00",
              "id": "hV7BP9vXvNYDOLI95rsj",
              "agenda": [
                {
                  "member_id": "7wgRccFQiSVeGruP4z8c",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "C4GtRMu4KuF6iTLli8Xf",
                  "id": "kn5OPDEiwk1RmHbaxcxX",
                  "topic_id": "hV7BP9vXvNYDOLI95rsj",
                  "member_name": "Fabio Binhara Navarro ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "C4GtRMu4KuF6iTLli8Xf",
              "name": "Discussão",
              "startTime": "09:15",
              "id": "qtq2a8NsEp7jcAy6kXm0",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "CmAlnnrzjRt13rIfjULG",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "C4GtRMu4KuF6iTLli8Xf",
              "id": "5lE39vZmCatGKS7Rc9Bm",
              "member_name": "Eduardo Miranda Teixeira",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "RYDKllEwxDZR8rGlgksq",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "C4GtRMu4KuF6iTLli8Xf",
              "id": "vjmXuCc1UpVgt2xmPUCc",
              "member_name": "Fernando Antonio Fantini ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA - OPERAÇÕES SOBRE A VIA DE SAÍDA DO VD",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "08:30",
          "id": "C4GtRMu4KuF6iTLli8Xf"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
              "name": "TL09 - Desafios logísticos na alocação de corações no Brasil: uma análise dos transplantes interestaduais",
              "startTime": "08:30",
              "id": "WCT55uNQk1kmGIW6j9uI",
              "agenda": [
                {
                  "member_id": "1mnU1YxNND7gFlsAt2Rg",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "3ePNJGiWffeDhOXNP3Kp",
                  "topic_id": "WCT55uNQk1kmGIW6j9uI",
                  "member_name": "Shirlyne Fabianni Dias Gaspar ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "RzhhxnIjXUFxXnBViKDk",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "mJQgmSnzPW6rFRnIiuQm",
                  "topic_id": "WCT55uNQk1kmGIW6j9uI",
                  "member_name": "Fernando Antibas Atik ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
              "name": "TL10 - Impacto da COVID-19 na sobrevivência de pacientes submetidos a cirurgia de revascularização do miocárdio",
              "startTime": "08:45",
              "id": "HLPVd2cqpz9nHdjsZTyJ",
              "agenda": [
                {
                  "member_id": "FosE0Q7Hd7wjyEK2oIww",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "DOoM82hLcSxhDahuPTsp",
                  "topic_id": "HLPVd2cqpz9nHdjsZTyJ",
                  "member_name": "Ricardo Nilsson Sgarbieri ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "tf3oLkNVCVXfHGH4ftNY",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "dtZw04l3RCYX40GpObT6",
                  "topic_id": "HLPVd2cqpz9nHdjsZTyJ",
                  "member_name": "Herbert Freyre Ríos",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
              "name": "TL11 - Escore de risco de sangramento em pacientes no pós-operatório imediato e precoce de cirurgia valvar",
              "startTime": "09:00",
              "id": "H7kSbvyMetXcZLiadlKP",
              "agenda": [
                {
                  "member_id": "vsJksbsfilmzwNOWqFeq",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "geEhZzY5ouvshCP9irSO",
                  "topic_id": "H7kSbvyMetXcZLiadlKP",
                  "member_name": "Alef de Carvalho Vieira",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "5oDJONxb6KKoNRImsWEj",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "nR6Pw82TgOBx52dbnxpV",
                  "topic_id": "H7kSbvyMetXcZLiadlKP",
                  "member_name": "Fabrício José de Souza Dinato ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
              "name": "TL12 - Suporte externo personalizado da raiz da aorta (PEARS) no tratamento dos aneurismas da Síndrome de Marfan e de valva aórtica bicúspide: primeira série de casos no continente americano",
              "startTime": "09:15",
              "id": "3vVO0zZGQUbFfeWeuEuL",
              "agenda": [
                {
                  "member_id": "ZebI3mSmhsWZHYTKRcsw",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "XeS4F2PMm4h8PhdguDfu",
                  "topic_id": "3vVO0zZGQUbFfeWeuEuL",
                  "member_name": "Renato Abdala Karam Kalil ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "5q4e8ZV6KSSHFKZhPVit",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "cVQmiG3pw7dAUfvX3KPg",
                  "topic_id": "3vVO0zZGQUbFfeWeuEuL",
                  "member_name": "Sérgio da Costa Rayol",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
              "name": "TL13 - Análise clínica e hemodinâmica de pacientes submetidos a implante, por via transfemoral, de prótese aórtica transcateter de fabricação nacional",
              "startTime": "09:30",
              "id": "VEyfdUnLburHBaUuFvdt",
              "agenda": [
                {
                  "member_id": "AtXcVcGzQRhRm88BYtTT",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "GP1RhYfvr2ZrOvq1KWB9",
                  "topic_id": "VEyfdUnLburHBaUuFvdt",
                  "member_name": "Felipe Reale Cividanes ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "l4rDJlQU0bo35wLxJrv0",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "xtJa8PvMzLbYMN8Dup7E",
                  "topic_id": "VEyfdUnLburHBaUuFvdt",
                  "member_name": "Arnaldo Akio Okino ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
              "name": "TL14 - Disfunção primária de enxerto em pacientes adultos submetidos a transplante cardíaco: análise da expressão gênica",
              "startTime": "09:45",
              "id": "Y2f0VZcWHAAsdep8yb8b",
              "agenda": [
                {
                  "member_id": "TNegaNCo8I6SdabN45Gc",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "LapTiRNbOu4habl78IsF",
                  "topic_id": "Y2f0VZcWHAAsdep8yb8b",
                  "member_name": "Samuel Padovani Steffen ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "OnihPyWjPMkA6mJRMfwr",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "sut7p7XwSWYp3tKSMxGy",
                  "topic_id": "Y2f0VZcWHAAsdep8yb8b",
                  "member_name": "Cláudio Leo Gelape ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
              "name": "TL15 - Omeprazole and methylene blue's effects in an animal model of cardiac ischemia and reperfusion and possible application for the pharmacological approach to vasoplegic syndrome",
              "startTime": "10:00",
              "id": "KOSqJv0UOH7mlRO1ogcW",
              "agenda": [
                {
                  "member_id": "ksgFBN706h9DXrcpd5fE",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "IyLHoXr3E7MEfYRvmSpm",
                  "topic_id": "KOSqJv0UOH7mlRO1ogcW",
                  "member_name": "Mariana Chisté Ferreira",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "5ahNmX5HyfHZqXjs0aP5",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "TnclzATTgxU4moZlx9JA",
                  "topic_id": "KOSqJv0UOH7mlRO1ogcW",
                  "member_name": "André Luppi Mota ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
              "name": "TL16 - Resultados em longo prazo do implante valvar aórtico transcateter: estudo de coorte com seguimento clínico de onze anos",
              "startTime": "10:15",
              "id": "nBQEW3PgiqP98ofs8PWR",
              "agenda": [
                {
                  "member_id": "z7koAlJEGjYXiGA4TL4k",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "9hvJpNmdXnQxGUzo9Izt",
                  "topic_id": "nBQEW3PgiqP98ofs8PWR",
                  "member_name": "Luciano Abdallah Ferreira ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "50uvA0cJpDqqceyzWusk",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
                  "id": "O7Dij2f9F6fqXXBtuCnQ",
                  "topic_id": "nBQEW3PgiqP98ofs8PWR",
                  "member_name": "Alvaro Rösler ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "Nci7AIXDEKQ27UR2Ryfu",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
              "id": "5uZCsxUCsUcmTZV22FIw",
              "member_name": "Carlos Manuel de Almeida Brandão ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "Evtzg8PI0eTjewEFOEe2",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "IP0QkUPxgFn5EBX0vqeZ",
              "id": "LH2Y57tu5kjGr6eQedJr",
              "member_name": "José Lira Mendes Filho ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662142789",
          "depto_id": "wBpYBXkDmoai8eadspL0",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "TEMAS LIVRES II",
          "depto": "TEMAS LIVRES",
          "location": "Auditório 5",
          "startTime": "08:30",
          "id": "IP0QkUPxgFn5EBX0vqeZ"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oEKOaeMdFBbREnb695jk",
              "name": "Vídeo 1  - Preservação do anel pulmonar e correção da angulação da APE na Tetralogia de Fallot / Pulmonary Valve Sparing Tetralogy of Fallot repair and Left Pulmonary Artery enlargement",
              "startTime": "09:30",
              "id": "BrajDq3wAtGMh3oaa4U4",
              "agenda": [
                {
                  "member_id": "iN28qdxipRgK7fX0G4Fh",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oEKOaeMdFBbREnb695jk",
                  "id": "PMKswnrd1Cfv0XRo8itg",
                  "topic_id": "BrajDq3wAtGMh3oaa4U4",
                  "member_name": "Glen Van Arsdell",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oEKOaeMdFBbREnb695jk",
              "name": "Vídeo 2  - Correção de cardiopatia congênita + estenose traqueal congênita",
              "startTime": "09:45",
              "id": "AOmdtiROzlyWXCatqhgQ",
              "agenda": [
                {
                  "member_id": "HiKwZGC9JxBw28x7X1ub",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oEKOaeMdFBbREnb695jk",
                  "id": "YuRrqfnQcR6xq030mnQr",
                  "topic_id": "AOmdtiROzlyWXCatqhgQ",
                  "member_name": "Beatriz Helena S. Furlanetto ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oEKOaeMdFBbREnb695jk",
              "name": "Vídeo 3 - Técnica de implante de marcapasso bicameral em câmeras esquerdas",
              "startTime": "10:00",
              "id": "kspxJugmUWiLFf5Nfr61",
              "agenda": [
                {
                  "member_id": "IhkEw3DWE01hzwAJyxuR",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oEKOaeMdFBbREnb695jk",
                  "id": "YLyt278mEvO3r3NwuOTN",
                  "topic_id": "kspxJugmUWiLFf5Nfr61",
                  "member_name": "Bruno da Costa Rocha ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oEKOaeMdFBbREnb695jk",
              "name": "Vídeo 4 -  Reparo da válvula aórtica / Customized aortic valve reconstruction in children",
              "startTime": "10:15",
              "id": "pGpHdEc6bOLyrSSLSuEp",
              "agenda": [
                {
                  "member_id": "1YRRj0zd5Kxu7qTlcNcy",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "oEKOaeMdFBbREnb695jk",
                  "id": "6fAom639hoEpMf04JVaY",
                  "topic_id": "pGpHdEc6bOLyrSSLSuEp",
                  "member_name": "Ignacio Bezerra",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "LapyFJ6x4PKGq7qMfbdg",
              "role_name": "Moderador(a)",
              "level": "a",
              "role_id": "6QisZ6kM0eraJV2egjJa",
              "activity_id": "oEKOaeMdFBbREnb695jk",
              "id": "5fPsS1IoPpE6KxhFwbQS",
              "member_name": "Leonardo Augusto Miana",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "RzhhxnIjXUFxXnBViKDk",
              "role_name": "Moderador(a)",
              "level": "a",
              "role_id": "6QisZ6kM0eraJV2egjJa",
              "activity_id": "oEKOaeMdFBbREnb695jk",
              "id": "andpsw1UTio6EJ2VJYtB",
              "member_name": "Fernando Antibas Atik ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "SESSÃO DE  VÍDEOS",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "09:30",
          "id": "oEKOaeMdFBbREnb695jk"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "MvEh5jd4z1UwDXbWhqbl",
              "name": "Visita aos Expositores ",
              "startTime": "10:30",
              "id": "9QhLevV6nl9YSwu5cbil",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709663252454",
          "depto_id": "0opU2hMyvevrpIXDzjeD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "INTERVALO E VISITA AOS EXPOSITORES",
          "depto": "SBCCV",
          "location": "Área de Exposição",
          "startTime": "10:30",
          "id": "MvEh5jd4z1UwDXbWhqbl"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "p9XbSSqyo1w8ptx2jeia",
              "name": "Apresentação dos resultados da Gestão",
              "startTime": "10:50",
              "id": "cV7nbCE2CWyRxugXQ63C",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "dmBJ4PuwRRIZOc6Cnjd1",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "p9XbSSqyo1w8ptx2jeia",
              "id": "ALrSiAuA1ZZ4PgExhOWP",
              "member_name": "Marco Antonio de Sousa do Vale ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "psfgBJto2mJevPxg6QEJ",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "p9XbSSqyo1w8ptx2jeia",
              "id": "DVmUBFnvAsguhkQOG5vG",
              "member_name": "Antonio de Jesus Chaves Junior",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "ErQ9Pd1VpuabuXHgLpfn",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "p9XbSSqyo1w8ptx2jeia",
              "id": "DX6bAF4ytQ3tFh93frUd",
              "member_name": "Patrícia Cristina Celestino",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "MylcOYoQFfJTDotsLSCv",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "p9XbSSqyo1w8ptx2jeia",
              "id": "Kx8Z2gcCngGHkvuUhHwu",
              "member_name": "Amanda Arrais Bento de Souza",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "ubeKErl515Mt9yaGHqi3",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "p9XbSSqyo1w8ptx2jeia",
              "id": "pop3mBwTXeeAsfgRUEFd",
              "member_name": "Moisés Barbosa de Andrade ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662136986",
          "depto_id": "OLg0OAKHpv8TocDsXPsm",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "Abertura do 13º Congresso Acadêmico de Cirurgia Cardiovascular ",
          "depto": "13º CONGRESSO ACADÊMICO DE CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 4",
          "startTime": "10:50",
          "id": "p9XbSSqyo1w8ptx2jeia"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
              "name": "Valvoplastia com balão no RN e lactente: prós e contras",
              "startTime": "11:00",
              "id": "QFse8fcuMrs9YyGopEnL",
              "agenda": [
                {
                  "member_id": "DELixrwkNaxoaXQWBQOE",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
                  "id": "fIMdtyoDUHeUal798yCi",
                  "topic_id": "QFse8fcuMrs9YyGopEnL",
                  "member_name": "Marcelo Ribeiro",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
              "name": "Valvoplastia cirúrgica no RN e lactente: prós e contras",
              "startTime": "11:15",
              "id": "sfpseIlTQFyYQjEjA9bi",
              "agenda": [
                {
                  "member_id": "dSLHPzKH0oiuukq43W10",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
                  "id": "lXqRRz7yGs1xp1gE8jo3",
                  "topic_id": "sfpseIlTQFyYQjEjA9bi",
                  "member_name": "Renato Samy Assad ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
              "name": "Advanced simulation models are able to predict results in percutaneous x surgery in neonates?",
              "startTime": "11:30",
              "id": "U0RqNlscSHSArGaFcBxJ",
              "agenda": [
                {
                  "member_id": "UjsGdYOu19nGJtuSpmwE",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
                  "id": "ND0mT0E03LoQXrSd4Fqw",
                  "topic_id": "U0RqNlscSHSArGaFcBxJ",
                  "member_name": "Shai Tejmam-Yarden",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
              "name": "Troca valvar aórtica em pacientes pediátricos. O que fazer quando não temos outra opção?",
              "startTime": "11:45",
              "id": "WRxFkln5HCCpjU6eYs0B",
              "agenda": [
                {
                  "member_id": "uk3OMbPvTpFbkwnLy5bI",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
                  "id": "NCr70tyGOL4LxwRY8iV6",
                  "topic_id": "WRxFkln5HCCpjU6eYs0B",
                  "member_name": "Valdester Cavalcante Pinto Júnior ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
              "name": "Cirurgia de Ozaki: uma boa opção para adolescentes e adultos jovens?",
              "startTime": "12:00",
              "id": "tSC0WRKZLA1gMXMg0EEZ",
              "agenda": [
                {
                  "member_id": "knPKVy27FPLqJGcHj9Hs",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
                  "id": "4qq54xQrSkLvyOGVP8Uc",
                  "topic_id": "tSC0WRKZLA1gMXMg0EEZ",
                  "member_name": "Valdano Mateus Correia Osório Manuel",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
              "name": "Aortic valve repair and Ross+Kono procedure",
              "startTime": "12:15",
              "id": "Gr56nnTocCvAksDj99GJ",
              "agenda": [
                {
                  "member_id": "iN28qdxipRgK7fX0G4Fh",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
                  "id": "Zj4Is6dU5P3zuXWCWRlz",
                  "topic_id": "Gr56nnTocCvAksDj99GJ",
                  "member_name": "Glen Van Arsdell",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
              "name": "Discussão",
              "startTime": "12:30",
              "id": "nRRXukgCAiTu83ug7P3H",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "Y9UL5zc8uOu7hUxm1O41",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
              "id": "WObTykcphbG6rOczZ3cn",
              "member_name": "Denoel Marcelino Oliveira ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "G7lcUh6ajYPZpR2Xf60Y",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "ENfzzgRLXcc9TFZwZ9z6",
              "id": "nMehLEVXzzXR3V9Pt0mO",
              "member_name": "Wilson Luiz da Silveira ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA - CIRURGIA DA VALVA AÓRTICA EM CIRURGIA CARDIOVASCULAR PEDIÁTRICA",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "11:00",
          "id": "ENfzzgRLXcc9TFZwZ9z6"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "JCeJKcbnKEBnJQMSHKWK",
              "name": "Avanços e perspectivas no tratamento transcateter das doenças estruturais cardíacas",
              "startTime": "11:00",
              "id": "XEvep2YyFSFby5vfwlcl",
              "agenda": [
                {
                  "member_id": "5yrGDXcl3mMyHZSJbuow",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "JCeJKcbnKEBnJQMSHKWK",
                  "id": "OOmMIuAw8E2A0l7uN28A",
                  "topic_id": "XEvep2YyFSFby5vfwlcl",
                  "member_name": "José Honório de Almeida Palma Fonseca",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "KUrfspRDNH3y1f5UxEXv",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "JCeJKcbnKEBnJQMSHKWK",
              "id": "JwRT4Pzqvv2F81pUNVOP",
              "member_name": "Enio Buffolo ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662092049",
          "depto_id": "yzJuE4VuCn9Mprf4cSqN",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "DEFEITOS ESTRUTURAIS",
          "location": "Auditório Principal",
          "startTime": "11:00",
          "id": "JCeJKcbnKEBnJQMSHKWK"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "name": "TLL01 - Avaliação do impacto da reoperação e dos procedimentos associados no resultado das operações dos aneurismas da raiz da aorta e da aorta ascendente",
              "startTime": "11:00",
              "id": "7NjbkEg8NxW1TVrobrIp",
              "agenda": [
                {
                  "member_id": "2eC5tG3Rf3IgH8ZRNRA0",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "JWxFeej6ueFFnyzpqQEk",
                  "id": "XgRA1iCIEFWJzi1XkzWO",
                  "topic_id": "7NjbkEg8NxW1TVrobrIp",
                  "member_name": "Fabrício Lara Carvalho",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "zYDLh4xGxhL3IgftowDq",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "JWxFeej6ueFFnyzpqQEk",
                  "id": "aKUD1hgD46BpoyJGlNwg",
                  "topic_id": "7NjbkEg8NxW1TVrobrIp",
                  "member_name": "Aldrei Costa Araújo",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "name": "TLL02 - Transplante cardíaco com corações captados fora do Estado de São Paulo, utilizando-se a preservação hipotérmica estática: análise da experiência de 102 casos do maior Centro transplantador do Brasil",
              "startTime": "11:15",
              "id": "iWtc9Nk5D64JC2YMqpOl",
              "agenda": [
                {
                  "member_id": "LHp66lMTiqQ3ZbPXi51K",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "JWxFeej6ueFFnyzpqQEk",
                  "id": "7qukF4SnFalkU2mz8w8R",
                  "topic_id": "iWtc9Nk5D64JC2YMqpOl",
                  "member_name": "Gabriel Rodrigues Bittencourt ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "J5XrbAnMvBOgM7IU08pE",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "JWxFeej6ueFFnyzpqQEk",
                  "id": "GK4XQp9yIFp0LgZQ5QDk",
                  "topic_id": "iWtc9Nk5D64JC2YMqpOl",
                  "member_name": "Giovanna Fávero Cano",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "name": "TLL03 -  Cirurgia de revascularização do miocárdio com e sem circulação extracorpórea: um estudo comparativo com pacientes da região sudeste do Brasil nos últimos 5 anos",
              "startTime": "11:30",
              "id": "8d8jWOJ46MdvN6zCfKzU",
              "agenda": [
                {
                  "member_id": "caInCe2UEo2vJ5ez9FAN",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "JWxFeej6ueFFnyzpqQEk",
                  "id": "9Zpd9j8fkFDvpSKfvwIr",
                  "topic_id": "8d8jWOJ46MdvN6zCfKzU",
                  "member_name": "Diogo Assis Souza ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "xddttI4ZwqOtQ7uhUjjF",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "JWxFeej6ueFFnyzpqQEk",
                  "id": "qoKYRBxW6rSkS32muwAL",
                  "topic_id": "8d8jWOJ46MdvN6zCfKzU",
                  "member_name": "Gleison Carlos Arantes Filho",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "name": "TLL04 -  Reabilitação cardíaca após procedimentos de intervenção: uma revisão sistemática",
              "startTime": "11:45",
              "id": "yyYOxMuo72yAsfg1fDfW",
              "agenda": [
                {
                  "member_id": "wxV46124AmHJk1py3kre",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "JWxFeej6ueFFnyzpqQEk",
                  "id": "3bsrPLaPM7wiISG8MMn2",
                  "topic_id": "yyYOxMuo72yAsfg1fDfW",
                  "member_name": "Gabriela Ferreira Nunes",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "oNlbl9hoqO4Ywxa9vCaG",
                  "role_name": "Comentador(a)",
                  "level": "t",
                  "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                  "activity_id": "JWxFeej6ueFFnyzpqQEk",
                  "id": "6aRmYK6gynL0L0t5IcKN",
                  "topic_id": "yyYOxMuo72yAsfg1fDfW",
                  "member_name": "Maikon Lucian Madeira Quarti",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "dmBJ4PuwRRIZOc6Cnjd1",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "id": "BLtM75o7Fc19ORAkn8Fn",
              "member_name": "Marco Antonio de Sousa do Vale ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "psfgBJto2mJevPxg6QEJ",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "id": "TEUOmW0zbYyS2URj9AgO",
              "member_name": "Antonio de Jesus Chaves Junior",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "0HKGwQwroXpkyJLzp9Sh",
              "role_name": "Avaliador",
              "level": "a",
              "role_id": "OYeQjttFfvxFjQH8yQd5",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "id": "U93vuJoz6H7PlP3s65AK",
              "member_name": "Laio Caju Wanderley",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "LHp66lMTiqQ3ZbPXi51K",
              "role_name": "Avaliador",
              "level": "a",
              "role_id": "OYeQjttFfvxFjQH8yQd5",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "id": "YolHUhD5pipOxdEPf6z6",
              "member_name": "Gabriel Rodrigues Bittencourt ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "NsfYLwC5wmSrRbSVh17F",
              "role_name": "Avaliador",
              "level": "a",
              "role_id": "OYeQjttFfvxFjQH8yQd5",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "id": "hy13aUEEI0k3ptWhhzyG",
              "member_name": "Antonio Carlos de Almeida Barbosa Filho",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "caInCe2UEo2vJ5ez9FAN",
              "role_name": "Avaliador",
              "level": "a",
              "role_id": "OYeQjttFfvxFjQH8yQd5",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "id": "lENHA2RzXRXC9GYQEcEO",
              "member_name": "Diogo Assis Souza ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "2eC5tG3Rf3IgH8ZRNRA0",
              "role_name": "Avaliador",
              "level": "a",
              "role_id": "OYeQjttFfvxFjQH8yQd5",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "id": "lg8wD8fxEUwHINUDPBS0",
              "member_name": "Fabrício Lara Carvalho",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "oNlbl9hoqO4Ywxa9vCaG",
              "role_name": "Avaliador",
              "level": "a",
              "role_id": "OYeQjttFfvxFjQH8yQd5",
              "activity_id": "JWxFeej6ueFFnyzpqQEk",
              "id": "x02Ty5rE9xu02F68S8Qh",
              "member_name": "Maikon Lucian Madeira Quarti",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662136986",
          "depto_id": "OLg0OAKHpv8TocDsXPsm",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "SESSÃO DE TEMAS LIVRES",
          "depto": "13º CONGRESSO ACADÊMICO DE CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 4",
          "startTime": "11:00",
          "id": "JWxFeej6ueFFnyzpqQEk"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "UUyKpwgFeEI6Eu811qqc",
              "name": "Judicialização da saúde será a solução?",
              "startTime": "11:00",
              "id": "0gNlqFq33uYf5vLYf6VC",
              "agenda": [
                {
                  "member_id": "hPRPEqyYykW4EpzoBnfV",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "UUyKpwgFeEI6Eu811qqc",
                  "id": "1W7K6VRW1OF9CI2jhEz9",
                  "topic_id": "0gNlqFq33uYf5vLYf6VC",
                  "member_name": "João Pedro Gebran Neto",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "VbemlUiQZS2XiFQdu4NW",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "UUyKpwgFeEI6Eu811qqc",
              "id": "ldmBN3ckz0Ava9NQSuWf",
              "member_name": "Fernando Antonio Lucchese ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "pHopGlaMmGboS9s4ZJPk",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "UUyKpwgFeEI6Eu811qqc",
              "id": "usUhsqGu3LmYJ64MbtsY",
              "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662124777",
          "depto_id": "VTbA7orqer53sB1oBc29",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "JUDICIALIZAÇÃO NA SAÚDE",
          "location": "Auditório 2",
          "startTime": "11:00",
          "id": "UUyKpwgFeEI6Eu811qqc"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Z17Ke3f6HxHxrL5civef",
              "name": "Hospitais filantrópicos, sua relevância e suas dificuldades",
              "startTime": "11:20",
              "id": "syqm2PEpeXlXmXpsjHJT",
              "agenda": [
                {
                  "member_id": "VbemlUiQZS2XiFQdu4NW",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "Z17Ke3f6HxHxrL5civef",
                  "id": "tuvtUv76Ticr64wZKns7",
                  "topic_id": "syqm2PEpeXlXmXpsjHJT",
                  "member_name": "Fernando Antonio Lucchese ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Z17Ke3f6HxHxrL5civef",
              "name": "Cirurgia cardiovascular e as políticas públicas no Brasil: o que é e o que pode ser?",
              "startTime": "11:35",
              "id": "6ZoVeYN89cG8Fbw2Av76",
              "agenda": [
                {
                  "member_id": "487mQwdaZGJfbJ8NbJ9n",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "Z17Ke3f6HxHxrL5civef",
                  "id": "3Fr2HcOX3M6LyKEwyZ2y",
                  "topic_id": "6ZoVeYN89cG8Fbw2Av76",
                  "member_name": "João Carlos Ferreira Leal ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Z17Ke3f6HxHxrL5civef",
              "name": "Novas tecnologias e como aprová-las no rol de procedimentos. Visão do CFM",
              "startTime": "11:50",
              "id": "Nm9Zvmky1vmzyzIk8w3D",
              "agenda": [
                {
                  "member_id": "IOgE1kvheHZM5JYiB9Ps",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "Z17Ke3f6HxHxrL5civef",
                  "id": "JHORKQYeq2xC4SA8Ia3c",
                  "topic_id": "Nm9Zvmky1vmzyzIk8w3D",
                  "member_name": "Donizetti Dimer Giamberardino Filho",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Z17Ke3f6HxHxrL5civef",
              "name": "Como realizar cirurgia cardiovascular sem judicializar?",
              "startTime": "12:05",
              "id": "fwztZZ6KHr2UHqMDpais",
              "agenda": [
                {
                  "member_id": "1sRBX2OvshSSNxP35bWs",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "Z17Ke3f6HxHxrL5civef",
                  "id": "YxHAlWEnu5IPjOlv7Zmf",
                  "topic_id": "fwztZZ6KHr2UHqMDpais",
                  "member_name": "Sérgio Lima de Almeida ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Z17Ke3f6HxHxrL5civef",
              "name": "A importância do médico como parceiro nos processos médicos judicializados",
              "startTime": "12:20",
              "id": "zXRQixseTok7bnPgZ8Bh",
              "agenda": [
                {
                  "member_id": "hPRPEqyYykW4EpzoBnfV",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "Z17Ke3f6HxHxrL5civef",
                  "id": "CixtjWFRyIondQ12TaPG",
                  "topic_id": "zXRQixseTok7bnPgZ8Bh",
                  "member_name": "João Pedro Gebran Neto",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Z17Ke3f6HxHxrL5civef",
              "name": "Discussão",
              "startTime": "12:35",
              "id": "8lQ2jf5gaqnNPCaWl5lu",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "VBZgvFDBMbMvqvUcyrQ6",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "Z17Ke3f6HxHxrL5civef",
              "id": "5cAA0OoaCUwD9DCwLLDO",
              "member_name": "Vinicius José da Silva Nina",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "pHopGlaMmGboS9s4ZJPk",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "Z17Ke3f6HxHxrL5civef",
              "id": "8JikcEXqbXz5jTad96sw",
              "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662124777",
          "depto_id": "VTbA7orqer53sB1oBc29",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA VIII",
          "depto": "JUDICIALIZAÇÃO NA SAÚDE",
          "location": "Auditório 2",
          "startTime": "11:20",
          "id": "Z17Ke3f6HxHxrL5civef"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "cmMrOUMbWtzksaKYx6xv",
              "name": "Indicações atuais do acesso transapical e acessos alternativos para TAVI",
              "startTime": "11:20",
              "id": "TtTJnmwSZofLTtU1YcZm",
              "agenda": [
                {
                  "member_id": "RtfC4tOZcC7lEmtA7qy4",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "cmMrOUMbWtzksaKYx6xv",
                  "id": "g05Kho0DhAOBYVUMlOSC",
                  "topic_id": "TtTJnmwSZofLTtU1YcZm",
                  "member_name": "Diego Felipe Gaia dos Santos ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "cmMrOUMbWtzksaKYx6xv",
              "name": "FOP: indicações do tratamento transcateter",
              "startTime": "11:35",
              "id": "YDN5v7IvFA0MQKIm4qDR",
              "agenda": [
                {
                  "member_id": "aNlwkmlC0g7HCk8XgXAS",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "cmMrOUMbWtzksaKYx6xv",
                  "id": "nQNoeToeJEybiud7wFd3",
                  "topic_id": "YDN5v7IvFA0MQKIm4qDR",
                  "member_name": "Alexandre Magno Macario Nunes Soares ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "cmMrOUMbWtzksaKYx6xv",
              "name": "Tratamento transcateter da valva mitral - resultados e perspectivas",
              "startTime": "11:50",
              "id": "LHKRRBx6O5qCcYwBLXTf",
              "agenda": [
                {
                  "member_id": "vklFqYm25ki5o1mzphiQ",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "cmMrOUMbWtzksaKYx6xv",
                  "id": "mGVQRebqyAyu5hCCof2e",
                  "topic_id": "LHKRRBx6O5qCcYwBLXTf",
                  "member_name": "Eduardo Keller Saadi ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "cmMrOUMbWtzksaKYx6xv",
              "name": "TAVI concomitante com doença coronária: antes, durante ou depois?",
              "startTime": "12:05",
              "id": "Fa868TD9RzYDLzPukvEX",
              "agenda": [
                {
                  "member_id": "mhJB0SuYtcugC3F5N1MT",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "cmMrOUMbWtzksaKYx6xv",
                  "id": "E2q44hSwCKJL52rK2W1t",
                  "topic_id": "Fa868TD9RzYDLzPukvEX",
                  "member_name": "Paulo Roberto Lunardi Prates ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "cmMrOUMbWtzksaKYx6xv",
              "name": "Mitraclip: indicações e controvérsias dos principais trials",
              "startTime": "12:20",
              "id": "A0VUQvqWw3q84fVu86AR",
              "agenda": [
                {
                  "member_id": "oKssp1F2GX2hSPdTSk19",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "cmMrOUMbWtzksaKYx6xv",
                  "id": "uPKs10sDGcMytwYvGVZD",
                  "topic_id": "A0VUQvqWw3q84fVu86AR",
                  "member_name": "Flávio Tarasoutchi",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "cmMrOUMbWtzksaKYx6xv",
              "name": "Discussão",
              "startTime": "12:35",
              "id": "XqFY2CVRP4c84hxd2trP",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "31vhJSp1Mbrc88Ld13or",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "cmMrOUMbWtzksaKYx6xv",
              "id": "H9FIf19cibOrwPyQkHMn",
              "member_name": "Ricardo José Choma ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "uAjTiB1jsq3FlwfLCnrH",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "cmMrOUMbWtzksaKYx6xv",
              "id": "bicNG9pgklxF0fNaal90",
              "member_name": "Christiano da Silveira de Barcellos ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662092049",
          "depto_id": "yzJuE4VuCn9Mprf4cSqN",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA VI",
          "depto": "DEFEITOS ESTRUTURAIS",
          "location": "Auditório Principal",
          "startTime": "11:20",
          "id": "cmMrOUMbWtzksaKYx6xv"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "45",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "hU0E1KYHqdo093MRbkCC",
              "name": "Mulheres na cirurgia cardiovascular: passado, presente e futuro",
              "startTime": "12:00",
              "id": "bC4l332iSjo6Y3tjBmsY",
              "agenda": [
                {
                  "member_id": "HiKwZGC9JxBw28x7X1ub",
                  "role_name": "Debatedor(a)",
                  "level": "t",
                  "role_id": "akXbIW6V3Q1UHZQzE0BF",
                  "activity_id": "hU0E1KYHqdo093MRbkCC",
                  "id": "62DM9kqZEamdTNL3gswg",
                  "topic_id": "bC4l332iSjo6Y3tjBmsY",
                  "member_name": "Beatriz Helena S. Furlanetto ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "8vWrWlQ4IZxCMIoSQAF5",
                  "role_name": "Debatedor(a)",
                  "level": "t",
                  "role_id": "akXbIW6V3Q1UHZQzE0BF",
                  "activity_id": "hU0E1KYHqdo093MRbkCC",
                  "id": "FT1KdSKhYzJLanbrurkm",
                  "topic_id": "bC4l332iSjo6Y3tjBmsY",
                  "member_name": "Magaly Arrais dos Santos",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "Z8uiF2pLISUKj38hBtiT",
                  "role_name": "Debatedor(a)",
                  "level": "t",
                  "role_id": "akXbIW6V3Q1UHZQzE0BF",
                  "activity_id": "hU0E1KYHqdo093MRbkCC",
                  "id": "k0jngWCVQXBrCWrFglP8",
                  "topic_id": "bC4l332iSjo6Y3tjBmsY",
                  "member_name": "Valquíria Pelisser Campagnucci ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "ErQ9Pd1VpuabuXHgLpfn",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "hU0E1KYHqdo093MRbkCC",
              "id": "aXqpPjljrtDWLaCcrFSM",
              "member_name": "Patrícia Cristina Celestino",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "MylcOYoQFfJTDotsLSCv",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "hU0E1KYHqdo093MRbkCC",
              "id": "l1oENBkQOUyq7FP26ehd",
              "member_name": "Amanda Arrais Bento de Souza",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662136986",
          "depto_id": "OLg0OAKHpv8TocDsXPsm",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "DEBATE",
          "depto": "13º CONGRESSO ACADÊMICO DE CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 4",
          "startTime": "12:00",
          "id": "hU0E1KYHqdo093MRbkCC"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "75",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "WPk0kJ1MYvqzJAM5KZSy",
              "name": "ENCERRAMENTO, PREMIAÇÃO DOS TEMAS LIVRES DA SBCCV, LIGA ACADÊMICA E DEMAIS HOMENAGENS",
              "startTime": "12:45",
              "id": "O5gbTXlYKeGLYDuClXwH",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662092049",
          "depto_id": "0opU2hMyvevrpIXDzjeD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "CERIMÔNIA DE ENCERRAMENTO DO CONGRESSO",
          "depto": "SBCCV",
          "location": "Auditório Principal",
          "startTime": "12:45",
          "id": "WPk0kJ1MYvqzJAM5KZSy"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "0mN8Kmgo1GlP8ctDQ1IR",
              "name": "Passado da SBCCV e a evolução para o presente",
              "startTime": "14:00",
              "id": "3udJ3Q5LAaHsXIt65vw2",
              "agenda": [
                {
                  "member_id": "pHopGlaMmGboS9s4ZJPk",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "0mN8Kmgo1GlP8ctDQ1IR",
                  "id": "OJReoSq48MtstljlkPnZ",
                  "topic_id": "3udJ3Q5LAaHsXIt65vw2",
                  "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "0mN8Kmgo1GlP8ctDQ1IR",
              "name": "Dicas para o futuro cirurgião cardiovascular",
              "startTime": "14:30",
              "id": "bzlctbNnWEBsnvOH17ZW",
              "agenda": [
                {
                  "member_id": "ifgnNJhEmY84MFU1gQjF",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "0mN8Kmgo1GlP8ctDQ1IR",
                  "id": "mEjv350O4jtNarkuPRbY",
                  "topic_id": "bzlctbNnWEBsnvOH17ZW",
                  "member_name": "José Wanderley Neto ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "psfgBJto2mJevPxg6QEJ",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "0mN8Kmgo1GlP8ctDQ1IR",
              "id": "S1V5iG6I76sgwuslgtHp",
              "member_name": "Antonio de Jesus Chaves Junior",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "ubeKErl515Mt9yaGHqi3",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "0mN8Kmgo1GlP8ctDQ1IR",
              "id": "tpuuvxbw54NujBJHl5y1",
              "member_name": "Moisés Barbosa de Andrade ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662136986",
          "depto_id": "OLg0OAKHpv8TocDsXPsm",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA  I - A HISTÓRIA DOS 50 ANOS DO CONGRESSO DA SOCIEDADE BRASILEIRA DE CIRURGIA CARDIOVASCULAR",
          "depto": "13º CONGRESSO ACADÊMICO DE CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 4",
          "startTime": "14:00",
          "id": "0mN8Kmgo1GlP8ctDQ1IR"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "name": "Abertura",
              "startTime": "14:00",
              "id": "FfXkBLlQOpf3y4XbRkHL",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "name": "Planejamento do implante através da angiotomografia",
              "startTime": "14:05",
              "id": "N7UAOp0hM4c597enHiUP",
              "agenda": [
                {
                  "member_id": "2RAcpVOvEjrF816lyq6K",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2cuVU8W5aCJAD2AM4fRv",
                  "id": "JQHU1jsEUhOnXlXAAdPJ",
                  "topic_id": "N7UAOp0hM4c597enHiUP",
                  "member_name": "Andrea Dumsch de Aragon Ferreira ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "name": "Anatomia da raiz da aorta",
              "startTime": "14:20",
              "id": "wU1bm5z0E3khpS426Wuq",
              "agenda": [
                {
                  "member_id": "487mQwdaZGJfbJ8NbJ9n",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2cuVU8W5aCJAD2AM4fRv",
                  "id": "QOeKeCQHuGyidyCwcxDW",
                  "topic_id": "wU1bm5z0E3khpS426Wuq",
                  "member_name": "João Carlos Ferreira Leal ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "name": "Indicações atuais e revisão dos principais ensaios clínicos",
              "startTime": "14:35",
              "id": "aDC1f6f0TJ30wlCNVcFJ",
              "agenda": [
                {
                  "member_id": "YSTjpav26KV1ydeC6v9p",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2cuVU8W5aCJAD2AM4fRv",
                  "id": "GdhXu1gSgRj32uurvlWL",
                  "topic_id": "aDC1f6f0TJ30wlCNVcFJ",
                  "member_name": "Gustavo Ieno Judas ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "name": "Anatomia do aparato valvar aórtico e sua relação com TAVI",
              "startTime": "14:50",
              "id": "cuqOoi7qTZxaBScJfNZd",
              "agenda": [
                {
                  "member_id": "5yrGDXcl3mMyHZSJbuow",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2cuVU8W5aCJAD2AM4fRv",
                  "id": "y3OEsc2HRxbouDrbFp8l",
                  "topic_id": "cuqOoi7qTZxaBScJfNZd",
                  "member_name": "José Honório de Almeida Palma Fonseca",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "name": "Passo a passo do implante",
              "startTime": "15:05",
              "id": "fmi7phGWREkYPjM2lSF1",
              "agenda": [
                {
                  "member_id": "vklFqYm25ki5o1mzphiQ",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2cuVU8W5aCJAD2AM4fRv",
                  "id": "fwUwnNdOL6OiUWmtG0bl",
                  "topic_id": "fmi7phGWREkYPjM2lSF1",
                  "member_name": "Eduardo Keller Saadi ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "name": "TAVI em valvas bicúspides",
              "startTime": "15:20",
              "id": "rjzwkF9Q1XDV1Fs3cctO",
              "agenda": [
                {
                  "member_id": "mhJB0SuYtcugC3F5N1MT",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2cuVU8W5aCJAD2AM4fRv",
                  "id": "fjghTNF6yYPl9GOm1hZe",
                  "topic_id": "rjzwkF9Q1XDV1Fs3cctO",
                  "member_name": "Paulo Roberto Lunardi Prates ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "name": "Principais complicações e como tratar",
              "startTime": "15:35",
              "id": "IZaIicZCYEaXTt6PM0Hg",
              "agenda": [
                {
                  "member_id": "8vWrWlQ4IZxCMIoSQAF5",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2cuVU8W5aCJAD2AM4fRv",
                  "id": "KbiSLMlOVmr3fHXRbQvj",
                  "topic_id": "IZaIicZCYEaXTt6PM0Hg",
                  "member_name": "Magaly Arrais dos Santos",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "name": "Acessos alternativos",
              "startTime": "15:50",
              "id": "zg1ldc9RNRuzs78EHFAA",
              "agenda": [
                {
                  "member_id": "RtfC4tOZcC7lEmtA7qy4",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "2cuVU8W5aCJAD2AM4fRv",
                  "id": "t5RPORv7bAEAqwI8vnPs",
                  "topic_id": "zg1ldc9RNRuzs78EHFAA",
                  "member_name": "Diego Felipe Gaia dos Santos ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "name": "Discussão",
              "startTime": "16:05",
              "id": "fI1ySj5l68PEbzjEZJHZ",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "75",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "name": "Treinamento em Simuladores",
              "startTime": "16:45",
              "id": "Fb6oZsqTqkgIGIxFNba2",
              "agenda": [
                {
                  "member_id": "YSTjpav26KV1ydeC6v9p",
                  "role_name": "Coordenador(a)",
                  "level": "t",
                  "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                  "activity_id": "2cuVU8W5aCJAD2AM4fRv",
                  "id": "CMkNDbn8IUwwawUZEHD4",
                  "topic_id": "Fb6oZsqTqkgIGIxFNba2",
                  "member_name": "Gustavo Ieno Judas ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                },
                {
                  "member_id": "vklFqYm25ki5o1mzphiQ",
                  "role_name": "Coordenador(a)",
                  "level": "t",
                  "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                  "activity_id": "2cuVU8W5aCJAD2AM4fRv",
                  "id": "ycmwfpOs9Csrf4Z2usAP",
                  "topic_id": "Fb6oZsqTqkgIGIxFNba2",
                  "member_name": "Eduardo Keller Saadi ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "vklFqYm25ki5o1mzphiQ",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "id": "7Hx6T73WkG5KuxjFsxqk",
              "member_name": "Eduardo Keller Saadi ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "YSTjpav26KV1ydeC6v9p",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "2cuVU8W5aCJAD2AM4fRv",
              "id": "xZdGWITPFhKD4Ryrjbi0",
              "member_name": "Gustavo Ieno Judas ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662124777",
          "depto_id": "SP6o4MrkyrAgxdjm4TRf",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "CURSO DE TAVI",
          "depto": "CURSO DE TAVI",
          "location": "Auditório 2",
          "startTime": "14:00",
          "id": "2cuVU8W5aCJAD2AM4fRv"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "696TCA7QoeCSRB66sCr3",
              "name": "Choque pós cardiotomia",
              "startTime": "14:00",
              "id": "B3t2quY8RA1Mf0zGdk00",
              "agenda": [
                {
                  "member_id": "M1OfuhGffCIJkrYYt9pl",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "696TCA7QoeCSRB66sCr3",
                  "id": "akl8ki9nt9QZasvfCUaZ",
                  "topic_id": "B3t2quY8RA1Mf0zGdk00",
                  "member_name": "Filomena Galas",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "Y90o4YcoL3yo2DzNQf0g",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "696TCA7QoeCSRB66sCr3",
              "id": "o4KYZ0TGb1Qt3vH0wbCG",
              "member_name": "Josalmir José Melo do Amaral ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662142789",
          "depto_id": "bFWmir6aazVI0ewnHovj",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "OS PIORES CENÁRIOS EM CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 5",
          "startTime": "14:00",
          "id": "696TCA7QoeCSRB66sCr3"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "bqGGwRXSIikNY25CD0A8",
              "name": "Estratégias para reoperações em cardiopatias congênitas",
              "startTime": "14:00",
              "id": "XsF58TDlv6YnQsqSv9z0",
              "agenda": [
                {
                  "member_id": "pWpnxr0dJGFYWgjb5jE9",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "bqGGwRXSIikNY25CD0A8",
                  "id": "H5aCZK39kuLbfCfxXHtD",
                  "topic_id": "XsF58TDlv6YnQsqSv9z0",
                  "member_name": "Décio Cavalet Soares Abuchaim ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "bqGGwRXSIikNY25CD0A8",
              "name": "Defeito do septo atrioventricular total",
              "startTime": "14:10",
              "id": "dEbVyoYIzBLlSqWUFglJ",
              "agenda": [
                {
                  "member_id": "Y9UL5zc8uOu7hUxm1O41",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "bqGGwRXSIikNY25CD0A8",
                  "id": "0yPaADDxgb3qNu2jYKeE",
                  "topic_id": "dEbVyoYIzBLlSqWUFglJ",
                  "member_name": "Denoel Marcelino Oliveira ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "bqGGwRXSIikNY25CD0A8",
              "name": "Operação do Cone",
              "startTime": "14:20",
              "id": "BPi5JCj5SwWDFrzbwDfO",
              "agenda": [
                {
                  "member_id": "tTSG956F1D7kvRqE2par",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "bqGGwRXSIikNY25CD0A8",
                  "id": "oqt3x7mS2rVQpyO7EFaL",
                  "topic_id": "BPi5JCj5SwWDFrzbwDfO",
                  "member_name": "Rodrigo Freire Bezerra",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "bqGGwRXSIikNY25CD0A8",
              "name": "Correção de ALCAPA com uso de enxerto de apêndice atrial esquerdo",
              "startTime": "14:30",
              "id": "IHKNza6R7IoUECO9r9as",
              "agenda": [
                {
                  "member_id": "VBZgvFDBMbMvqvUcyrQ6",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "bqGGwRXSIikNY25CD0A8",
                  "id": "zBozMdSP6yvrROztBItR",
                  "topic_id": "IHKNza6R7IoUECO9r9as",
                  "member_name": "Vinicius José da Silva Nina",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "bqGGwRXSIikNY25CD0A8",
              "name": "Operação de PEARS",
              "startTime": "14:40",
              "id": "SE34zGORBKM1vf0DM0Ld",
              "agenda": [
                {
                  "member_id": "ZebI3mSmhsWZHYTKRcsw",
                  "role_name": " Apresentador(a) ",
                  "level": "t",
                  "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                  "activity_id": "bqGGwRXSIikNY25CD0A8",
                  "id": "VZiNqnSlyGiV51XZ84Yq",
                  "topic_id": "SE34zGORBKM1vf0DM0Ld",
                  "member_name": "Renato Abdala Karam Kalil ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "bqGGwRXSIikNY25CD0A8",
              "name": "Discussão",
              "startTime": "14:50",
              "id": "LVdxzN9WK65rh1jkWV8U",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "N7kAbrv1COv51XT2Vsd8",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "bqGGwRXSIikNY25CD0A8",
              "id": "NVzv3fiCVvV4lfwcyZG3",
              "member_name": "Cybelle Soares Matos Cascudo ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "VbemlUiQZS2XiFQdu4NW",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "bqGGwRXSIikNY25CD0A8",
              "id": "wsOKdFBUoqwwy1qvl047",
              "member_name": "Fernando Antonio Lucchese ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "SESSÃO DE VÍDEOS CIRÚRGICOS",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "14:00",
          "id": "bqGGwRXSIikNY25CD0A8"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "s6udTsCwD8bmYJzcHH9Z",
              "name": "Transplantes no Brasil hoje e os desafios para o futuro",
              "startTime": "14:00",
              "id": "X3Dpq7Gs455ZzntNzWeZ",
              "agenda": [
                {
                  "member_id": "wzc9bboIiUmKkT9AXf57",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "s6udTsCwD8bmYJzcHH9Z",
                  "id": "HF35Amdsg73kRi9NIWI6",
                  "topic_id": "X3Dpq7Gs455ZzntNzWeZ",
                  "member_name": "Luciana Bertocco de Paiva Haddad",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "v931elE9XIZJxcOGdNS4",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "s6udTsCwD8bmYJzcHH9Z",
              "id": "6EcgNeqsBh2IbsgjxIu2",
              "member_name": "Juan Alberto Cosquillo Mejia ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662092049",
          "depto_id": "g7Sxz9Hmi7kgiqeCQZv6",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MINICONFERÊNCIA",
          "depto": "ASSISTÊNCIA CIRCULATÓRIA VENTRICULAR E TRANSPLANTE CARDÍACO",
          "location": "Auditório Principal",
          "startTime": "14:00",
          "id": "s6udTsCwD8bmYJzcHH9Z"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "X4UnH7cqF7GxB76RbELc",
              "name": "O papel do ECMO na redução de desfechos de mortalidade em pacientes com choque circulatório refratário: discussão dos desenhos e resultados dos últimos ensaios clínicos",
              "startTime": "14:20",
              "id": "zsYymsrdkDlHQW04SsCu",
              "agenda": [
                {
                  "member_id": "RzhhxnIjXUFxXnBViKDk",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "X4UnH7cqF7GxB76RbELc",
                  "id": "OFOwuQ4s1iG64bQioBt1",
                  "topic_id": "zsYymsrdkDlHQW04SsCu",
                  "member_name": "Fernando Antibas Atik ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "X4UnH7cqF7GxB76RbELc",
              "name": "CCM: A modulação da contração cardíaca por estímulo elétrico e o impacto na qualidade de vida",
              "startTime": "14:40",
              "id": "776lFhATtLlml9XHYykT",
              "agenda": [
                {
                  "member_id": "OF20ckfZhp8Gf8qvKS7u",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "X4UnH7cqF7GxB76RbELc",
                  "id": "2sMgaH4disUkwkKFExY6",
                  "topic_id": "776lFhATtLlml9XHYykT",
                  "member_name": "Veridiana Silva de Andrade",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "X4UnH7cqF7GxB76RbELc",
              "name": "Alternativas aos não respondedores da terapia de ressincronização cardíaca na insuficiência cardíaca com fração de ejeção reduzida: a estimulação direta do feixe de Hiss está pronta para o uso?",
              "startTime": "15:00",
              "id": "V2jYWdA35dcGsVEohWkN",
              "agenda": [
                {
                  "member_id": "WVt1qCq8yrtvGokCuDGa",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "X4UnH7cqF7GxB76RbELc",
                  "id": "lS68hlNGa62HhbdRhAHq",
                  "topic_id": "V2jYWdA35dcGsVEohWkN",
                  "member_name": "Achilles Abelaira Filho ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "X4UnH7cqF7GxB76RbELc",
              "name": "Dispositivos de assistência ventricular de longa permanência: indicações e como avançar em países como o Brasil",
              "startTime": "15:20",
              "id": "o3sAnbCFCIibCTkdzI8F",
              "agenda": [
                {
                  "member_id": "3YKHsRROT0UV32P4W7Wm",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "X4UnH7cqF7GxB76RbELc",
                  "id": "DOUeitXwv0jWbA2bYybV",
                  "topic_id": "o3sAnbCFCIibCTkdzI8F",
                  "member_name": "Paulo Manuel Pêgo-Fernandes ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "X4UnH7cqF7GxB76RbELc",
              "name": "Discussão",
              "startTime": "15:40",
              "id": "379yh171YK6J4ECs5HJE",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "n9Z6BDJ50t5jBtPyY8Bb",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "X4UnH7cqF7GxB76RbELc",
              "id": "1ZeXXn5xFtlR7i8PVVI3",
              "member_name": "Rubens Tofano de Barros ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "urqa8kheZfSyrtQUcRh6",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "X4UnH7cqF7GxB76RbELc",
              "id": "WGMiqWGCwRvbHNNXHrhj",
              "member_name": "Luiz Cláudio Moreira Lima ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662092049",
          "depto_id": "g7Sxz9Hmi7kgiqeCQZv6",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA VII",
          "depto": "ASSISTÊNCIA CIRCULATÓRIA VENTRICULAR E TRANSPLANTE CARDÍACO",
          "location": "Auditório Principal",
          "startTime": "14:20",
          "id": "X4UnH7cqF7GxB76RbELc"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
              "name": "Prótese mitral com folheto imóvel",
              "startTime": "14:20",
              "id": "wW6YSRlb48joKaWDHXbo",
              "agenda": [
                {
                  "member_id": "YcEGvs1EHY5MaUR0DcWL",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
                  "id": "T4CXJdmIzHeydfxWqFPJ",
                  "topic_id": "wW6YSRlb48joKaWDHXbo",
                  "member_name": "Rodrigo Coelho Segalote ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
              "name": "Pseudoaneurisma pós-Bental ",
              "startTime": "14:35",
              "id": "ZrlQHRgbQvMkqvtQkp2v",
              "agenda": [
                {
                  "member_id": "Sc8INEzLO3HQm3PdgCvH",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
                  "id": "GlS7P43iE2fNKvtNdTlY",
                  "topic_id": "ZrlQHRgbQvMkqvtQkp2v",
                  "member_name": "José Augusto Duncan Santiago ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
              "name": "Vazamento periprotético pós TEVAR",
              "startTime": "14:50",
              "id": "aEcEjQDzUO1Ynspb1E9E",
              "agenda": [
                {
                  "member_id": "fw6hFmYYPOCIXsxdSLRm",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
                  "id": "LzY49r7H76DL35WwFM24",
                  "topic_id": "aEcEjQDzUO1Ynspb1E9E",
                  "member_name": "Gustavo Calado de Aguiar Ribeiro ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
              "name": "TAVI complicada com dissecção aguda da aorta",
              "startTime": "15:05",
              "id": "axMX1zlo2Jpm1DZU9UdP",
              "agenda": [
                {
                  "member_id": "8vWrWlQ4IZxCMIoSQAF5",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
                  "id": "9vejyrBT76ekLbqgsFLs",
                  "topic_id": "axMX1zlo2Jpm1DZU9UdP",
                  "member_name": "Magaly Arrais dos Santos",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
              "name": "Disjunção do sulco atrioventricular",
              "startTime": "15:20",
              "id": "8hdMYl5MYbaZAwDwQXlW",
              "agenda": [
                {
                  "member_id": "QZjFuLMJXZlRdcYRyw2I",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
                  "id": "xlQ9C0sz2qAI4Gcvkhbl",
                  "topic_id": "8hdMYl5MYbaZAwDwQXlW",
                  "member_name": "Gustavo Klug Pimentel ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
              "name": "Sangramento maciço após cirurgia da raiz da aorta",
              "startTime": "15:35",
              "id": "02jjdptf7L7GByae2tAr",
              "agenda": [
                {
                  "member_id": "3PGBHb0C3UO8TXp9gDM2",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
                  "id": "pAkm42YtJdJ03Vq975T8",
                  "topic_id": "02jjdptf7L7GByae2tAr",
                  "member_name": "Jocerlano Santos de Sousa ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
              "name": "Discussão",
              "startTime": "15:50",
              "id": "uwd1mi3wxfuBMWyWLlxQ",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "UFJ3Ac1G2vumQDKpdZpH",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
              "id": "NizvMfWEOjaMPouSue76",
              "member_name": "Mário Ricardo Amar ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "l4rDJlQU0bo35wLxJrv0",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "mtEGV5Lxpm2iVfwH0JX3",
              "id": "Rgt7uE0wEuXtqtghero1",
              "member_name": "Arnaldo Akio Okino ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662142789",
          "depto_id": "bFWmir6aazVI0ewnHovj",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA X",
          "depto": "OS PIORES CENÁRIOS EM CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 5",
          "startTime": "14:20",
          "id": "mtEGV5Lxpm2iVfwH0JX3"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "30",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "HTMfdC1GAR94whYVHB8h",
              "name": "O que é sabido e o que é novo em ventrículos borderline / Borderline ventricles. What is known and what is new?",
              "startTime": "15:00",
              "id": "cbeKWPakIullOrzovhyD",
              "agenda": [
                {
                  "member_id": "iN28qdxipRgK7fX0G4Fh",
                  "role_name": "Conferencista",
                  "level": "t",
                  "role_id": "uYOH6vwplH1OSKByONkf",
                  "activity_id": "HTMfdC1GAR94whYVHB8h",
                  "id": "I4csenlwRIC2op2TTj6V",
                  "topic_id": "cbeKWPakIullOrzovhyD",
                  "member_name": "Glen Van Arsdell",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "bPK40aNYW7olk4LePR1r",
              "role_name": "Presidente",
              "level": "a",
              "role_id": "n3EoDSuxQZNObutTSI6s",
              "activity_id": "HTMfdC1GAR94whYVHB8h",
              "id": "dniBvaco0qbfx14fpPUZ",
              "member_name": "Marcelo Biscegli Jatene ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "CONFERÊNCIA",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "15:00",
          "id": "HTMfdC1GAR94whYVHB8h"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Lp7G5S9DoFee1U27TM6p",
              "name": "O que é necessário para uma publicação científica",
              "startTime": "15:00",
              "id": "q1EVBSazhzk2ti3h1JgB",
              "agenda": [
                {
                  "member_id": "zUJF3rGEzCCujnzfeA9P",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "Lp7G5S9DoFee1U27TM6p",
                  "id": "TynHvpUNO7kLdA97dQF9",
                  "topic_id": "q1EVBSazhzk2ti3h1JgB",
                  "member_name": "Walter José Gomes ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Lp7G5S9DoFee1U27TM6p",
              "name": "Desafios do jovem pesquisador",
              "startTime": "15:20",
              "id": "dI67i3zTtF3iOmsCJoxL",
              "agenda": [
                {
                  "member_id": "keFvoyoOACgEM8bxAcmx",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "Lp7G5S9DoFee1U27TM6p",
                  "id": "i9PCd1MxF0aZCRxOV5aH",
                  "topic_id": "dI67i3zTtF3iOmsCJoxL",
                  "member_name": "Henrique Madureira da Rocha Coutinho ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "20",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "Lp7G5S9DoFee1U27TM6p",
              "name": "Como começar e como encontrar um orientador",
              "startTime": "15:40",
              "id": "tHmLbOHHAeFFeoYm36uG",
              "agenda": [
                {
                  "member_id": "caInCe2UEo2vJ5ez9FAN",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "Lp7G5S9DoFee1U27TM6p",
                  "id": "Q79MBeC3UDJzcS7Co8Ef",
                  "topic_id": "tHmLbOHHAeFFeoYm36uG",
                  "member_name": "Diogo Assis Souza ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "ErQ9Pd1VpuabuXHgLpfn",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "Lp7G5S9DoFee1U27TM6p",
              "id": "pnsRWadkqhhmBoWJNHx7",
              "member_name": "Patrícia Cristina Celestino",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "dmBJ4PuwRRIZOc6Cnjd1",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "Lp7G5S9DoFee1U27TM6p",
              "id": "zkXiRNTHNr25XVg7aPvS",
              "member_name": "Marco Antonio de Sousa do Vale ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662136986",
          "depto_id": "OLg0OAKHpv8TocDsXPsm",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA  II - CAMINHOS PARA A PESQUISA CIENTÍFICA",
          "depto": "13º CONGRESSO ACADÊMICO DE CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 4",
          "startTime": "15:00",
          "id": "Lp7G5S9DoFee1U27TM6p"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oefM1Br3ZeJ0WxxdvSXw",
              "name": "Como a experiência do paciente impacta na atenção à saúde",
              "startTime": "15:30",
              "id": "7vtbbuxHbs8ALAzX7iiH",
              "agenda": [
                {
                  "member_id": "ItkusNynvXCA1puFB0rV",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "oefM1Br3ZeJ0WxxdvSXw",
                  "id": "iLUeC1pUAELuwiGWVN65",
                  "topic_id": "7vtbbuxHbs8ALAzX7iiH",
                  "member_name": "Marcelo Alvarenga",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oefM1Br3ZeJ0WxxdvSXw",
              "name": "Como os pais e pacientes cardiopatas congênitos avaliam sua experiência no pré-operatório, na internação cirúrgica e no pós alta",
              "startTime": "15:40",
              "id": "pCP28c4pfKLFcqaAhbz8",
              "agenda": [
                {
                  "member_id": "SLvHHLo7cP0WxBtdV5az",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "oefM1Br3ZeJ0WxxdvSXw",
                  "id": "kDRhrykDKE2Ue76zECLd",
                  "topic_id": "pCP28c4pfKLFcqaAhbz8",
                  "member_name": "Janaína Souto Rocha",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "10",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "oefM1Br3ZeJ0WxxdvSXw",
              "name": "Discussão",
              "startTime": "15:50",
              "id": "99dDq2qRFcoFvUoAzdFZ",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "LapyFJ6x4PKGq7qMfbdg",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "oefM1Br3ZeJ0WxxdvSXw",
              "id": "WFXzcwgUNgiduCVoUUmi",
              "member_name": "Leonardo Augusto Miana",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "ItkusNynvXCA1puFB0rV",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "oefM1Br3ZeJ0WxxdvSXw",
              "id": "f4vDvdvvhhWL1chSw2Xg",
              "member_name": "Marcelo Alvarenga",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MESA REDONDA - A VOZ DO PACIENTE",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "15:30",
          "id": "oefM1Br3ZeJ0WxxdvSXw"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [],
          "agenda": [],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709663252454",
          "depto_id": "0opU2hMyvevrpIXDzjeD",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "INTERVALO E VISITA AOS EXPOSITORES",
          "depto": "SBCCV",
          "location": "Área de Exposição",
          "startTime": "16:00",
          "id": "NaHO7PPzcyp7Y9w7BMU6"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "4LcuM0kgowZY4JnlM75i",
              "name": "MICS CABG com enxertos arteriais",
              "startTime": "16:15",
              "id": "6yUN4SbqEsIDssJzJoRn",
              "agenda": [
                {
                  "member_id": "IFFBOlR2QfHhXOk6FbdY",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "4LcuM0kgowZY4JnlM75i",
                  "id": "jhjsnUajqTn9ZeNgXAgR",
                  "topic_id": "6yUN4SbqEsIDssJzJoRn",
                  "member_name": "Waldo Emerson Pinheiro Daniel",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "4LcuM0kgowZY4JnlM75i",
              "name": "Troca valvar mitral em anel calcificado com técnica periareolar",
              "startTime": "16:30",
              "id": "QRTJxPFydh4sDvLAKu00",
              "agenda": [
                {
                  "member_id": "swv5sDij38nzPP0LGPX0",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "4LcuM0kgowZY4JnlM75i",
                  "id": "Qig6WhHYfP6weanvCrKP",
                  "topic_id": "QRTJxPFydh4sDvLAKu00",
                  "member_name": "Paola Keese Montanhesi ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "4LcuM0kgowZY4JnlM75i",
              "name": "Acesso transcarotídeo para TAVI",
              "startTime": "16:45",
              "id": "0M3tnRE4A9B70Y0dGE6z",
              "agenda": [
                {
                  "member_id": "BQ1OXriXdZWCo3YpsGHb",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "4LcuM0kgowZY4JnlM75i",
                  "id": "QbUa3OqJnpOwUrIQ75C6",
                  "topic_id": "0M3tnRE4A9B70Y0dGE6z",
                  "member_name": "Paulo César Santos ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "4LcuM0kgowZY4JnlM75i",
              "name": "Tips and Tricks em mitraclip",
              "startTime": "17:00",
              "id": "1z8pXTS3e3pyeLN05kGY",
              "agenda": [
                {
                  "member_id": "04h2scYEUKTReNq7iogR",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "4LcuM0kgowZY4JnlM75i",
                  "id": "PFBSYzs6A6mzImWgPdVA",
                  "topic_id": "1z8pXTS3e3pyeLN05kGY",
                  "member_name": "João Marcelo Ancilon Cavalcante Albuquerque ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "4LcuM0kgowZY4JnlM75i",
              "name": "Troca valvar mitral e aórtica por minitoracotomia",
              "startTime": "17:15",
              "id": "dE9M5i7aF3aomq0DoQZj",
              "agenda": [
                {
                  "member_id": "0C730CSckDjjq8PIEFPk",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "4LcuM0kgowZY4JnlM75i",
                  "id": "WnsEUlXQ05xWJ5mMCUQb",
                  "topic_id": "dE9M5i7aF3aomq0DoQZj",
                  "member_name": "Alisson Parrilha Toschi ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "EtAfmnqDcepyhD8K2cGP",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "4LcuM0kgowZY4JnlM75i",
              "id": "AWi9crUb2GonuPnTDBom",
              "member_name": "Elinthon Tavares Veronese ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "5YxlBHAfgpiuHI67JHKZ",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "4LcuM0kgowZY4JnlM75i",
              "id": "k7EwDNDlwMMHLMvFubow",
              "member_name": "George Ronald Soncini da Rosa ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662092049",
          "depto_id": "d41jSqncZoXyi7XvGpAq",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "MICS",
          "depto": "SESSÃO COMO EU FAÇO",
          "location": "Auditório Principal",
          "startTime": "16:15",
          "id": "4LcuM0kgowZY4JnlM75i"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "aoqyCfqKrNDxn37PnuY8",
              "name": "O uso de modelos experimentais no aprendizado de anatomia cardíaca e cirurgia cardiovascular",
              "startTime": "16:15",
              "id": "rQSGsDcsbc1oalOebZ51",
              "agenda": [
                {
                  "member_id": "05sQ6y14sKvQGnSvkvLA",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "aoqyCfqKrNDxn37PnuY8",
                  "id": "mZDA395GVNeu7kwqDzfi",
                  "topic_id": "rQSGsDcsbc1oalOebZ51",
                  "member_name": "Gabriel Rezende Neves",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "aoqyCfqKrNDxn37PnuY8",
              "name": "A importância dos estágios práticos na curva de aprendizagem acadêmica em cenário de cirurgia cardiovascular",
              "startTime": "16:20",
              "id": "Fyy7DKJiLlDZomLnWyvO",
              "agenda": [
                {
                  "member_id": "770FBuk4BjAgZVPR0465",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "aoqyCfqKrNDxn37PnuY8",
                  "id": "6JHKarpCnjIcmihqRPoz",
                  "topic_id": "Fyy7DKJiLlDZomLnWyvO",
                  "member_name": "Letícia Siman Lopes ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "5",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "aoqyCfqKrNDxn37PnuY8",
              "name": "Discussão",
              "startTime": "16:25",
              "id": "5OxLnSOXqyHMtfvjKYzE",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "ubeKErl515Mt9yaGHqi3",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "aoqyCfqKrNDxn37PnuY8",
              "id": "16TuP8QC6PAgj2t7SsbI",
              "member_name": "Moisés Barbosa de Andrade ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "MylcOYoQFfJTDotsLSCv",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "aoqyCfqKrNDxn37PnuY8",
              "id": "4qatyfF75tmmlaMaS7JM",
              "member_name": "Amanda Arrais Bento de Souza",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662136986",
          "depto_id": "OLg0OAKHpv8TocDsXPsm",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "FÓRUM DAS LIGAS - DBLACCV PELO BRASIL",
          "depto": "13º CONGRESSO ACADÊMICO DE CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 4",
          "startTime": "16:15",
          "id": "aoqyCfqKrNDxn37PnuY8"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "D8qOojLlG6RORSCv0Tcf",
              "name": "Transplante cardíaco pediátrico no Brasil. Realidade atual",
              "startTime": "16:30",
              "id": "fpZyrNUQ1wJdAZKrjRBW",
              "agenda": [
                {
                  "member_id": "bPK40aNYW7olk4LePR1r",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "D8qOojLlG6RORSCv0Tcf",
                  "id": "CQsXWQuqu0rLhw24vRdo",
                  "topic_id": "fpZyrNUQ1wJdAZKrjRBW",
                  "member_name": "Marcelo Biscegli Jatene ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "D8qOojLlG6RORSCv0Tcf",
              "name": "Opções e estratégias de suporte circulatório em pacientes pediátricos",
              "startTime": "16:45",
              "id": "3gEzKySq57TlFyKXuDIR",
              "agenda": [
                {
                  "member_id": "RzhhxnIjXUFxXnBViKDk",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "D8qOojLlG6RORSCv0Tcf",
                  "id": "tXiOHinWfyaJjR6z2JRd",
                  "topic_id": "3gEzKySq57TlFyKXuDIR",
                  "member_name": "Fernando Antibas Atik ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "D8qOojLlG6RORSCv0Tcf",
              "name": "ECMO - Qual a realidade brasileira como ponte para TX e pós cardiotomia?",
              "startTime": "17:00",
              "id": "ANY5pzJtYFgFkRWe0Ccv",
              "agenda": [
                {
                  "member_id": "Grp7ZpLL5sbcfYJM0t21",
                  "role_name": "Palestrante",
                  "level": "t",
                  "role_id": "BcYHERVzWLzxVYs443Xn",
                  "activity_id": "D8qOojLlG6RORSCv0Tcf",
                  "id": "fAb9QG0I1J8HNpr9VLWD",
                  "topic_id": "ANY5pzJtYFgFkRWe0Ccv",
                  "member_name": "Luiz Fernando Caneo ",
                  "day_id": "qe9JZRx1JUE7cjWsfWz7"
                }
              ],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "D8qOojLlG6RORSCv0Tcf",
              "name": "Discussão",
              "startTime": "17:15",
              "id": "EqfsnFARxkMLSwyyp7zB",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "V64V1Hjhqx4criX08D9u",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "D8qOojLlG6RORSCv0Tcf",
              "id": "MuGYVUwGIxiyz0n7ycYV",
              "member_name": "Guilherme Viotto Rodrigues da Silva",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "RKXTtRQhYcbVzqn6S09K",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "D8qOojLlG6RORSCv0Tcf",
              "id": "nCKwCQD2vlRrVMJfJAlQ",
              "member_name": "Marcelo Frederigue de Castro ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662130844",
          "depto_id": "O8ZV7WXNuFyM5XybxTef",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "ASSISTÊNCIA CIRCULATÓRIA E TRANSPLANTE CARDÍACO EM PEDIATRIA",
          "depto": "DCCVPED",
          "location": "Auditório 3",
          "startTime": "16:30",
          "id": "D8qOojLlG6RORSCv0Tcf"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [],
          "agenda": [
            {
              "member_id": "psfgBJto2mJevPxg6QEJ",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "oJHziXGk2AYXEz7y8gli",
              "id": "0QwqRGTVmKbKxYGgp2fy",
              "member_name": "Antonio de Jesus Chaves Junior",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "ErQ9Pd1VpuabuXHgLpfn",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "oJHziXGk2AYXEz7y8gli",
              "id": "62TGzEnE0cSy8K3liHDg",
              "member_name": "Patrícia Cristina Celestino",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "MylcOYoQFfJTDotsLSCv",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "oJHziXGk2AYXEz7y8gli",
              "id": "BY9atwAUbvgdiuUbi8pO",
              "member_name": "Amanda Arrais Bento de Souza",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "dmBJ4PuwRRIZOc6Cnjd1",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "oJHziXGk2AYXEz7y8gli",
              "id": "kXYXqeOQfwwSanvxWp9Z",
              "member_name": "Marco Antonio de Sousa do Vale ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "ubeKErl515Mt9yaGHqi3",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "oJHziXGk2AYXEz7y8gli",
              "id": "v4aoAFdanMIIYlw4fxtv",
              "member_name": "Moisés Barbosa de Andrade ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662136986",
          "depto_id": "OLg0OAKHpv8TocDsXPsm",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "DESAFIO DAS LIGAS",
          "depto": "13º CONGRESSO ACADÊMICO DE CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 4",
          "startTime": "16:30",
          "id": "oJHziXGk2AYXEz7y8gli"
        },
        {
          "date": {"_seconds": 1718420400, "_nanoseconds": 0},
          "sponsor": null,
          "date_dd_mm": "15/06",
          "topics": [
            {
              "duration": "15",
              "event_id": "qZzZKG5PbyJeStdMmOT2",
              "activity_id": "VlXeWIJcGRSqTdC9doLR",
              "name": "Votação da Diretoria 2024/2025 e Encerramento",
              "startTime": "17:00",
              "id": "LU598MuoJY96qegEuenM",
              "agenda": [],
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "agenda": [
            {
              "member_id": "dmBJ4PuwRRIZOc6Cnjd1",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "VlXeWIJcGRSqTdC9doLR",
              "id": "QxofnbmRGPVnWmY0stqW",
              "member_name": "Marco Antonio de Sousa do Vale ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "ErQ9Pd1VpuabuXHgLpfn",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "VlXeWIJcGRSqTdC9doLR",
              "id": "R7etNZSMQnysHYJGP1kb",
              "member_name": "Patrícia Cristina Celestino",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "ubeKErl515Mt9yaGHqi3",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "VlXeWIJcGRSqTdC9doLR",
              "id": "atgqZaCEULQ1LEzg4Exd",
              "member_name": "Moisés Barbosa de Andrade ",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "psfgBJto2mJevPxg6QEJ",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "VlXeWIJcGRSqTdC9doLR",
              "id": "rS8DTsZblPQsPVQA6lwa",
              "member_name": "Antonio de Jesus Chaves Junior",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            },
            {
              "member_id": "MylcOYoQFfJTDotsLSCv",
              "role_name": "Coordenador(a)",
              "level": "a",
              "role_id": "1N7XxEx7sGOa4lVBLZQ5",
              "activity_id": "VlXeWIJcGRSqTdC9doLR",
              "id": "ygTsNSayxAzG6fRuIR6c",
              "member_name": "Amanda Arrais Bento de Souza",
              "day_id": "qe9JZRx1JUE7cjWsfWz7"
            }
          ],
          "day_id": "qe9JZRx1JUE7cjWsfWz7",
          "location_id": "1709662136986",
          "depto_id": "OLg0OAKHpv8TocDsXPsm",
          "event_id": "qZzZKG5PbyJeStdMmOT2",
          "name": "ENCERRAMENTO",
          "depto": "13º CONGRESSO ACADÊMICO DE CIRURGIA CARDIOVASCULAR",
          "location": "Auditório 4",
          "startTime": "17:00",
          "id": "VlXeWIJcGRSqTdC9doLR"
        }
      ]
    }
  }

  _getCongressScheduleData (event_id, location_id): Observable<any> {

    let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/getCongressSchedule';

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const body: any = {'eventId': event_id, 'locationId': location_id}

    return this._httpClient.post<any>(url, body, httpOptions)
      .pipe(
        retry(2),
        catchError((error) => {
          console.log(error.status)
          return throwError(error.status);
        })
      )
  }


}

